/* eslint-disable no-restricted-globals */
/*eslint no-extend-native: ["error", { "exceptions": ["Array"] }]*/
import React from "react";
import ip from "ip";
// import "../../style.css";
import Amplify, { Auth } from "aws-amplify";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter, Link } from "react-router-dom";
import * as _ from "lodash";
import isEmpty from "lodash/isEmpty";
import { MenuItem, Select } from "@material-ui/core";
import moment from "moment";
import parse, { attributesToProps } from "html-react-parser";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import SideMenu from "../sideMenu/sideMenu";
import loader from "../../images/Spin-1s-107px.gif";
import ReactQuill from 'react-quill';
import QuestionComponent from "./QuestionComponent";
import {
  Icon,
 Input as input
} from "@material-ui/core";
import Tooltip from "@material-ui/core/Tooltip";
import QuestionManufactureComponent from "./QuestionManufactureComponent";
import {
  getSettlementById,
  uploadEligibilityQuestionFileByUser,
  deleteEligibilityQuestionFileByUser,
  saveSettlementAnswers,
  saveEnrollmenttDoc,
  saveEnrollmentAuthorization,
  getPendingRequiredDocUser,
  moveToNextQuestionList,
  getEligibilityQuestionById,
  getAutoPartDefendentPartsByPartId,
  saveUsersUneligibleSettlements,
  getAllVehicleDataByUserIdAPI,
  getAllVehicleDataSettlementByUserIdAPI,
  saveMultipleVehicleDataByUserIdAPI,
  clearData,
  saveToNextQuestionList,
  clearSavedata,
  getPendingSettlementQuestions,
  saveSettlementWithoutData,
  uploadfile,
} from "../../Actions/actions";
import * as SecretKeys from "../../ENV.json";
import exclamation from "../../images/exclamation-xxl.png";
import thumbs from "../../images/thumbs.png";
import AddVehicleInEligibility from "../common/addVehicleInEligibility";

import VinComponet from "../common/vin";

import { DatePickerInput } from "rc-datepicker";
import "rc-datepicker/lib/style.css";

const listLabel = [
  "Rental Car and Transportation",
  "Towin charges to a BMW Dealer",
  "Childcare expenses incurred",
  "Costs to repair front airbags",
  "Lot wages",
  "Storage fees",
];

Amplify.configure(SecretKeys.awsUserpool);
class ApplyContainerQuestion extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      optionalNotesTextState : "",
      Urlparams: [],
      totalNumberOfQuestions: 0,
      currentQuestionNumber: 0,
      buttonText: "Next",
      ShowUploadScreen: false,
      QuestionList: [],
      currentQuestionBody: [],
      recentAnswer: [],
      postObject: {},
      PopErrorNotAllowedToMove: false,
      PopErrorNotAllowedToMoveE: false,
      showLastQusetion: false,
      success: false,
      enrollmentId: 0,
      pendingSettlementDOcUser: {},
      loaded: false,
      modalIsOpen: false,
      errorsTermPolicy: {},
      allowFileCliam: 0,
      acceptTermCondition: 0,
      multipleFileState:[],
      recordedState : false,
      repeatState : {},
      nexState :false,
      nexxState:false,
      dupeState : "",
      addState:[],
      radioDupeState:[],
      yesState:[],
      dropdState:[],
      vehiclerecentAnswer:[],
      dupeInterCheck : false,
      // signatureImage: loaderImg,
      documentList: [
        {
          documentFile: "",
        },
      ],
      vehicleOptions: [],
      error: "",
      UserName: "",
      uploadCount: 0,
      RequireDocCount: 0,
      UploadError: false,
      settlementName: "",
      categoryImage: "",
      settlementUserId: localStorage.getItem("userId"),
      nextQuestionDataApi1: [],
      nextQuestionSaveDataApi1: [],
      backQuestionSaveDataApi1: [],
      answerIdLatestQ: "",
      answerTextLatestQ: "",
      stateId: 1,
      stateSubmitData: true,
      arrayBackWord: [],
      recentAnswerState : "",
      counterQuesr: 1,
      forwardStatus: 1,
      skipUploadDoc1: 1,
      pendingSettlementDOc1: [],
      resentData: 1,
      multipleInputOptionsData: [],
      questionNumber: 1,
      renderState: 1,
      reviewQuestion: "N",
      browser: navigator.appCodeName,
      appVersion: navigator.appVersion,
      ipAddress: ip.address(),
      firstQuestion: "",
      manufactureData: [],
      vehicleDetailsDtoListData: [],
      reimbursementDetailsDtoListDta: [],
      recentDataSelect: "",
      recentDataStateChildM: "",
      autoPartDefendentParts: [],
      childIndexDataId: "",
      intervalId: 0,
      vehicleDataNewResponse: [],
      saveDataAnswer: "N",
      interCheck: false,
      fileNameState : "",
      disclaimerAgreeState : "Yes",
      // isLoader: false,
    };
    this.inputSelctorOptionsNotes = this.inputSelctorOptionsNotes.bind(this);
    this.ProceedWithQuestionNext = this.ProceedWithQuestionNext.bind(this);
    this.ProceedWithQuestionBack = this.ProceedWithQuestionBack.bind(this);
    this.ProceedWithQuestionFirst = this.ProceedWithQuestionFirst.bind(this);
    this.MultiselectOptions = this.MultiselectOptions.bind(this);
    this.radioSelectOption = this.radioSelectOption.bind(this);
    this.radioSelectOptionOne =this.radioSelectOptionOne.bind(this);
    this.inputSelctorOptions = this.inputSelctorOptions.bind(this);
    this.inputSelctorOptionsNumber = this.inputSelctorOptionsNumber.bind(this);
    this._onSelect = this._onSelect.bind(this);
    this.multipleInputOptions = this.multipleInputOptions.bind(this);
    this.multipleInputOptionsDate = this.multipleInputOptionsDate.bind(this);
    this.completeSteps = this.completeSteps.bind(this);
    this.openModal = this.openModal.bind(this);
    this.afterOpenModal = this.afterOpenModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.onChange = this.onChange.bind(this);
    this.vehicleOptionsMultiSelection = this.vehicleOptionsMultiSelection.bind(
      this
    );
    this.saveEmptyData = this.saveEmptyData.bind(this);
    this.myRef = React.createRef();
  }

  saveEmptyData() {
    const eid = this.state.Urlparams;
    const data = {
      userId: this.state.settlementUserId,
      id: eid,
    };
    this.props.saveSettlementWithoutData(data);
    this.setState({
      success: true,
      showLastQusetion: false,
    });
  }

  scrollStep = () => {
    if (window.pageYOffset === 0) {
      clearInterval(this.state.intervalId);
    }
    window.scroll(0, window.pageYOffset - this.props.scrollStepInPx);
  };

  onChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  componentDidMount() {
    const {
      match: { params },
    } = this.props;
    const postObject = {};
    postObject.id = params.eid;
    this.props.getSettlementById({ id: params.eid });
    this.setState({ loaded: true });

    const data = {
      userId: this.state.settlementUserId,
      settlementId: params.eid,
    };
    this.props.getAllVehicleDataByUserIdAPI(data);
    this.props.getAllVehicleDataSettlementByUserIdAPI(data);
    this.setState({
      Urlparams: params.eid,
      postObject,
    });
    const dataaSettel = {
      id: this.props.match.params.eid,
      settlementId: this.props.match.params.eid,
      userId: this.state.settlementUserId,
    };
    if (
      this.props.match.params.review !== "" &&
      this.props.match.params.review !== undefined
    ) {
      this.setState({
        reviewQuestion: "Y",
      });
    }
    this.props.moveToNextQuestionList(dataaSettel);
  }

  componentWillMount() {
    if (
      localStorage.getItem("paymentStatus") === "pending" &&
      !!localStorage.getItem("paymentFailedButLetUserIn") === false
    ) {
      this.context.router.history.push("/add-payment-method");
    }
    const intervalId = setInterval(
      this.scrollStep.bind(this),
      this.props.delayInMs
    );
    this.setState({
      intervalId,
    });
    this.forceUpdate();
  }

  componentWillUnmount() {
    this.props.clearData();
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (
      nextState.enrollmentId !== "" &&
      nextState.enrollmentId !== this.state.enrollmentId
    ) {
      // const enrollmentId = nextState.enrollmentId;
      // this.getTheUploadDoc(enrollmentId);
      return true;
    }
    if (nextProps !== this.props) {
      return true;
    }
    if (
      nextProps.pendingSettlementDOcUser !==
        this.state.pendingSettlementDOcUser &&
      Object.keys(this.state.pendingSettlementDOcUser).length === 0 &&
      nextProps.totalNumberOfQuestions !== this.state.totalNumberOfQuestions &&
      nextState.totalNumberOfQuestions === 0
    ) {
      // empty
    }
    return true;
  }

  componentWillReceiveProps(nextProps, nextState) {
    let quesArr = [];
    let quesArrSorted = [];
    let pendingSettlementDOcUser = {};
    // const vehicleOptions = [];
    let settlementName = "";
    let categoryImage = "";
    const settlementQuestionList = nextProps.data.settlementQuestionList
      ? nextProps.data.settlementQuestionList
      : {};

    settlementName =
      settlementQuestionList.shortName !== undefined
        ? settlementQuestionList.shortName
        : "";
    categoryImage =
      settlementQuestionList.categoryImage !== undefined
        ? settlementQuestionList.categoryImage
        : "";
    if (
      settlementQuestionList &&
      settlementQuestionList.eligibilityQuestionDtoList &&
      settlementQuestionList.eligibilityQuestionDtoList !== undefined &&
      Object.keys(settlementQuestionList.eligibilityQuestionDtoList).length > 0
    ) {
      quesArr = settlementQuestionList.eligibilityQuestionDtoList;
      quesArrSorted = _.orderBy(quesArr, ["questionOrder"], ["asc"]);
      // this.createQuestion('bbb', settlementQuestionList);
      // this.setState({ loaded: true });
    }
    if (
      settlementQuestionList.eligibilityQuestionDtoList &&
      nextProps.data.settlementQuestionList.eligibilityQuestionDtoList !==
        undefined
    ) {
      if (
        nextProps.data.settlementQuestionList !==
          this.props.data.settlementQuestionList &&
        Object.keys(settlementQuestionList.eligibilityQuestionDtoList)
          .length === 0
      ) {
        // this.setState({ loaded: true });
        // this.getPendingDocs();
      }
    }
    if (
      this.state.currentQuestionNumber !== nextState.currentQuestionNumber &&
      this.state.totalNumberOfQuestions > 0 &&
      nextState.currentQuestionNumber < nextState.totalNumberOfQuestions
    ) {
      this.setState({ ShowUploadScreen: false });
    }
    const pendingSettlementDOcList = nextProps.data.pendingSettlementDOcUser
      ? nextProps.data.pendingSettlementDOcUser
      : {};
    if (Object.keys(pendingSettlementDOcList).length > 0) {
      pendingSettlementDOcUser = pendingSettlementDOcList;
    }

    const ReciveSettlmentanswersResponse = nextProps.data
      .ReciveSettlmentanswersResponse
      ? nextProps.data.ReciveSettlmentanswersResponse
      : {};
    if (Object.keys(ReciveSettlmentanswersResponse).length > 0) {
      this.setState({
        enrollmentId:
          ReciveSettlmentanswersResponse.enrollmentId !== undefined
            ? ReciveSettlmentanswersResponse.enrollmentId
            : "",
        // loaded: true,
      });
    }

    const UploadENrolmentDocResponse = nextProps.data.UploadENrolmentDocResponse
      ? nextProps.data.UploadENrolmentDocResponse
      : {};
    if (
      UploadENrolmentDocResponse[0] !== undefined &&
      Object.keys(UploadENrolmentDocResponse[0]).length > 0
    ) {
      this.setState({
        signatureImage: UploadENrolmentDocResponse[0].documentFilePath,
        enrollmentId: UploadENrolmentDocResponse[0].enrollmentId,
      });
    }

    const vehicleData = nextProps.data.vehicleData
      ? nextProps.data.vehicleData
      : {};
    if (vehicleData !== undefined && Object.keys(vehicleData).length > 0) {
      // vehicleOptions = vehicleData.records;
      setTimeout(() => {
        // this.setState({ loaded: false });
      }, 2000);
    }
    if (quesArrSorted.length === 0) {
      // this.setState({ loaded: true });
    }
    const currentQuestionNumber = this.state;
    const UploadDocValue = 0;
    this.setState({
      totalNumberOfQuestions: quesArrSorted.length,
      currentQuestionNumber:
        quesArrSorted.length === 0 ? 0 : currentQuestionNumber,
      QuestionList: quesArrSorted,
      pendingSettlementDOcUser,
      RequireDocCount: UploadDocValue,
      // vehicleOptions,
      settlementName,
      categoryImage,
    });
  }

  ProceedWithQuestionFirst(e) {
    e.preventDefault();
    const {
      match: { params },
    } = this.props;
    const { arrayBackWord, settlementUserId } = this.state;
    const { nextQuestionDataApi } = this.props.data;
    let multipleIputTypeQuestionLsit = [];
console.log("mourn",nextQuestionDataApi)
    if (
      nextQuestionDataApi.questionTypeId === 7 ||
      nextQuestionDataApi.questionTypeId === 13 ||
      nextQuestionDataApi.questionTypeId === 15
    ) {
      multipleIputTypeQuestionLsit = this.multiQuestioFunction(
        nextQuestionDataApi,
        nextQuestionDataApi.questionTypeId
      );
    }

    if (arrayBackWord.length > 0) {
      const data = {
        userId: settlementUserId,
        eligibilityQuestionId: arrayBackWord[0],
      };
      this.props.getEligibilityQuestionById(data);
      this.setState({
        forwardStatus: 2,
        counterQuesr: 1,
        PopErrorNotAllowedToMove: true,
        PopErrorNotAllowedToMoveE: false,
        showLastQusetion: false,
        success: false,
        multipleIputTypeQuestion: multipleIputTypeQuestionLsit,
      });
    } else {
      this.props.getSettlementById({ id: params.eid });

      this.setState({
        forwardStatus: 3,
        counterQuesr: 1,
        PopErrorNotAllowedToMove: true,
        PopErrorNotAllowedToMoveE: false,
        showLastQusetion: false,
        success: false,
        nextQuestionDataApi1: nextQuestionDataApi,
        multipleIputTypeQuestion: multipleIputTypeQuestionLsit,
      });
    }
  }

  filterArray = (testArray) => {
    let index = -1;
    const arrLength = testArray ? testArray.length : 0;
    let resIndex = -1;
    const result = [];
    while (++index < arrLength) {
      const value = testArray[index];
      if (value) {
        result[++resIndex] = value;
      }
    }
    return result;
  };

  ProceedWithQuestionBack() {
    const { arrayBackWord, settlementUserId, counterQuesr } = this.state;
    let arrayBack = [];
    const lengthArray = arrayBackWord.length;
    const data = {
      userId: settlementUserId,
      eligibilityQuestionId: arrayBackWord[lengthArray - 1],
    };
    this.props.getEligibilityQuestionById(data);

    arrayBack = this.state.arrayBackWord;
    const isIn = arrayBackWord.indexOf(arrayBackWord[lengthArray - 1]);
    arrayBackWord.splice(isIn, 1);
    this.setState({
      stateSubmitData: true,
      error: "",
      arrayBackWord: arrayBack,
      forwardStatus: 2,
      counterQuesr: counterQuesr - 1,
      nexxState:true,
      multipleFileState:[]
    });
  }

  async ProceedWithQuestionNext() {
    const {
      recentAnswer,
      vehicleDetailsDtoListData,
      settlementUserId,
      skipUploadDoc1,
      nextQuestionDataApi1,
      counterQuesr,
      currentQuestionNumber,
      totalNumberOfQuestions,
      multipleIputTypeQuestion,
      saveDataAnswer,
      optionalNotesTextState,
      recentAnswerState,
      fileNameState,
      multipleFileState,
      disclaimerAgreeState
    } = this.state;

    console.log("mournn",nextQuestionDataApi1)
    const { clearSavedata } = this.props;
    const ansArray = [];
    const vehicleDataMultiple = [];
    const vehicleDataMultipleSave = [];
    let arrayBack = [];
    const emptyFlagArray = [];
    arrayBack = this.state.arrayBackWord;
    this.setState({ renderState: 2});
    const LocalAnswerObj = {};

    const moveToNextFlag = [];
    const isQualify = [];
    const isMatch = [];
    const Type = nextQuestionDataApi1.questionTypeId;
    const questionId = nextQuestionDataApi1.eligibilityQuestionId;
    const answerOptions = nextQuestionDataApi1.eligibilityAnswerDto;
    const soldFlagData = nextQuestionDataApi1.soldFlag;
    const errorFlag = [];
    const errorFagList = [];
    const errorFagListMulti = [];
    const errorFagQtyList = [];
    const errorFagQtyListDup = [];

    console.log("sssssssssssssss", Type)
    // this.setState({
    //  })
    // code for multiselect and type 2
    if (Type === 1 || Type === 5) {
      LocalAnswerObj.eligibilityQuestionId = questionId;
      // for (let i = 0; i < recentAnswer.length; i++) {
      answerOptions.map((item) => {
        if (item.isDisabled !== 1) {
          // if (item.answerId === recentAnswer[i]) {
          if (recentAnswer.findIndex((data) => data === item.answerId) !== -1) {
            if (item.moveToNextQuestion === 0) {
              moveToNextFlag.push({
                moveToNextQuestion: false,
                answerID: item.answerId,
              });
            }

            if (item.isQualify === 0) {
              isQualify.push({ isQualify: false, answerID: item.answerId });
            }
            ansArray.push({
              eligibilityQuestionId: questionId,
              userId: settlementUserId,
              value: item.answerText,
              eligibilityAnswerId: item.answerId,
              optionalNotesData: optionalNotesTextState,
              // optionalNotesData : this.state.optionalNotesTextState === "" && nextQuestionDataApi1.optionalNotesData !== null  ? nextQuestionDataApi1.optionalNotesData : this.state.optionalNotesTextState
            });
          }
        }
        emptyFlagArray.push({
          eligibilityQuestionId: questionId,
          userId: settlementUserId,
          value: "",
          eligibilityAnswerId: item.answerId,
          optionalNotesData: optionalNotesTextState,
          // optionalNotesData : this.state.optionalNotesTextState === "" && nextQuestionDataApi1.optionalNotesData !== null  ? nextQuestionDataApi1.optionalNotesData : this.state.optionalNotesTextState
        });
        return true;
      });
      // }
      this.setState({ recentAnswer: [], multipleInputOptionsData: [] ,optionalNotesTextState : "",fileNameState:"",multipleFileState:[]});
    }
    if (Type === 2 || Type === 4) {
      LocalAnswerObj.eligibilityQuestionId = questionId;
      answerOptions.map((item) => {
        if (item.isDisabled !== 1) {
          if (item.answerId === recentAnswer[0]) {
            if (item.moveToNextQuestion === 0) {
              moveToNextFlag.push({
                moveToNextQuestion: false,
                answerID: item.answerId,
              });
            }
            if (item.isQualify === 0) {
              isQualify.push({ isQualify: false, answerID: item.answerId });
            }
            ansArray.push({
              eligibilityQuestionId: questionId,
              userId: settlementUserId,
              value: item.answerText,
              eligibilityAnswerId: item.answerId,
              // optionalNotesData : this.state.optionalNotesTextState
              optionalNotesData: optionalNotesTextState,
              // optionalNotesData : this.state.optionalNotesTextState === "" && nextQuestionDataApi1.optionalNotesData !== null  ? nextQuestionDataApi1.optionalNotesData : this.state.optionalNotesTextState
            });
          }
        }
        emptyFlagArray.push({
          eligibilityQuestionId: questionId,
          userId: settlementUserId,
          value: "",
          eligibilityAnswerId: item.answerId,
          optionalNotesData: optionalNotesTextState,
          // optionalNotesData : this.state.optionalNotesTextState
          // optionalNotesData : this.state.optionalNotesTextState === "" && nextQuestionDataApi1.optionalNotesData !== null  ? nextQuestionDataApi1.optionalNotesData : this.state.optionalNotesTextState
        });
        return true;
      });
      this.setState({ recentAnswer: [], multipleInputOptionsData: [],optionalNotesTextState : "",fileNameState:"" ,multipleFileState:[]});
    }
    // code for Inputbox
    // if (Type === 3) {
    //   console.log("st",optionalNotesTextState ,recentAnswerState,nextQuestionDataApi1)
    //   LocalAnswerObj.eligibilityQuestionId = questionId;
    //   answerOptions.map((item) => {
    //     if (item.isDisabled !== 1) {
    //       if(item.answerId===recentAnswer){
    //       if (item.moveToNextQuestion === 0) {
    //         moveToNextFlag.push({
    //           moveToNextQuestion: false,
    //           answerID: item.answerId,
    //         });
    //       }
    //       if (item.isQualify === 0) {
    //         isQualify.push({ isQualify: false, answerID: item.answerId });
    //       }
    //       console.log("recentAnswer", recentAnswer)
    //       if (typeof recentAnswer === "string") {
    //         ansArray.push({
    //           eligibilityQuestionId: questionId,
    //           userId: settlementUserId,
    //           //value: recentAnswer,
    //           value : this.state.recentAnswerState,
    //           eligibilityAnswerId: item.answerId,
    //           // optionalNotesData : this.state.optionalNotesTextState
    //           optionalNotesData : this.state.optionalNotesTextState === "" && nextQuestionDataApi1.optionalNotesData !== null  ? nextQuestionDataApi1.optionalNotesData : this.state.optionalNotesTextState
    //         });
    //         console.log("aArray",ansArray)
    //       } else if (recentAnswer[0] !== undefined) {
    //         ansArray.push({
    //           eligibilityQuestionId: questionId,
    //           userId: settlementUserId,
    //          // value: recentAnswer[0],
    //          value : this.state.recentAnswerState,
    //           eligibilityAnswerId: item.answerId,
    //           // optionalNotesData : this.state.optionalNotesTextState
    //           optionalNotesData : this.state.optionalNotesTextState === "" && nextQuestionDataApi1.optionalNotesData !== null  ? nextQuestionDataApi1.optionalNotesData : this.state.optionalNotesTextState
    //         });
    //         console.log("aArraya",ansArray)
    //       }
         
    //       // ansArray.push({"eligibilityQuestionId":questionId,"userId":userid,"value":recentAnswer,"eligibilityAnswerId":item.answerId});
    //         }
    //     }
    //     emptyFlagArray.push({
    //       eligibilityQuestionId: questionId,
    //       userId: settlementUserId,
    //       //value: "",
    //       value: this.state.recentAnswerState,
    //       eligibilityAnswerId: item.answerId,
    //       // optionalNotesData : this.state.optionalNotesTextState
    //       optionalNotesData : this.state.optionalNotesTextState === "" && nextQuestionDataApi1.optionalNotesData !== null  ? nextQuestionDataApi1.optionalNotesData : this.state.optionalNotesTextState
    //     });
    //     return true;
    //   });
    //   this.setState({ recentAnswer: [], multipleInputOptionsData: [] ,optionalNotesTextState : "",fileNameState:"",multipleFileState:[] });
    // }
    if (Type === 3) {
      LocalAnswerObj.eligibilityQuestionId = questionId;
      answerOptions.map((item) => {
        if (item.isDisabled !== 1) {
          // if(item.answerId===recentAnswer){
          if (item.moveToNextQuestion === 0) {
            moveToNextFlag.push({
              moveToNextQuestion: false,
              answerID: item.answerId,
            });
          }
          if (item.isQualify === 0) {
            isQualify.push({ isQualify: false, answerID: item.answerId });
          }
          console.log("recentAnswer", recentAnswer)
          if (typeof recentAnswer === "string") {
            if(recentAnswer !== "") {
              ansArray.push({
                eligibilityQuestionId: questionId,
                userId: settlementUserId,
                value: recentAnswer,
                eligibilityAnswerId: item.answerId,
                optionalNotesData: optionalNotesTextState,
                // optionalNotesData : this.state.optionalNotesTextState === "" && nextQuestionDataApi1.optionalNotesData !== null  ? nextQuestionDataApi1.optionalNotesData : this.state.optionalNotesTextState
              });
            }
          } else if (recentAnswer[0] !== undefined) {
            if(recentAnswer[0] !== "") {
              ansArray.push({
                eligibilityQuestionId: questionId,
                userId: settlementUserId,
                value: recentAnswer[0],
                eligibilityAnswerId: item.answerId,
                optionalNotesData: optionalNotesTextState,
                // optionalNotesData : this.state.optionalNotesTextState === "" && nextQuestionDataApi1.optionalNotesData !== null  ? nextQuestionDataApi1.optionalNotesData : this.state.optionalNotesTextState
              });
            }
          }
          // ansArray.push({"eligibilityQuestionId":questionId,"userId":userid,"value":recentAnswer,"eligibilityAnswerId":item.answerId});
          //  }
        }
        emptyFlagArray.push({
          eligibilityQuestionId: questionId,
          userId: settlementUserId,
          value: "",
          eligibilityAnswerId: item.answerId,
          optionalNotesData: optionalNotesTextState,
          // optionalNotesData : this.state.optionalNotesTextState === "" && nextQuestionDataApi1.optionalNotesData !== null  ? nextQuestionDataApi1.optionalNotesData : this.state.optionalNotesTextState
        });
        return true;
      });
      this.setState({ recentAnswer: [], multipleInputOptionsData: [] });
    }
    // if (Type === 15) {
    //   LocalAnswerObj.eligibilityQuestionId = questionId;
    //   answerOptions.map((item) => {
    //     if (item.isDisabled !== 1) {
    //       // if(item.answerId===recentAnswer){
    //       if (item.moveToNextQuestion === 0) {
    //         moveToNextFlag.push({
    //           moveToNextQuestion: false,
    //           answerID: item.answerId,
    //         });
    //       }
    //       if (item.isQualify === 0) {
    //         isQualify.push({ isQualify: false, answerID: item.answerId });
    //       }
    //       if (typeof recentAnswer === "string") {
    //         ansArray.push({
    //           eligibilityQuestionId: questionId,
    //           userId: settlementUserId,
    //           value: recentAnswer,
    //           eligibilityAnswerId: item.answerId,
    //         });
    //       } else if (recentAnswer[0] !== undefined) {
    //         ansArray.push({
    //           eligibilityQuestionId: questionId,
    //           userId: settlementUserId,
    //           value: recentAnswer[0],
    //           eligibilityAnswerId: item.answerId,
    //         });
    //       }
    //       // ansArray.push({"eligibilityQuestionId":questionId,"userId":userid,"value":recentAnswer,"eligibilityAnswerId":item.answerId});
    //       //  }
    //     }
    //     emptyFlagArray.push({
    //       eligibilityQuestionId: questionId,
    //       userId: settlementUserId,
    //       value: "",
    //       eligibilityAnswerId: item.answerId,
    //     });
    //     return true;
    //   });
    //   this.setState({ recentAnswer: [], multipleInputOptionsData: [] });
    // }
    // end for Inputbox

    if (Type === 14) {
      // console.log("answerOptions 14", answerOptions);
      LocalAnswerObj.eligibilityQuestionId = questionId;
      answerOptions.map((item) => {
        ansArray.push({
          eligibilityQuestionId: questionId,
          userId: settlementUserId,
          value: "yes",
          eligibilityAnswerId: item.answerId,
          // optionalNotesData : this.state.optionalNotesTextState
          optionalNotesData: optionalNotesTextState,
          // optionalNotesData : this.state.optionalNotesTextState === "" && item.optionalNotesData !== null  ? item.optionalNotesData : this.state.optionalNotesTextState
        });
        emptyFlagArray.push({
          eligibilityQuestionId: questionId,
          userId: settlementUserId,
          value: "",
          eligibilityAnswerId: item.answerId,
          optionalNotesData: optionalNotesTextState,
          // optionalNotesData : this.state.optionalNotesTextState
          // optionalNotesData : this.state.optionalNotesTextState === "" && nextQuestionDataApi1.optionalNotesData !== null  ? nextQuestionDataApi1.optionalNotesData : this.state.optionalNotesTextState
        });
        return true;
      });
      this.setState({ recentAnswer: [], multipleInputOptionsData: [],optionalNotesTextState : "",fileNameState:"",multipleFileState:[] });
    }

    // code for number input
    if (Type === 6) {
      LocalAnswerObj.eligibilityQuestionId = questionId;
      answerOptions.map((item) => {
        if (item.isDisabled !== 1) {
          const answer = item.answerText;
          let matchProperty = [];
          matchProperty = answer.split(",");
          if (matchProperty.indexOf(recentAnswer) === -1) {
            isMatch.push({ matchValue: false, answerID: item.answerId });
          }
          if (item.moveToNextQuestion === 0) {
            if (
              item.matchValue === 1 &&
              item.answerText.includes(recentAnswer) === true
            ) {
              moveToNextFlag.push({
                moveToNextQuestion: false,
                answerID: item.answerId,
              });
            }
          } else if (
            item.matchValue === 1 &&
            item.answerText.includes(recentAnswer) === false
          ) {
            moveToNextFlag.push({
              moveToNextQuestion: false,
              answerID: item.answerId,
            });
          }
          // moveToNextFlag.push({ moveToNextQuestion: false, answerID: item.answerId });

          // if (item.matchValue === 1 && item.answerText.includes(recentAnswer) === false) {
          //   moveToNextFlag.push({ moveToNextQuestion: false, answerID: item.answerId });
          // }
          if (item.isQualify === 0) {
            isQualify.push({ isQualify: false, answerID: item.answerId });
          }
          if (recentAnswer.length === 0) {
            // ansArray.push({"eligibilityQuestionId":questionId,"userId":settlementUserId,"value":"","eligibilityAnswerId":item.answerId});
          } else if (typeof recentAnswer === "string") {
            ansArray.push({
              eligibilityQuestionId: questionId,
              userId: settlementUserId,
              value: recentAnswer,
              eligibilityAnswerId: item.answerId,
              optionalNotesData: optionalNotesTextState,
              // optionalNotesData : this.state.optionalNotesTextState
              // optionalNotesData : this.state.optionalNotesTextState === "" && nextQuestionDataApi1.optionalNotesData !== null  ? nextQuestionDataApi1.optionalNotesData : this.state.optionalNotesTextState
            });
          } else if (recentAnswer[0] !== undefined) {
            ansArray.push({
              eligibilityQuestionId: questionId,
              userId: settlementUserId,
              value: recentAnswer[0],
              eligibilityAnswerId: item.answerId,
              // optionalNotesData : this.state.optionalNotesTextState
              optionalNotesData: optionalNotesTextState,
              // optionalNotesData : this.state.optionalNotesTextState === "" && nextQuestionDataApi1.optionalNotesData !== null  ? nextQuestionDataApi1.optionalNotesData : this.state.optionalNotesTextState
            });
          }
        }
        emptyFlagArray.push({
          eligibilityQuestionId: questionId,
          userId: settlementUserId,
          value: "",
          eligibilityAnswerId: item.answerId,
          optionalNotesData: optionalNotesTextState,
          // optionalNotesData : this.state.optionalNotesTextState
          // optionalNotesData : this.state.optionalNotesTextState === "" && nextQuestionDataApi1.optionalNotesData !== null  ? nextQuestionDataApi1.optionalNotesData : this.state.optionalNotesTextState
        });
        return true;
      });
      this.setState({ recentAnswer: [], multipleInputOptionsData: [] ,optionalNotesTextState : "",fileNameState:"",multipleFileState:[]});
    }
    // end for number input

    // code for multiple input

    if ( Type === 15) {
      console.log(
        "ssssssssssss",
        multipleIputTypeQuestion.eligibilityAnswerDto
      );
      LocalAnswerObj.eligibilityQuestionId = questionId;
      multipleIputTypeQuestion.eligibilityAnswerDto.map((item) => {
        if (item.isDisabled !== 1) {
          console.log("sssssssssssssss item.value", item.moveToNextQuestion, item.value)
          if (item.moveToNextQuestion === 0 && item.value !== "") {
            if(item.value !== "Invalid date") {
              moveToNextFlag.push({
                moveToNextQuestion: false,
                answerID: item.answerId,
              });
            }
          }
          if (item.isQualify === 0) {
            isQualify.push({ isQualify: false, answerID: item.answerId });
          }
          if (item.answerId !== 0) {
            ansArray.push({
              eligibilityQuestionId: item.eligibilityQuestionId,
              userId: item.userId,
              value: item.value,
              eligibilityAnswerId: item.answerId,
              optionalNotesData: optionalNotesTextState,
            });
          }
        }
        emptyFlagArray.push({
          eligibilityQuestionId: questionId,
          userId: settlementUserId,
          value: "",
          eligibilityAnswerId: item.answerId,
          optionalNotesData: optionalNotesTextState,
        });
        return true;
      });
      this.setState({ recentAnswer: [], multipleInputOptionsData: [] });
      // }
    }


    if (Type === 7 || Type === 13 ) {
      console.log(
        "ssssssssssss",
        multipleIputTypeQuestion.eligibilityAnswerDto
      );
      LocalAnswerObj.eligibilityQuestionId = questionId;
      multipleIputTypeQuestion.eligibilityAnswerDto.map((item) => {
        if (item.isDisabled !== 1) {
          if (item.moveToNextQuestion === 0 && item.value !== "") {
            moveToNextFlag.push({
              moveToNextQuestion: false,
              answerID: item.answerId,
            });
          }

          console.log("sssssssssssssssssssssssssssss niraj", item)

          if (item.isQualify === 0) {
            isQualify.push({ isQualify: false, answerID: item.answerId });
          }
          if (item.answerId !== 0) {
            if (item && item.value !== "") {
              if(item.value !== "Invalid date") {
                ansArray.push({
                  eligibilityQuestionId: item.eligibilityQuestionId,
                  userId: item.userId,
                  value: item.value,
                  eligibilityAnswerId: item.answerId,
                  optionalNotesData: optionalNotesTextState,
                  // optionalNotesData : this.state.optionalNotesTextState
                  // optionalNotesData : this.state.optionalNotesTextState === "" && nextQuestionDataApi1.optionalNotesData !== null  ? nextQuestionDataApi1.optionalNotesData : this.state.optionalNotesTextState
                });
              }
            }
          }

          if (Type === 13) {
            multipleIputTypeQuestion.eligibilityAnswerDto.findIndex(
              (item1) =>
                console.log(
                  item1.value,
                  "item1.value",
                  item1.inputType === "" && item1.value === ""
                )
              // item1.inputType === "" && item1.value === ""
            );
            if (
              multipleIputTypeQuestion.eligibilityAnswerDto.findIndex(
                (item1) => item1.inputType === "" || item1.value === ""
              ) !== -1
            ) {
              errorFagListMulti.push({
                eligibilityQuestionId: questionId,
                userId: settlementUserId,
                value: "",
                eligibilityAnswerId: item.answerId,
                optionalNotesData: optionalNotesTextState,
                // optionalNotesData : this.state.optionalNotesTextState === "" && nextQuestionDataApi1.optionalNotesData !== null  ? nextQuestionDataApi1.optionalNotesData : this.state.optionalNotesTextState
              });
            }
          }

          // if (item.eligibilityQuestionResponseDto !== null) {
          //   if (item.eligibilityQuestionResponseDto.eligibilityAnswerId !== undefined) {
          //     if (recentAnswer.length !== 0) {
          //       if (_.findIndex(recentAnswer, o => o.key === item.answerId) !== -1) {
          //         ansArray.push({
          //           eligibilityQuestionId: questionId, userId: settlementUserId, value: recentAnswer[_.findIndex(recentAnswer, o => o.key === item.answerId)].value, eligibilityAnswerId: item.answerId,
          //         });
          //       } else {
          //         ansArray.push({
          //           eligibilityQuestionId: questionId, userId: settlementUserId, value: item.eligibilityQuestionResponseDto.value, eligibilityAnswerId: item.answerId,
          //         });
          //       }
          //     } else {
          //       ansArray.push({
          //         eligibilityQuestionId: questionId, userId: settlementUserId, value: item.eligibilityQuestionResponseDto.value, eligibilityAnswerId: item.answerId,
          //       });
          //     }
          //   }
          // } else {
          //   for (let i = 0; i < recentAnswer.length; i++) {
          //     if (item.answerId === recentAnswer[i].key) {
          //       ansArray.push({
          //         eligibilityQuestionId: questionId, userId: settlementUserId, value: recentAnswer[i].value, eligibilityAnswerId: item.answerId,
          //       });
          //     }
          //   }
          // }
          // }
        }
        emptyFlagArray.push({
          eligibilityQuestionId: questionId,
          userId: settlementUserId,
          value: "",
          eligibilityAnswerId: item.answerId,
          optionalNotesData: optionalNotesTextState,
          // optionalNotesData : this.state.optionalNotesTextState
          // optionalNotesData : this.state.optionalNotesTextState === "" && nextQuestionDataApi1.optionalNotesData !== null  ? nextQuestionDataApi1.optionalNotesData : this.state.optionalNotesTextState
        });
        return true;
      });
      this.setState({ recentAnswer: [], multipleInputOptionsData: [] ,optionalNotesTextState : "",fileNameState:"",multipleFileState:[]});
      // }
    }

    // code for vehicle and type 8
    if (Type === 8) {
      LocalAnswerObj.eligibilityQuestionId = questionId;
      // console.log('saveDataAnswer', this.state.saveDataAnswer, recentAnswer)
      const vehicleData = this.filterArray(recentAnswer);
      for (let i = 0; i < vehicleData.length; i++) {
        answerOptions.map((item) => {
          if (item.moveToNextQuestion === 0) {
            moveToNextFlag.push({
              moveToNextQuestion: false,
              answerID: item.answerId,
            });
          }
          if (item.isQualify === 0) {
            isQualify.push({ isQualify: false, answerID: item.answerId });
          }
          if (i < 1) {
            ansArray.push({
              eligibilityQuestionId: questionId,
              userId: settlementUserId,
              value: vehicleData[i],
              eligibilityAnswerId: item.answerId,
              optionalNotesData: optionalNotesTextState,
              // optionalNotesData : this.state.optionalNotesTextState
              // optionalNotesData : this.state.optionalNotesTextState === "" && nextQuestionDataApi1.optionalNotesData !== null  ? nextQuestionDataApi1.optionalNotesData : this.state.optionalNotesTextState
            });
          }
          // vehicleDataMultiple
          emptyFlagArray.push({
            eligibilityQuestionId: questionId,
            userId: settlementUserId,
            value: "",
            eligibilityAnswerId: item.answerId,
            optionalNotesData: optionalNotesTextState,
            // optionalNotesData : this.state.optionalNotesTextState
            optionalNotesData : this.state.optionalNotesTextState === "" && nextQuestionDataApi1.optionalNotesData !== null  ? nextQuestionDataApi1.optionalNotesData : this.state.optionalNotesTextState
          });
          return true;
        });
        this.state.vehicleOptions.map((vehicleDataList) => {
          if (vehicleDataList.vehicleDataId === vehicleData[i]) {
            vehicleDataMultiple.push({
              vehicleYear: vehicleDataList.vehicleYear,
              vehicleMake: vehicleDataList.vehicleMake,
              vehicleModel: vehicleDataList.vehicleModel,
              vehicleDetailsId: vehicleDataList.vehicleDataId,
            });
          }
          return true;
        });
      }

      if (recentAnswer.length === 0) {
        ansArray.push({
          eligibilityQuestionId: questionId,
          userId: settlementUserId,
          value: "",
          eligibilityAnswerId: answerOptions[0].answerId,
          optionalNotesData: optionalNotesTextState,
          // optionalNotesData : this.state.optionalNotesTextState === "" && nextQuestionDataApi1.optionalNotesData !== null  ? nextQuestionDataApi1.optionalNotesData : this.state.optionalNotesTextState
          // optionalNotesData : this.state.optionalNotesTextState === "" && item.optionalNotesData !== null  ? item.optionalNotesData : this.state.optionalNotesTextState
        });
      }
      this.setState({ recentAnswer: [], multipleInputOptionsData: [] ,optionalNotesTextState : "",fileNameState:"",multipleFileState:[]});
    }
    if (Type === 9) {
      LocalAnswerObj.eligibilityQuestionId = questionId;
      answerOptions.map((item) => {
        ansArray.push({
          eligibilityQuestionId: questionId,
          userId: settlementUserId,
         value: "",
          eligibilityAnswerId: item.answerId,
          optionalNotesData: optionalNotesTextState,
          // optionalNotesData : this.state.optionalNotesTextState
          // optionalNotesData : this.state.optionalNotesTextState === "" && nextQuestionDataApi1.optionalNotesData !== null  ? nextQuestionDataApi1.optionalNotesData : this.state.optionalNotesTextState
        });

        //  }
        // }
        emptyFlagArray.push({
          eligibilityQuestionId: questionId,
          userId: settlementUserId,
          value: "",
          eligibilityAnswerId: item.answerId,
          optionalNotesData: optionalNotesTextState,
          // optionalNotesData : this.state.optionalNotesTextState
          // optionalNotesData : this.state.optionalNotesTextState === "" && nextQuestionDataApi1.optionalNotesData !== null  ? nextQuestionDataApi1.optionalNotesData : this.state.optionalNotesTextState
        });
        return true;
      });
      this.setState({ recentAnswer: [], multipleInputOptionsData: [],optionalNotesTextState : "",fileNameState:"",multipleFileState:[] });
    }

    if (Type === 10) {
      LocalAnswerObj.eligibilityQuestionId = questionId;
      answerOptions.map((item) => {
        if (item.moveToNextQuestion === 0) {
          moveToNextFlag.push({
            moveToNextQuestion: false,
            answerID: item.answerId,
          });
        }
        if (item.isQualify === 0) {
          isQualify.push({ isQualify: false, answerID: item.answerId });
        }
        ansArray.push({
          eligibilityQuestionId: questionId,
          userId: settlementUserId,
          value: "",
          eligibilityAnswerId: item.answerId,
          optionalNotesData: optionalNotesTextState,
          // optionalNotesData : this.state.optionalNotesTextState
          // optionalNotesData : this.state.optionalNotesTextState === "" && nextQuestionDataApi1.optionalNotesData !== null  ? nextQuestionDataApi1.optionalNotesData : this.state.optionalNotesTextState
        });
        if (vehicleDetailsDtoListData !== null) {
          if (vehicleDetailsDtoListData.length > 0) {
            vehicleDetailsDtoListData.map((vehicleDataList) => {
              /*
               * Not valid - we are forcing a selection of vehicle part on every vehicle whih is wrong
              if (vehicleDataList.autoPartDefendentDtoListValue.findIndex(data => data.autoPartid === 0) !== -1) {
                errorFlag.push({
                  eligibilityQuestionId: questionId, userId: settlementUserId, value: '', eligibilityAnswerId: item.answerId,
                });
              }
              */
              if (
                vehicleDataList.autoPartDefendentDtoListValue.findIndex(
                  (item1) =>
                    item1.autoPartid !== 0 && item1.autoPartDefendentId === 0
                ) !== -1
              ) {
                errorFagList.push({
                  eligibilityQuestionId: questionId,
                  userId: settlementUserId,
                  value: "",
                  eligibilityAnswerId: item.answerId,
                  optionalNotesData: optionalNotesTextState,
                  // optionalNotesData : this.state.optionalNotesTextState === "" && nextQuestionDataApi1.optionalNotesData !== null  ? nextQuestionDataApi1.optionalNotesData : this.state.optionalNotesTextState
                });
              }
              return true;
            });
          }
        }
        // if (i < 1) {
        // }
        // vehicleDataMultiple
        emptyFlagArray.push({
          eligibilityQuestionId: questionId,
          userId: settlementUserId,
          value: "",
          eligibilityAnswerId: item.answerId,
          optionalNotesData: optionalNotesTextState,
          // optionalNotesData : this.state.optionalNotesTextState
          // optionalNotesData : this.state.optionalNotesTextState === "" && nextQuestionDataApi1.optionalNotesData !== null  ? nextQuestionDataApi1.optionalNotesData : this.state.optionalNotesTextState
        });
        return true;
      });
      if (vehicleDetailsDtoListData !== null) {
        vehicleDetailsDtoListData.map((vehicleDataList) => {
          // if (vehicleDataList.vehicleDataId === vehicleData[i]) {
          vehicleDataMultiple.push({
            vehicleResponseId: vehicleDataList.vehicleResponseId,
            autoPartDefendentDtoList:
              vehicleDataList.autoPartDefendentDtoListValue,
          });
          // }
          return true;
        });
      }
      // }
      this.setState({ recentAnswer: [], multipleInputOptionsData: [] ,optionalNotesTextState : "",fileNameState:"",multipleFileState:[]});
    }

    if (Type === 11) {
      LocalAnswerObj.eligibilityQuestionId = questionId;
      const vehicleData = this.state.vehicleOptions;
      for (let i = 0; i < vehicleData.length; i++) {
        answerOptions.map((item) => {
          if (item.moveToNextQuestion === 0) {
            moveToNextFlag.push({
              moveToNextQuestion: false,
              answerID: item.answerId,
            });
          }
          if (item.isQualify === 0) {
            isQualify.push({ isQualify: false, answerID: item.answerId });
          }
          if (i < 1) {
            ansArray.push({
              eligibilityQuestionId: questionId,
              userId: settlementUserId,
              value: vehicleData[i].vehicleDetailsId,
              eligibilityAnswerId: item.answerId,
              optionalNotesData: optionalNotesTextState,
              // optionalNotesData : this.state.optionalNotesTextState
              // optionalNotesData : this.state.optionalNotesTextState === "" && nextQuestionDataApi1.optionalNotesData !== null  ? nextQuestionDataApi1.optionalNotesData : this.state.optionalNotesTextState
            });
          }
          // vehicleDataMultiple
          emptyFlagArray.push({
            eligibilityQuestionId: questionId,
            userId: settlementUserId,
            value: "",
            eligibilityAnswerId: item.answerId,
            optionalNotesData: optionalNotesTextState,
            // optionalNotesData : this.state.optionalNotesTextState === "" && nextQuestionDataApi1.optionalNotesData !== null  ? nextQuestionDataApi1.optionalNotesData : this.state.optionalNotesTextState
          });
          return true;
        });
      }
      this.state.vehicleDataNewObject.map((vehicleDataList) => {
        // console.log('sssssssssssssssssssssssssssssssssssss',moment(vehicleDataList.soldDate).format('YYYY-MM-DD HH:MM:SS'))

        vehicleDataMultiple.push({
          vehicleYear: vehicleDataList.vehicleYear,
          vehicleMake: vehicleDataList.vehicleMake,
          vehicleModel: vehicleDataList.vehicleModel,
          vehicleDetailsId: vehicleDataList.vehicleDetailsId,
          vin: vehicleDataList.vin,
          vehicleType: vehicleDataList.vehicleType,
          soldDate:
            moment(vehicleDataList.soldDate).format("YYYY-MM-DD HH:MM:SS") !==
            "Invalid date"
              ? moment(vehicleDataList.soldDate).format("YYYY-MM-DD HH:MM:SS")
              : "",
        });

        vehicleDataMultipleSave.push({
          vehicleYear: vehicleDataList.vehicleYear,
          vehicleMake: vehicleDataList.vehicleMake,
          vehicleModel: vehicleDataList.vehicleModel,
          vehicleDataId: vehicleDataList.vehicleDetailsId,
          vin: vehicleDataList.vin,
          vehicleType: vehicleDataList.vehicleType,
          soldDate:
            moment(vehicleDataList.soldDate).format("YYYY-MM-DD HH:MM:SS") !==
            "Invalid date"
              ? moment(vehicleDataList.soldDate).format("YYYY-MM-DD HH:MM:SS")
              : "",
        });

        return true;
      });

      if (recentAnswer.length === 0) {
        // ansArray.push({
        //   eligibilityQuestionId: questionId, userId: settlementUserId, value: '', eligibilityAnswerId: answerOptions[0].answerId,
        // });
      }

      let objList = this.state.vehicleDataNewObject;

      let uniqueList = [];
      let dupList = [];

      Array.prototype.contains = function (item) {
        let filtered_item = this.filter((i) => {
          return (
            i.vehicleYear === item.vehicleYear &&
            i.vehicleYear === item.vehicleYear &&
            i.vin === item.vin &&
            i.vehicleMake === item.vehicleMake &&
            i.vehicleModel === item.vehicleModel
          );
        });
        return !!filtered_item.length;
      };

      // const contains = (list, item) => {
      //   let filtered_item = list.filter((i) => {
      //     return i.vehicleYear === item.vehicleYear && i.vin === item.vin && i.vehicleMake === item.vehicleMake && i.vehicleModel === item.vehicleModel
      //   });
      //   return !!filtered_item.length;
      // }

      const pushToUniqueList = (item) => {
        if (!uniqueList.contains(item)) uniqueList.push(item);
      };

      const pushToDuplicateList = (item) => {
        if (!dupList.contains(item)) dupList.push(item);
      };

      for (let i = 0; i < objList.length; i++) {
        if (uniqueList.contains(objList[i])) {
          pushToDuplicateList(objList[i]);
        } else {
          pushToUniqueList(objList[i]);
        }
      }

      // console.log('Duplicate list is ', dupList);
      // console.log('Unique list is ', uniqueList);

      // if (dupList.length > 0) {
      //   errorFagQtyListDup.push({
      //     eligibilityQuestionId: questionId,
      //     userId: settlementUserId,
      //     value: ""
      //   });
      // }

      if (
        this.state.vehicleDataNewObject.findIndex(
          (item1) =>
            item1.vin === "" ||
            item1.vehicleType === "" ||
            (item1.vehicleType === "Sold" &&
              (item1.soldDate === undefined || item1.soldDate === ""))
        ) !== -1
      ) {
        errorFagQtyList.push({
          eligibilityQuestionId: questionId,
          userId: settlementUserId,
          value: "",
        });
      }
      if (errorFagQtyList.length === 0) {
        this.props.saveMultipleVehicleDataByUserIdAPI({
          userId: settlementUserId,
          vehicleDataDtoList: vehicleDataMultipleSave,
        });
        this.setState({ recentAnswer: [], multipleInputOptionsData: [] ,optionalNotesTextState : "",fileNameState:""});
      }
    }

    if (Type === 12) {
      LocalAnswerObj.eligibilityQuestionId = questionId;
      const vehicleData = this.state.reimbursementDetailsDtoListDta;
      // ansArray.push({
      //   eligibilityQuestionId: questionId, userId: settlementUserId, value: '', eligibilityAnswerId: answerOptions[0].answerId,
      // });
      // console.log('vehicleData', vehicleData);
      answerOptions.map((item) => {
        // console.log('ddddddddddddddddd item',item.answerId, vehicleDataList.reimbursementDetailsDtoList)
        // if (item.isQualify === 1) {
        //   moveToNextFlag.push({ moveToNextQuestion: false, answerID: item.answerId });
        // }
        if (item.isQualify === 0) {
          isQualify.push({ isQualify: false, answerID: item.answerId });
        }
        // if (i < 1) {
        // ansArray.push({
        //   eligibilityQuestionId: questionId, userId: settlementUserId, value: '', eligibilityAnswerId: answerOptions[0].answerId,
        // });
        // }
        // vehicleDataMultiple
        emptyFlagArray.push({
          eligibilityQuestionId: questionId,
          userId: settlementUserId,
          value: "",
          eligibilityAnswerId: item.answerId,
          optionalNotesData: optionalNotesTextState,
          // optionalNotesData : this.state.optionalNotesTextState
          // optionalNotesData : this.state.optionalNotesTextState === "" && nextQuestionDataApi1.optionalNotesData !== null  ? nextQuestionDataApi1.optionalNotesData : this.state.optionalNotesTextState
        });
        return true;
      });
      if (vehicleData !== null) {
        vehicleData.map((vehicleDataList) => {
          // console.log('ssssssssssssssss vehicleData', vehicleData);
          const reimbursementDetailsDtoListChild = [];
          vehicleDataList.reimbursementDetailsDtoList.map((data) => {
            // reimbursementDetailsDtoListChild.push({ reimbursementAmount: data.value });
            if (data.value !== "") {
              if (data.isQualify === 1) {
                moveToNextFlag.push({
                  moveToNextQuestion: false,
                  answerID: data.eligibilityQuestionId,
                });
              }
            }

            if (
              (soldFlagData === 0 && vehicleDataList.vehicleType !== "Sold") ||
              soldFlagData === 1
            ) {
              ansArray.push({
                eligibilityQuestionId: data.eligibilityQuestionId,
                userId: data.userId,
                value: data.value,
                eligibilityAnswerId: data.eligibilityAnswerId,
                vehicleId: data.vehicleId,
                optionalNotesData: optionalNotesTextState,
                // optionalNotesData : this.state.optionalNotesTextState === "" && nextQuestionDataApi1.optionalNotesData !== null  ? nextQuestionDataApi1.optionalNotesData : this.state.optionalNotesTextState
                // optionalNotesData : this.state.optionalNotesTextState === "" && item.optionalNotesData !== null  ? item.optionalNotesData : this.state.optionalNotesTextState
              });
            }
            return true;
          });

          vehicleDataMultiple.push({
            vehicleYear: vehicleDataList.vehicleYear,
            vehicleMake: vehicleDataList.vehicleMake,
            vehicleModel: vehicleDataList.vehicleModel,
            vehicleDetailsId: vehicleDataList.vehicleDetailsId,
            reimbursementDetailsDtoList: reimbursementDetailsDtoListChild,
          });
          return true;
        });
      }

      // console.log('isQualify',isQualify, moveToNextFlag)

      this.setState({ recentAnswer: [], multipleInputOptionsData: [] ,optionalNotesTextState : "",fileNameState:"",multipleFileState:[]});
    }

    this.setState({
      stateId: 2,

      // stateSubmitData:true
    });

    // console.log('errorFagQtyList.length',errorFagQtyList.length)
    let letErrorMessage = "";
    if (errorFlag.length !== 0) {
      letErrorMessage = "Please choose the part ";
    } else if (errorFagList.length !== 0) {
      letErrorMessage = "Please choose the part manufacturer ";
    } else if (errorFagQtyList.length !== 0) {
      letErrorMessage = "Please fill Vin, current status and sold date.";
    } else if (errorFagQtyListDup.length !== 0) {
      letErrorMessage = "VIN is already associated with another vehicle.";
    } else if (errorFagListMulti.length !== 0) {
      letErrorMessage = "Please select question type and answer the question.";
    }
    console.log("s sssssssssssssssssssssssssssss niraj t" , nextQuestionDataApi1.isMandatory, ansArray )
    if (nextQuestionDataApi1.isMandatory === 1) {
      if (
        errorFlag.length === 0 &&
        errorFagList.length === 0 &&
        errorFagQtyList.length === 0 &&
        errorFagQtyListDup.length === 0 &&
        letErrorMessage.length === 0
      ) {
        letErrorMessage = "";
        if (ansArray.length > 0) {
          if (moveToNextFlag.length > 0) {
            this.props.saveUsersUneligibleSettlements({
              settlementId: this.props.match.params.eid,
              userId: settlementUserId,
            });

            this.setState({
              PopErrorNotAllowedToMove: false,
              PopErrorNotAllowedToMoveE: true,
              showLastQusetion: false,
              success: false,
              recentAnswer: [],
              multipleInputOptionsData: [],
            });
          } else {
            arrayBack.push(questionId);
            this.setState(
              {
                stateSubmitData: true,
                forwardStatus: 1,
                counterQuesr: counterQuesr + 1,
                arrayBackWord: arrayBack,
                nextQuestionDataApi1,
                loaded: true,
                multipleIputTypeQuestion: [],
              },
              () => {console.log("three");
                const dataa = {
                  settlementId: this.props.match.params.eid,
                  saveValue:
                    nextQuestionDataApi1.questionTypeId === 8
                      ? saveDataAnswer
                      : 
                      "Y",
                  reviewQuestion: this.state.reviewQuestion,
                  eligibilityQuestionId: this.state.nextQuestionDataApi1
                    .eligibilityQuestionId,
                  eligibilityQuestionResponseDtos: ansArray,
                  vehicleDetailsDtoList: vehicleDataMultiple,
                  userId: settlementUserId,
                  deviceType: "WEB",
                  browser: this.state.browser,
                  appVersion: this.state.appVersion,
                  ipAddress: this.state.ipAddress,
                  // optionalNotesData : this.state.optionalNotesTextState
                  disclaimerAgree : disclaimerAgreeState
                };
                // console.log("eligibilityQuestionResponseDtos",dataa.eligibilityQuestionResponseDtos)
                clearSavedata();
                this.props.saveToNextQuestionList(dataa);
                this.setState({nexState:true,disclaimerAgreeState:"Yes",addState:[],
                radioDupeState:[],
                yesState:[],
                dropdState:[],dupeInterCheck:true})
              }
            );
            this.setState({ error: "" });

            // if (nextQuestionDataApi1.questionLeft === 'N') {
            //   // this.props.saveSettlementAnswers(this.state.postObject);

            // }
            const emptyFArray = [];
            this.setState({
              currentQuestionNumber:
                currentQuestionNumber + 1 === totalNumberOfQuestions
                  ? currentQuestionNumber
                  : currentQuestionNumber + 1,
              buttonText:
                nextQuestionDataApi1.questionLeft === "N" ? "Complete" : "Next",
              // postObject: answerObj, skipUploadDoc
              recentAnswer: emptyFArray,
              multipleInputOptionsData: [],
            });
          }
        } else {
          this.setState({
            error: "Please answer the question",
            nextQuestionDataApi1,
            stateSubmitData: false,
            forwardStatus: 1,
            PopErrorNotAllowedToMove: true,
            PopErrorNotAllowedToMoveE: false,
            showLastQusetion: false,
            success: false,
          });
        }
      } else {
        this.setState({
          error: letErrorMessage,
          nextQuestionDataApi1,
          stateSubmitData: false,
          forwardStatus: 1,
          PopErrorNotAllowedToMove: true,
          PopErrorNotAllowedToMoveE: false,
          showLastQusetion: false,
          success: false,
        });
      }
    } else if (moveToNextFlag.length > 0) {
      this.props.saveUsersUneligibleSettlements({
        settlementId: this.props.match.params.eid,
        userId: settlementUserId,
      });

      this.setState({
        PopErrorNotAllowedToMove: false,
        PopErrorNotAllowedToMoveE: true,
        showLastQusetion: false,
        success: false,
        recentAnswer: [],
        multipleFileState:[]
      });
    } else {
      if (
        errorFlag.length === 0 &&
        errorFagList.length === 0 &&
        errorFagQtyList.length === 0 &&
        errorFagQtyListDup.length === 0
      ) {
        arrayBack.push(questionId);
        this.setState(
          {
            stateSubmitData: true,
            forwardStatus: 1,
            counterQuesr: counterQuesr + 1,
            arrayBackWord: arrayBack,
            nextQuestionDataApi1,
            loaded: true,
            multipleIputTypeQuestion: [],
            multipleFileState:[],
          },
          () => {
            let dataa = {};
            if (ansArray.length > 0) {
              console.log("one")
              dataa = {
                settlementId: this.props.match.params.eid,
                eligibilityQuestionId: this.state.nextQuestionDataApi1
                  .eligibilityQuestionId,
                eligibilityQuestionResponseDtos: ansArray,
                vehicleDetailsDtoList: vehicleDataMultiple,
                saveValue:
                  nextQuestionDataApi1.questionTypeId === 8
                    ? saveDataAnswer
                    : 
                    "Y",
                reviewQuestion: this.state.reviewQuestion,
                userId: settlementUserId,
                deviceType: "WEB",
                browser: this.state.browser,
                appVersion: this.state.appVersion,
                ipAddress: this.state.ipAddress,
                // optionalNotesData : this.state.optionalNotesTextState
                disclaimerAgree : disclaimerAgreeState
              };
            } else {
              console.log("two")
              dataa = {
                settlementId: this.props.match.params.eid,
                eligibilityQuestionId: this.state.nextQuestionDataApi1
                  .eligibilityQuestionId,
                eligibilityQuestionResponseDtos: emptyFlagArray,
                vehicleDetailsDtoList: vehicleDataMultiple,
                saveValue: "N",
                // saveValue: "Y",
                reviewQuestion: this.state.reviewQuestion,
                userId: settlementUserId,
                deviceType: "WEB",
                browser: this.state.browser,
                appVersion: this.state.appVersion,
                ipAddress: this.state.ipAddress,
                // optionalNotesData: optionalNotesTextState
                disclaimerAgree : disclaimerAgreeState
              };
            }
            clearSavedata();
            this.props.saveToNextQuestionList(dataa);
            this.setState({multipleFileState:[],nexState:true,dupeInterCheck:true,  disclaimerAgreeState:"Yes",addState:[],
            radioDupeState:[],
            yesState:[],
            dropdState:[],})
          }
        );

        this.setState({ error: "",optionalNotesTextState:"",multipleFileState:[] });
      } else {
        this.setState({
          error: letErrorMessage,
          nextQuestionDataApi1,
          stateSubmitData: false,
          forwardStatus: 1,
          PopErrorNotAllowedToMove: true,
          PopErrorNotAllowedToMoveE: false,
          showLastQusetion: false,
          success: false,
          optionalNotesTextState:"",
          multipleFileState:[]
        });
      }
      let status = false;
      // let statusSuccess = false;
      // let successResult = true;

      if (nextQuestionDataApi1.questionLeft === "N") {
        // this.props.saveSettlementAnswers(this.state.postObject);
        if (skipUploadDoc1 === 1) {
          status = true;
          // statusSuccess = true;
          // successResult = true;
        } else {
          status = true;
          // statusSuccess = true;
          // successResult = true;
        }
      }
      const emptyFArray = [];
      this.setState({
        currentQuestionNumber:
          currentQuestionNumber + 1 === totalNumberOfQuestions
            ? currentQuestionNumber
            : currentQuestionNumber + 1,
        buttonText:
          nextQuestionDataApi1.questionLeft === "N" ? "Complete" : "Next",
        // postObject: answerObj, skipUploadDoc
        recentAnswer: emptyFArray,
        multipleInputOptionsData: [],
        ShowUploadScreen: status,
      });
    }
    this.setState({
      recentAnswer: [],
      multipleInputOptionsData: [],
      saveDataAnswer: "N",
    });
  }

  vehicleOptionsMultiSelection(id) {
    let answerArr = [];
    answerArr = this.state.recentAnswer;
    // let a = this.state.vehiclerecentAnswer;
    const isIn = answerArr.indexOf(id);
    if (isIn > -1) {
      answerArr.splice(isIn, 1);
    } else {
      answerArr.push(id);
    }

    // if (answerArr.length > 0) {
    //   answerArr = [];
    // }
    const uniqueArray = [];
    for (let i = 0; i < answerArr.length; i++) {
      if (uniqueArray.indexOf(answerArr[i]) === -1) {
        uniqueArray.push(answerArr[i]);
      }
    }
    // answerArr.push(uniqueArray);
    this.setState({
      saveDataAnswer: "Y",
      recentAnswer: uniqueArray,
      error: "",
      answerIdLatestQ: id,
      answerTextLatestQ: id,
      resentData: 2,
      // disclaimerAgreeState:"No"
    });
    // if(JSON.stringify(a) !== JSON.stringify(uniqueArray)){
    //   this.setState({disclaimerAgreeState:"No"});
    // }
  }

  MultiselectOptions(id, text) {
    let answerArr = [];
    answerArr = this.state.recentAnswer;
    let ans = this.state.addState;
   
    const isIn = answerArr.indexOf(id);
    if (isIn > -1) {
      answerArr.splice(isIn, 1);
    } else {
      answerArr.push(id);
    }
    
    for(let i=0;i<1;i++){
      var a =[...this.state.recentAnswer]
    }
    const uniqueArray = [];
    for (let i = 0; i < answerArr.length; i++) {
      if (uniqueArray.indexOf(answerArr[i]) === -1) {
        uniqueArray.push(answerArr[i]);
      }
    }
  

    this.setState({
      recentAnswer: uniqueArray,
      answerIdLatestQ: id,
      answerTextLatestQ: text,
      error: "",
      resentData: 2,
    });
    if(JSON.stringify(ans) !== JSON.stringify(uniqueArray)){
      this.setState({disclaimerAgreeState:"No"});
      console.log("thios",this.state.disclaimerAgreeState)
    }
    
  }

  radioSelectOption(id, text) {
    let answerArr = [];
    answerArr = this.state.recentAnswer;
    let ao = this.state.recentAnswer[0];
    if (answerArr.length > 0) {
      answerArr = [];
      this.state.radioDupeState.push(ao);
    }
    if (answerArr.length > 0) {
      answerArr = [];
      this.state.radioDupeState.push(ao);
    }
    console.log("bonde",answerArr,this.state.radioDupeState,this.state.disclaimerAgreeState)
    answerArr.push(id);
    this.setState({
      recentAnswer: answerArr,
      answerIdLatestQ: id,
      answerTextLatestQ: text,
      error: "",
    });

    if( this.state.recentAnswer[0] !== this.state.radioDupeState[0]){
      this.setState({disclaimerAgreeState:"No"});
      console.log("thee",this.state.disclaimerAgreeState,answerArr,this.state.recentAnswer,this.state.radioDupeState)
    }
    // if(JSON.stringify(anss) !== JSON.stringify(answerArr)){
    //   this.setState({disclaimerAgreeState:"No"});
    //   console.log("thios",this.state.disclaimerAgreeState)
    // }
  }

  radioSelectOptionOne(id, text) {
    let answerArr = [];
    answerArr = this.state.recentAnswer;
    let ao = this.state.recentAnswer[0];
    if (answerArr.length > 0) {
      answerArr = [];
      this.state.yesState.push(ao);
    }
    console.log("bonde",answerArr,this.state.radioDupeState,this.state.disclaimerAgreeState)
    answerArr.push(id);
    this.setState({
      recentAnswer: answerArr,
      answerIdLatestQ: id,
      answerTextLatestQ: text,
      error: "",
    });

    if( this.state.recentAnswer[0] !== this.state.yesState[0]){
      this.setState({disclaimerAgreeState:"No"});
      console.log("thee",this.state.disclaimerAgreeState,answerArr,this.state.recentAnswer,this.state.radioDupeState)
    }
    // if(JSON.stringify(anss) !== JSON.stringify(answerArr)){
    //   this.setState({disclaimerAgreeState:"No"});
    //   console.log("thios",this.state.disclaimerAgreeState)
    // }
  }

  inputSelctorOptionsNumber(e) {
    console.log("recent",this.state.recentAnswer)
    let ans = this.state.recentAnswer;
    const re = /^[0-9\b]+$/;
    if (re.test(e.target.value) || e.target.value === "") {
      this.setState({
        resentData: 2,
        [e.target.name]: e.target.value,

        error: "",
      });
    }
    if(ans.toString() != e.target.value){
      this.setState({disclaimerAgreeState:"No"})
    }
  }

  changeVinNumber = (value, index) => {
    const { vehicleDataNewObject } = this.state;
    vehicleDataNewObject[index].vin = value;
    this.setState({
      vehicleDataNewObject,
    });
  };

  changeSoldDate = (value, index) => {
    const { vehicleDataNewObject } = this.state;
    vehicleDataNewObject[index].vehicleType = value;
    this.setState({
      vehicleDataNewObject,
    });
  };

  changeDate = (value, index) => {
    const { vehicleDataNewObject } = this.state;
    vehicleDataNewObject[index].soldDate = value;
    this.setState({
      vehicleDataNewObject,
    });
  };

  inputSelctorOptions(e) {
  

    this.setState({
      resentData: 2,
      [e.target.name]: e.target.value,
      recentAnswerState : e.target.value
,      error: "",
disclaimerAgreeState:"No"
    });
    console.log("joker",e.target.value,this.state.recentAnswer);
  }

  inputSelctorOptionsNotes(e){
    console.log("f",e.target.value,e)
    this.setState({optionalNotesTextState:e.target.value,error:""});
    
  }

  _onSelect(e) {
    let answerArr = [];
    let dropd = this.state.dropdState;
    answerArr = this.state.recentAnswer;
    if (answerArr.length > 0) {
      answerArr = [];
    }
    answerArr.push(e.target.value);
    this.setState({
      recentAnswer: answerArr,
      error: "",
    });
    if(JSON.stringify(dropd) !== JSON.stringify(answerArr)){
      this.setState({disclaimerAgreeState:"No"});
      
    }
  }

  onKeyPressed = (e) => {
    const key = e.keyCode ? e.keyCode : e.which;

    if (
      !(
        [8, 9, 13, 27, 46].indexOf(key) !== -1 ||
        (key === 65 && (e.ctrlKey || e.metaKey)) ||
        (key >= 35 && key <= 40) ||
        (key >= 48 && key <= 57 && !(e.shiftKey || e.altKey)) ||
        (key >= 96 && key <= 105)
      )
    )
      e.preventDefault();
  };

  //
  multipleInputOptions = (index) => (e) => {
    const { multipleIputTypeQuestion } = this.state;
    const multipleAnswer = multipleIputTypeQuestion;
     if (
        multipleAnswer.eligibilityAnswerDto.findIndex(
          (item) => item.answerId === index
        ) !== -1
      ) {
        multipleAnswer.eligibilityAnswerDto[
          multipleAnswer.eligibilityAnswerDto.findIndex(
            (item) => item.answerId === index
          )
        ].value = e.target.value;
      }
      const val = e.target.value;
      let answerArr = [];
      let answerArrKey = [];
      answerArr = this.state.recentAnswer;
      answerArrKey = this.state.multipleInputOptionsData;

      if (answerArrKey.indexOf(index) === -1) {
        answerArr.push({ key: index, value: val });
      } else {
        for (let arrayIndex = 0; arrayIndex < answerArr.length; arrayIndex++) {
          if (answerArr[arrayIndex].key === index) {
            answerArr[arrayIndex].value = val;
          }
        }
        //
      }
      answerArrKey.push(index);

      this.setState({
        recentAnswer: answerArr,
        multipleInputOptionsData: answerArrKey,
        multipleIputTypeQuestion: multipleAnswer,
        error: "",
        disclaimerAgreeState:"No"
      });
  };

  multipleInputOptionsNumber = (index) => (e) => {
    const { multipleIputTypeQuestion } = this.state;
    const multipleAnswer = multipleIputTypeQuestion;
    const re = /^[0-9\b]+$/;
    if (re.test(e.target.value) || e.target.value === "") {
      if (
        multipleAnswer.eligibilityAnswerDto.findIndex(
          (item) => item.answerId === index
        ) !== -1
      ) {
        multipleAnswer.eligibilityAnswerDto[
          multipleAnswer.eligibilityAnswerDto.findIndex(
            (item) => item.answerId === index
          )
        ].value = e.target.value;
      }
      const val = e.target.value;
      let answerArr = [];
      let answerArrKey = [];
      answerArr = this.state.recentAnswer;
      answerArrKey = this.state.multipleInputOptionsData;

      if (answerArrKey.indexOf(index) === -1) {
        answerArr.push({ key: index, value: val });
      } else {
        for (let arrayIndex = 0; arrayIndex < answerArr.length; arrayIndex++) {
          if (answerArr[arrayIndex].key === index) {
            answerArr[arrayIndex].value = val;
          }
        }
        //
      }
      answerArrKey.push(index);

      this.setState({
        recentAnswer: answerArr,
        multipleInputOptionsData: answerArrKey,
        multipleIputTypeQuestion: multipleAnswer,
        error: "",
        disclaimerAgreeState:"No"
      });
    }
  };

  multipleInputTypeDateOptions = (index) => (e) => {
    const { multipleIputTypeQuestion } = this.state;
    const multipleAnswer = multipleIputTypeQuestion;
     if (
        multipleAnswer.eligibilityAnswerDto.findIndex(
          (item) => item.answerId === index
        ) !== -1
      ) {
        multipleAnswer.eligibilityAnswerDto[
          multipleAnswer.eligibilityAnswerDto.findIndex(
            (item) => item.answerId === index
          )
        ].value = moment(e).format("MM/DD/YYYY");
      }
      const val = moment(e).format("MM/DD/YYYY");
      let answerArr = [];
      let answerArrKey = [];
      answerArr = this.state.recentAnswer;
      answerArrKey = this.state.multipleInputOptionsData;

      if (answerArrKey.indexOf(index) === -1) {
        answerArr.push({ key: index, value: val });
      } else {
        for (let arrayIndex = 0; arrayIndex < answerArr.length; arrayIndex++) {
          if (answerArr[arrayIndex].key === index) {
            answerArr[arrayIndex].value = val;
          }
        }
        //
      }
      answerArrKey.push(index);

      this.setState({
        recentAnswer: answerArr,
        multipleInputOptionsData: answerArrKey,
        multipleIputTypeQuestion: multipleAnswer,
        error: "",
        disclaimerAgreeState:"No"
      });
  };

  deleteQuestionDetail = (index) => (e) => {
    e.preventDefault();
    const {
      multipleIputTypeQuestion: { eligibilityAnswerDto },
    } = this.state;

    let eligibilityAnswerDtoList = eligibilityAnswerDto;
    console.log(
      "eligibilityAnswerDtoeligibilityAnswerDto",
      eligibilityAnswerDto,
      index,
      eligibilityAnswerDtoList[index].reviewIndex
    );

    if (
      eligibilityAnswerDtoList[index + 1] &&
      eligibilityAnswerDtoList[index].reviewIndex === 0 &&
      eligibilityAnswerDtoList[index + 1].reviewIndex !== 0
    ) {
      eligibilityAnswerDtoList[index + 1].reviewIndex = 0;
    }
    eligibilityAnswerDtoList.splice(index, 1);

    console.log(
      "eligibilityAnswerDtoeligibilityAnswerDto eligibilityAnswerDtoList",
      eligibilityAnswerDtoList
    );

    this.setState({
      multipleIputTypeQuestion: {
        ...this.state.multipleIputTypeQuestion,
        eligibilityAnswerDto: eligibilityAnswerDtoList,
      },
    });
  };

  addMoreQuestionDetail = () => {
    const {multipleIputTypeQuestion: {eligibilityAnswerDto, eligibilityQuestionId}, settlementUserId} = this.state
    // const {
    //   multipleIputTypeQuestion,
    //   multipleIputTypeQuestion: { eligibilityAnswerDto, eligibilityQuestionId },
    //   settlementUserId,
    // } = this.state;

    let eligibilityAnswerDtoList = eligibilityAnswerDto;
    eligibilityAnswerDtoList.push({
      answerId: 0,
      answerText: "",
      isDisabled: "",
      isQualify: "",
      matchValue: "",
      placeholder: "",
      inputType: "",
      moveToNextQuestion: "",
      value: "",
      review: "add",
      reviewIndex: 0,
      eligibilityQuestionId: eligibilityQuestionId,
      userId: settlementUserId,
      eligibilityAnswerId: "",
    });

    this.setState({
      multipleIputTypeQuestion: {
        ...this.state.multipleIputTypeQuestion,
        eligibilityAnswerDto: eligibilityAnswerDtoList,
        disclaimerAgreeState:"No"
      },
    });
  };

  onMultiselectSelect = (index) => (e) => {
    const {
      multipleIputTypeQuestion: { eligibilityAnswerDto, questionListDto },
      settlementUserId,
    } = this.state;
    if (
      questionListDto.findIndex((item) => item.answerId === e.target.value) !==
      -1
    ) {
      eligibilityAnswerDto[index].answerId = e.target.value;
      eligibilityAnswerDto[index].answerText =
        questionListDto[
          questionListDto.findIndex((item) => item.answerId === e.target.value)
        ].answerText;
      eligibilityAnswerDto[index].isDisabled =
        questionListDto[
          questionListDto.findIndex((item) => item.answerId === e.target.value)
        ].isDisabled;
      eligibilityAnswerDto[index].isQualify =
        questionListDto[
          questionListDto.findIndex((item) => item.answerId === e.target.value)
        ].isQualify;

      eligibilityAnswerDto[index].matchValue =
        questionListDto[
          questionListDto.findIndex((item) => item.answerId === e.target.value)
        ].matchValue;
      eligibilityAnswerDto[index].placeholder =
        questionListDto[
          questionListDto.findIndex((item) => item.answerId === e.target.value)
        ].placeholder;
      eligibilityAnswerDto[index].inputType =
        questionListDto[
          questionListDto.findIndex((item) => item.answerId === e.target.value)
        ].inputType;
      eligibilityAnswerDto[index].moveToNextQuestion =
        questionListDto[
          questionListDto.findIndex((item) => item.answerId === e.target.value)
        ].moveToNextQuestion;
      eligibilityAnswerDto[index].value = "";
      eligibilityAnswerDto[index].eligibilityQuestionId =
        eligibilityAnswerDto[index].eligibilityQuestionId;
      eligibilityAnswerDto[index].userId = settlementUserId;
      eligibilityAnswerDto[index].eligibilityAnswerId = e.target.value;
    }
    this.setState(
      {
        multipleIputTypeQuestion: {
          ...this.state.multipleIputTypeQuestion,
          eligibilityAnswerDto: eligibilityAnswerDto,
          disclaimerAgreeState:"No"
        },
      },
      () => {
        // console.log('sssssssssssssssssssssssss',this.state.multipleIputTypeQuestion)
      }
    );
    // let answerArr = [];
    // answerArr = this.state.recentAnswer;
    // if (answerArr.length > 0) {
    //   answerArr = [];
    // }
    // answerArr.push(e.target.value);
    // this.setState({
    //   recentAnswer: answerArr,
    //   error: ""
    // });
  };

  multipleInputOptionsSelect = (index, ansIndex) => (e) => {
    const { multipleIputTypeQuestion } = this.state;
    const multipleAnswer = multipleIputTypeQuestion;
    // console.log('multipleAnswer',index, ansIndex, e.target.value)
    // const re = /^[0-9\b]+$/;
    // if (re.test(e.target.value) || e.target.value === "") {
    // console.log('nextQuestionDataApi1', nextQuestionDataApi1.eligibilityAnswerDto, index);
    // console.log(multipleAnswer.eligibilityAnswerId.findIndex(item => item.answerId === index));
    // if (
    //   multipleAnswer.eligibilityAnswerDto.findIndex(
    //     item => item.answerId === index
    //   ) !== -1
    // ) {
    //   multipleAnswer.eligibilityAnswerDto[
    //     multipleAnswer.eligibilityAnswerDto.findIndex(
    //       item => item.answerId === index
    //     )
    //   ].value = e.target.value;
    // }
    multipleAnswer.eligibilityAnswerDto[ansIndex].value = e.target.value;
    const val = e.target.value;
    let answerArr = [];
    let answerArrKey = [];
    answerArr = this.state.recentAnswer;
    answerArrKey = this.state.multipleInputOptionsData;

    if (answerArrKey.indexOf(index) === -1) {
      answerArr.push({ key: index, value: val });
    } else {
      for (let arrayIndex = 0; arrayIndex < answerArr.length; arrayIndex++) {
        if (answerArr[arrayIndex].key === index) {
          answerArr[arrayIndex].value = val;
        }
      }
      //
    }
    answerArrKey.push(index);

    this.setState({
      recentAnswer: answerArr,
      multipleInputOptionsData: answerArrKey,
      multipleIputTypeQuestion: multipleAnswer,
      // nextQuestionDataApi1: multipleAnswer,
      error: "",
      disclaimerAgreeState:"No"
    });
    // }
  };

  multipleInputOptionsDate = (index, ansIndex) => (e) => {
    const { multipleIputTypeQuestion } = this.state;
    const multipleAnswer = multipleIputTypeQuestion;
    multipleAnswer.eligibilityAnswerDto[ansIndex].value = moment(e).format(
      "MM/DD/YYYY"
    );

    const val = moment(e).format("MM/DD/YYYY");
    let answerArr = [];
    let answerArrKey = [];
    answerArr = this.state.recentAnswer;
    answerArrKey = this.state.multipleInputOptionsData;

    if (answerArrKey.indexOf(index) === -1) {
      answerArr.push({ key: index, value: val });
    } else {
      for (let arrayIndex = 0; arrayIndex < answerArr.length; arrayIndex++) {
        if (answerArr[arrayIndex].key === index) {
          answerArr[arrayIndex].value = val;
        }
      }
      //
    }
    answerArrKey.push(index);

    this.setState({
      recentAnswer: answerArr,
      multipleInputOptionsData: answerArrKey,
      multipleIputTypeQuestion: multipleAnswer,
      // nextQuestionDataApi1: multipleAnswer,
      error: "",
      disclaimerAgreeState:"No"
    });
    // }
  };

  multipleInputOptionsR = (index, vehicleDetailsdId) => (e) => {
    const { reimbursementDetailsDtoListDta } = this.state;

    // console.log('reimbursementDetailsDtoListDta', index, reimbursementDetailsDtoListDta, vehicleDetailsdId);

    const indexVehicleID = reimbursementDetailsDtoListDta.findIndex(
      (item) => item.vehicleDetailsId === vehicleDetailsdId
    );
    if (indexVehicleID !== -1) {
      // console.log('indexVehicleID', indexVehicleID);
      const indexVehicleAnswerID = reimbursementDetailsDtoListDta[
        indexVehicleID
      ].reimbursementDetailsDtoList.findIndex(
        (item) => item.eligibilityAnswerId === index
      );
      reimbursementDetailsDtoListDta[
        indexVehicleID
      ].reimbursementDetailsDtoList[indexVehicleAnswerID].value =
        e.target.value;
      this.setState(
        {
          reimbursementDetailsDtoListDta,
          disclaimerAgreeState:"No"
        },
        () => {
          // console.log('reimbursementDetailsDtoListDta niraj', reimbursementDetailsDtoListDta);
        }
      );
    }
  };

  // multiple dropdown

  multipleDropdownFunction = (index, stateChild, childIndex, currentId) => (
    e
  ) => {
    const updateDataList = [];
    let selectedData = [];
    let recentDataStateChildM = "";
    let childData = "";
    let autoPartidDataUpdate = "";
    let letErrorMessage = "";
    let selectedChildData = [];
    const { vehicleDetailsDtoListData } = this.state;
    // const opts = { position: 'top-center' };
    if (stateChild === "Child") {
      recentDataStateChildM = stateChild;
      for (
        let arrayIndex = 0;
        arrayIndex < vehicleDetailsDtoListData.length;
        arrayIndex++
      ) {
        if (vehicleDetailsDtoListData[arrayIndex].vehicleDetailsId === index) {
          childData =
            vehicleDetailsDtoListData[arrayIndex]
              .autoPartDefendentDtoListValueChildData;
          selectedChildData =
            vehicleDetailsDtoListData[arrayIndex]
              .autoPartDefendentDtoListValue !== undefined
              ? vehicleDetailsDtoListData[arrayIndex]
                  .autoPartDefendentDtoListValue
              : [];
          if (
            selectedChildData.findIndex(
              (item) => item.autoPartid === e.target.value
            ) !== -1
          ) {
            letErrorMessage =
              "This option is already selected, please select any other option";
          } else {
            // console.log('childIndex', childIndex);
            letErrorMessage = "";
            if (
              selectedChildData.findIndex(
                (item) => item.autoPartid === e.target.value
              ) === -1
            ) {
              if (
                selectedChildData.findIndex(
                  (item) => item.selectedIndex === childIndex
                ) === -1
              ) {
                selectedChildData.push({
                  selectedIndex: childIndex,
                  autoPartid: Number.parseInt(e.target.value, 10),
                  autoPartDefendentId: 0,
                });
              } else {
                selectedChildData[
                  selectedChildData.findIndex(
                    (item) => item.selectedIndex === childIndex
                  )
                ].autoPartid = e.target.value;
                selectedChildData[
                  selectedChildData.findIndex(
                    (item) => item.selectedIndex === childIndex
                  )
                ].autoPartDefendentId = 0;
              }
            } else {
              for (let i = 0; i < selectedChildData.length; i++) {
                if (
                  Number.parseInt(selectedChildData[i].autoPartid, 10) ===
                  Number.parseInt(e.target.value, 10)
                ) {
                  selectedChildData[i].autoPartid = e.target.value;
                  selectedChildData[i].autoPartDefendentId = 0;
                }
              }
            }

            for (let i = 0; i < childData.length; i++) {
              if (childData[i].vehicleDetailsIndex === childIndex) {
                childData[i].autoPartid = Number.parseInt(e.target.value, 10);
                childData[i].autoPartDefendentId = 0;
              }
            }
            const data = {
              autoPartid: e.target.value,
            };
            this.props.getAutoPartDefendentPartsByPartId(data);
          }

          updateDataList.push({
            vehicleYear: vehicleDetailsDtoListData[arrayIndex].vehicleYear,
            vehicleMake: vehicleDetailsDtoListData[arrayIndex].vehicleMake,
            vehicleModel: vehicleDetailsDtoListData[arrayIndex].vehicleModel,
            vehicleDetailsId:
              vehicleDetailsDtoListData[arrayIndex].vehicleDetailsId,
            vehicleResponseId:
              vehicleDetailsDtoListData[arrayIndex].vehicleResponseId,
            selectedPartId: Number.parseInt(
              vehicleDetailsDtoListData[arrayIndex].selectedPartId,
              10
            ),
            autoPartDefendentDtoList:
              vehicleDetailsDtoListData[arrayIndex].autoPartDefendentDtoList,
            autoPartDefendentDataId:
              vehicleDetailsDtoListData[arrayIndex].autoPartDefendentDataId !==
              undefined
                ? Number.parseInt(
                    vehicleDetailsDtoListData[arrayIndex]
                      .autoPartDefendentDataId,
                    10
                  )
                : 0,
            autoPartDefendentDtoListData:
              vehicleDetailsDtoListData[arrayIndex]
                .autoPartDefendentDtoListData !== undefined
                ? vehicleDetailsDtoListData[arrayIndex]
                    .autoPartDefendentDtoListData
                : [],
            autoPartDefendentDtoListValue: selectedChildData,
            autoPartDefendentDtoListValueChildData: childData,
          });
        } else {
          updateDataList.push({
            vehicleYear: vehicleDetailsDtoListData[arrayIndex].vehicleYear,
            vehicleMake: vehicleDetailsDtoListData[arrayIndex].vehicleMake,
            vehicleModel: vehicleDetailsDtoListData[arrayIndex].vehicleModel,
            vehicleDetailsId:
              vehicleDetailsDtoListData[arrayIndex].vehicleDetailsId,
            vehicleResponseId:
              vehicleDetailsDtoListData[arrayIndex].vehicleResponseId,
            selectedPartId: Number.parseInt(
              vehicleDetailsDtoListData[arrayIndex].selectedPartId,
              10
            ),
            autoPartDefendentDtoList:
              vehicleDetailsDtoListData[arrayIndex].autoPartDefendentDtoList,
            autoPartDefendentDataId:
              vehicleDetailsDtoListData[arrayIndex].autoPartDefendentDataId !==
              undefined
                ? Number.parseInt(
                    vehicleDetailsDtoListData[arrayIndex]
                      .autoPartDefendentDataId,
                    10
                  )
                : 0,
            autoPartDefendentDtoListData:
              vehicleDetailsDtoListData[arrayIndex]
                .autoPartDefendentDtoListData !== undefined
                ? vehicleDetailsDtoListData[arrayIndex]
                    .autoPartDefendentDtoListData
                : [],
            autoPartDefendentDtoListValue:
              vehicleDetailsDtoListData[arrayIndex]
                .autoPartDefendentDtoListValue !== undefined
                ? vehicleDetailsDtoListData[arrayIndex]
                    .autoPartDefendentDtoListValue
                : [],
            autoPartDefendentDtoListValueChildData:
              vehicleDetailsDtoListData[arrayIndex]
                .autoPartDefendentDtoListValueChildData,
          });
        }
        // if (childData[childIndexDataId-1].vehicleDetailsIndex === recentDataSelect) {
        // }
      }
    } else {
      recentDataStateChildM = "";
      for (
        let arrayIndex = 0;
        arrayIndex < vehicleDetailsDtoListData.length;
        arrayIndex++
      ) {
        if (vehicleDetailsDtoListData[arrayIndex].vehicleDetailsId === index) {
          selectedData =
            vehicleDetailsDtoListData[arrayIndex]
              .autoPartDefendentDtoListValue !== undefined
              ? vehicleDetailsDtoListData[arrayIndex]
                  .autoPartDefendentDtoListValue
              : [];
          if (
            selectedData.findIndex(
              (item) => item.autoPartid === e.target.value
            ) !== -1
          ) {
            letErrorMessage =
              "This option is already selected, please select any other option";
            autoPartidDataUpdate = false;
          } else {
            letErrorMessage = "";
            if (
              selectedData.findIndex(
                (item) => item.autoPartid === currentId
              ) === -1
            ) {
              selectedData.push({
                selectedIndex: 0,
                autoPartid: Number.parseInt(e.target.value, 10),
                autoPartDefendentId: 0,
              });
            } else {
              for (let i = 0; i < selectedData.length; i++) {
                if (
                  Number.parseInt(selectedData[i].autoPartid, 10) ===
                  Number.parseInt(currentId, 10)
                ) {
                  selectedData[i].autoPartid = Number.parseInt(
                    e.target.value,
                    10
                  );
                  selectedData[i].autoPartDefendentId = 0;
                }
              }
            }
            autoPartidDataUpdate = true;
            const data = {
              autoPartid: e.target.value,
            };
            this.props.getAutoPartDefendentPartsByPartId(data);
          }
          updateDataList.push({
            vehicleYear: vehicleDetailsDtoListData[arrayIndex].vehicleYear,
            vehicleMake: vehicleDetailsDtoListData[arrayIndex].vehicleMake,
            vehicleModel: vehicleDetailsDtoListData[arrayIndex].vehicleModel,
            vehicleDetailsId:
              vehicleDetailsDtoListData[arrayIndex].vehicleDetailsId,
            vehicleResponseId:
              vehicleDetailsDtoListData[arrayIndex].vehicleResponseId,
            selectedPartId:
              autoPartidDataUpdate === true
                ? Number.parseInt(e.target.value, 10)
                : Number.parseInt(
                    vehicleDetailsDtoListData[arrayIndex].selectedPartId,
                    10
                  ),
            autoPartDefendentDtoListValue: selectedData,
            autoPartDefendentDataId:
              vehicleDetailsDtoListData[arrayIndex].autoPartDefendentDataId !==
              undefined
                ? Number.parseInt(
                    vehicleDetailsDtoListData[arrayIndex]
                      .autoPartDefendentDataId,
                    10
                  )
                : 0,
            autoPartDefendentDtoList:
              vehicleDetailsDtoListData[arrayIndex].autoPartDefendentDtoList,
            autoPartDefendentDtoListData:
              vehicleDetailsDtoListData[arrayIndex]
                .autoPartDefendentDtoListData !== undefined
                ? vehicleDetailsDtoListData[arrayIndex]
                    .autoPartDefendentDtoListData
                : [],
            autoPartDefendentDtoListValueChildData:
              vehicleDetailsDtoListData[arrayIndex]
                .autoPartDefendentDtoListValueChildData,
          });
          autoPartidDataUpdate = false;
        } else {
          updateDataList.push({
            vehicleYear: vehicleDetailsDtoListData[arrayIndex].vehicleYear,
            vehicleMake: vehicleDetailsDtoListData[arrayIndex].vehicleMake,
            vehicleModel: vehicleDetailsDtoListData[arrayIndex].vehicleModel,
            vehicleDetailsId:
              vehicleDetailsDtoListData[arrayIndex].vehicleDetailsId,
            vehicleResponseId:
              vehicleDetailsDtoListData[arrayIndex].vehicleResponseId,
            selectedPartId: Number.parseInt(
              vehicleDetailsDtoListData[arrayIndex].selectedPartId,
              10
            ),
            autoPartDefendentDtoListValue:
              vehicleDetailsDtoListData[arrayIndex]
                .autoPartDefendentDtoListValue !== undefined
                ? vehicleDetailsDtoListData[arrayIndex]
                    .autoPartDefendentDtoListValue
                : [],
            autoPartDefendentDataId:
              vehicleDetailsDtoListData[arrayIndex].autoPartDefendentDataId !==
              undefined
                ? vehicleDetailsDtoListData[arrayIndex].autoPartDefendentDataId
                : 0,
            autoPartDefendentDtoList:
              vehicleDetailsDtoListData[arrayIndex].autoPartDefendentDtoList,
            autoPartDefendentDtoListData:
              vehicleDetailsDtoListData[arrayIndex]
                .autoPartDefendentDtoListData !== undefined
                ? vehicleDetailsDtoListData[arrayIndex]
                    .autoPartDefendentDtoListData
                : [],
            autoPartDefendentDtoListValueChildData:
              vehicleDetailsDtoListData[arrayIndex]
                .autoPartDefendentDtoListValueChildData,
          });
        }
      }
    }
    let answerArr = [];

    // console.log('updateDataListupdateDataListupdateDataList', updateDataList);
    answerArr = this.state.recentAnswer;
    this.setState({
      vehicleDetailsDtoListData: updateDataList,
      recentAnswer: answerArr,
      recentDataSelect: index,
      recentDataStateChildM,
      childIndexDataId: childIndex,
      error: letErrorMessage,
      // nextQuestionDataApi1,
      stateSubmitData: false,
      forwardStatus: 1,
      PopErrorNotAllowedToMove: true,
      PopErrorNotAllowedToMoveE: false,
      showLastQusetion: false,
      success: false,
      disclaimerAgreeState:"No"
    });
  };

  multipleDropdownFunctionPart = (
    index,
    stateChild,
    childIndex,
    autoPartid
  ) => (e) => {
    const { vehicleDetailsDtoListData } = this.state;
    let selectedData = [];
    const updateDataList = [];

    let recentDataStateChildM = "";
    let childData = "";
    let selectedChildData = [];
    if (stateChild === "Child") {
      recentDataStateChildM = stateChild;
      for (
        let arrayIndex = 0;
        arrayIndex < vehicleDetailsDtoListData.length;
        arrayIndex++
      ) {
        if (vehicleDetailsDtoListData[arrayIndex].vehicleDetailsId === index) {
          selectedChildData =
            vehicleDetailsDtoListData[arrayIndex].autoPartDefendentDtoListValue;
          childData =
            vehicleDetailsDtoListData[arrayIndex]
              .autoPartDefendentDtoListValueChildData;
          const indexChildData = childData.findIndex(
            (p) =>
              Number.parseInt(p.autoPartid, 10) ===
              Number.parseInt(autoPartid, 10)
          );
          childData[indexChildData].autoPartDefendentId = e.target.value;
          // for (let i = 0; i < childData.length; i++) {
          //   if (childData[i].vehicleDetailsIndex === childIndex) {
          //   }
          // }
          const indexSelecteData = selectedChildData.findIndex(
            (p) =>
              Number.parseInt(p.autoPartid, 10) ===
              Number.parseInt(autoPartid, 10)
          );
          selectedChildData[
            indexSelecteData
          ].autoPartDefendentId = Number.parseInt(e.target.value, 10);

          // for (let i = 0; i < selectedChildData.length; i++) {
          //   if (selectedChildData[i].autoPartid === Number.parseInt(autoPartid, 10)) {
          //     selectedChildData[i].autoPartDefendentId = e.target.value;
          //   }
          // }
          updateDataList.push({
            vehicleYear: vehicleDetailsDtoListData[arrayIndex].vehicleYear,
            vehicleMake: vehicleDetailsDtoListData[arrayIndex].vehicleMake,
            vehicleModel: vehicleDetailsDtoListData[arrayIndex].vehicleModel,
            vehicleDetailsId:
              vehicleDetailsDtoListData[arrayIndex].vehicleDetailsId,
            vehicleResponseId:
              vehicleDetailsDtoListData[arrayIndex].vehicleResponseId,
            selectedPartId:
              vehicleDetailsDtoListData[arrayIndex].selectedPartId,
            autoPartDefendentDtoList:
              vehicleDetailsDtoListData[arrayIndex].autoPartDefendentDtoList,
            autoPartDefendentDataId:
              vehicleDetailsDtoListData[arrayIndex].autoPartDefendentDataId !==
              undefined
                ? vehicleDetailsDtoListData[arrayIndex].autoPartDefendentDataId
                : 0,
            autoPartDefendentDtoListData:
              vehicleDetailsDtoListData[arrayIndex]
                .autoPartDefendentDtoListData !== undefined
                ? vehicleDetailsDtoListData[arrayIndex]
                    .autoPartDefendentDtoListData
                : [],
            autoPartDefendentDtoListValue: selectedChildData,
            autoPartDefendentDtoListValueChildData: childData,
          });
        } else {
          updateDataList.push({
            vehicleYear: vehicleDetailsDtoListData[arrayIndex].vehicleYear,
            vehicleMake: vehicleDetailsDtoListData[arrayIndex].vehicleMake,
            vehicleModel: vehicleDetailsDtoListData[arrayIndex].vehicleModel,
            vehicleDetailsId:
              vehicleDetailsDtoListData[arrayIndex].vehicleDetailsId,
            vehicleResponseId:
              vehicleDetailsDtoListData[arrayIndex].vehicleResponseId,
            selectedPartId:
              vehicleDetailsDtoListData[arrayIndex].selectedPartId,
            autoPartDefendentDtoList:
              vehicleDetailsDtoListData[arrayIndex].autoPartDefendentDtoList,
            autoPartDefendentDataId:
              vehicleDetailsDtoListData[arrayIndex].autoPartDefendentDataId !==
              undefined
                ? vehicleDetailsDtoListData[arrayIndex].autoPartDefendentDataId
                : 0,
            autoPartDefendentDtoListData:
              vehicleDetailsDtoListData[arrayIndex]
                .autoPartDefendentDtoListData !== undefined
                ? vehicleDetailsDtoListData[arrayIndex]
                    .autoPartDefendentDtoListData
                : [],
            autoPartDefendentDtoListValue:
              vehicleDetailsDtoListData[arrayIndex]
                .autoPartDefendentDtoListValue,
            autoPartDefendentDtoListValueChildData:
              vehicleDetailsDtoListData[arrayIndex]
                .autoPartDefendentDtoListValueChildData,
          });
        }
        // if (childData[childIndexDataId-1].vehicleDetailsIndex === recentDataSelect) {
        // }
      }
    } else {
      recentDataStateChildM = "";

      for (
        let arrayIndex = 0;
        arrayIndex < vehicleDetailsDtoListData.length;
        arrayIndex++
      ) {
        if (vehicleDetailsDtoListData[arrayIndex].vehicleDetailsId === index) {
          selectedData =
            vehicleDetailsDtoListData[arrayIndex]
              .autoPartDefendentDtoListValue !== undefined
              ? vehicleDetailsDtoListData[arrayIndex]
                  .autoPartDefendentDtoListValue
              : [];
          for (let i = 0; i < selectedData.length; i++) {
            if (
              Number.parseInt(selectedData[i].autoPartid, 10) ===
              Number.parseInt(autoPartid, 10)
            ) {
              selectedData[i].autoPartid = Number.parseInt(autoPartid, 10);
              selectedData[i].autoPartDefendentId = Number.parseInt(
                e.target.value,
                10
              );
            }
          }
          updateDataList.push({
            vehicleYear: vehicleDetailsDtoListData[arrayIndex].vehicleYear,
            vehicleMake: vehicleDetailsDtoListData[arrayIndex].vehicleMake,
            vehicleModel: vehicleDetailsDtoListData[arrayIndex].vehicleModel,
            vehicleDetailsId:
              vehicleDetailsDtoListData[arrayIndex].vehicleDetailsId,
            vehicleResponseId:
              vehicleDetailsDtoListData[arrayIndex].vehicleResponseId,
            selectedPartId:
              vehicleDetailsDtoListData[arrayIndex].selectedPartId,
            autoPartDefendentDataId: e.target.value,
            autoPartDefendentDtoList:
              vehicleDetailsDtoListData[arrayIndex].autoPartDefendentDtoList,
            autoPartDefendentDtoListData:
              vehicleDetailsDtoListData[arrayIndex]
                .autoPartDefendentDtoListData !== undefined
                ? vehicleDetailsDtoListData[arrayIndex]
                    .autoPartDefendentDtoListData
                : [],
            autoPartDefendentDtoListValue: selectedData,
            autoPartDefendentDtoListValueChildData:
              vehicleDetailsDtoListData[arrayIndex]
                .autoPartDefendentDtoListValueChildData,
          });
        } else {
          updateDataList.push({
            vehicleYear: vehicleDetailsDtoListData[arrayIndex].vehicleYear,
            vehicleMake: vehicleDetailsDtoListData[arrayIndex].vehicleMake,
            vehicleModel: vehicleDetailsDtoListData[arrayIndex].vehicleModel,
            vehicleDetailsId:
              vehicleDetailsDtoListData[arrayIndex].vehicleDetailsId,
            vehicleResponseId:
              vehicleDetailsDtoListData[arrayIndex].vehicleResponseId,
            selectedPartId:
              vehicleDetailsDtoListData[arrayIndex].selectedPartId,
            autoPartDefendentDataId:
              vehicleDetailsDtoListData[arrayIndex].autoPartDefendentDataId !==
              undefined
                ? vehicleDetailsDtoListData[arrayIndex].autoPartDefendentDataId
                : 0,
            autoPartDefendentDtoList:
              vehicleDetailsDtoListData[arrayIndex].autoPartDefendentDtoList,
            autoPartDefendentDtoListData:
              vehicleDetailsDtoListData[arrayIndex]
                .autoPartDefendentDtoListData !== undefined
                ? vehicleDetailsDtoListData[arrayIndex]
                    .autoPartDefendentDtoListData
                : [],
            autoPartDefendentDtoListValue:
              vehicleDetailsDtoListData[arrayIndex]
                .autoPartDefendentDtoListValue,
            autoPartDefendentDtoListValueChildData:
              vehicleDetailsDtoListData[arrayIndex]
                .autoPartDefendentDtoListValueChildData,
          });
        }
      }
    }

    let answerArr = [];
    answerArr = this.state.recentAnswer;
    // if (answerArr.length > 0) {
    //   answerArr = [];
    // }
    // answerArr.push('id' : index ,e.value);

    this.setState({
      vehicleDetailsDtoListData: updateDataList,
      recentAnswer: answerArr,
      recentDataSelect: index,
      recentDataStateChildM,
      childIndexDataId: childIndex,
      error: "",
      disclaimerAgreeState:"No"
    });
  };

  deleteMoreDetail = (id, index, iteamDataIdData) => (e) => {
    e.preventDefault();
    // console.log('ddddddddddddddddddddddd',id)
    // console.log('ddddddddddddddddddddddd index',index)
    // console.log('ddddddddddddddddddddddd iteamDataIdData',iteamDataIdData)
    const { vehicleDetailsDtoListData } = this.state;
    // console.log('ddddddddddddssssssssss', vehicleDetailsDtoListData)
    let childData = [];
    let autoPartDefendentDtoListValueData = [];
    const updateDataList = [];
    for (
      let arrayIndex = 0;
      arrayIndex < vehicleDetailsDtoListData.length;
      arrayIndex++
    ) {
      if (vehicleDetailsDtoListData[arrayIndex].vehicleDetailsId === id) {
        autoPartDefendentDtoListValueData =
          vehicleDetailsDtoListData[arrayIndex].autoPartDefendentDtoListValue;
        childData =
          vehicleDetailsDtoListData[arrayIndex]
            .autoPartDefendentDtoListValueChildData;
        if (autoPartDefendentDtoListValueData !== undefined) {
          for (let i = 0; i < autoPartDefendentDtoListValueData.length; i++) {
            if (
              autoPartDefendentDtoListValueData[i].autoPartid ===
              Number.parseInt(iteamDataIdData, 10)
            ) {
              autoPartDefendentDtoListValueData.splice(i, 1);
            }
          }
        }

        childData.splice(
          childData.findIndex(
            (p) =>
              Number.parseInt(p.autoPartid, 10) ===
              Number.parseInt(iteamDataIdData, 10)
          ),
          1
        );
        updateDataList.push({
          vehicleYear: vehicleDetailsDtoListData[arrayIndex].vehicleYear,
          vehicleMake: vehicleDetailsDtoListData[arrayIndex].vehicleMake,
          vehicleModel: vehicleDetailsDtoListData[arrayIndex].vehicleModel,
          vehicleDetailsId:
            vehicleDetailsDtoListData[arrayIndex].vehicleDetailsId,
          vehicleResponseId:
            vehicleDetailsDtoListData[arrayIndex].vehicleResponseId,
          selectedPartId: vehicleDetailsDtoListData[arrayIndex].selectedPartId,
          autoPartDefendentDataId:
            vehicleDetailsDtoListData[arrayIndex].autoPartDefendentDataId,
          autoPartDefendentDtoList:
            vehicleDetailsDtoListData[arrayIndex].autoPartDefendentDtoList,
          autoPartDefendentDtoListData:
            vehicleDetailsDtoListData[arrayIndex]
              .autoPartDefendentDtoListData !== undefined
              ? vehicleDetailsDtoListData[arrayIndex]
                  .autoPartDefendentDtoListData
              : [],
          autoPartDefendentDtoListValue: autoPartDefendentDtoListValueData,
          autoPartDefendentDtoListValueChildData: childData,
        });
      } else {
        updateDataList.push({
          vehicleYear: vehicleDetailsDtoListData[arrayIndex].vehicleYear,
          vehicleMake: vehicleDetailsDtoListData[arrayIndex].vehicleMake,
          vehicleModel: vehicleDetailsDtoListData[arrayIndex].vehicleModel,
          vehicleDetailsId:
            vehicleDetailsDtoListData[arrayIndex].vehicleDetailsId,
          vehicleResponseId:
            vehicleDetailsDtoListData[arrayIndex].vehicleResponseId,
          selectedPartId: vehicleDetailsDtoListData[arrayIndex].selectedPartId,
          autoPartDefendentDataId:
            vehicleDetailsDtoListData[arrayIndex].autoPartDefendentDataId !==
            undefined
              ? vehicleDetailsDtoListData[arrayIndex].autoPartDefendentDataId
              : 0,
          autoPartDefendentDtoList:
            vehicleDetailsDtoListData[arrayIndex].autoPartDefendentDtoList,
          autoPartDefendentDtoListData:
            vehicleDetailsDtoListData[arrayIndex]
              .autoPartDefendentDtoListData !== undefined
              ? vehicleDetailsDtoListData[arrayIndex]
                  .autoPartDefendentDtoListData
              : [],
          autoPartDefendentDtoListValue:
            vehicleDetailsDtoListData[arrayIndex].autoPartDefendentDtoListValue,
          autoPartDefendentDtoListValueChildData:
            vehicleDetailsDtoListData[arrayIndex]
              .autoPartDefendentDtoListValueChildData,
        });
      }
    }
    // console.log('ddddddddddddssssssssss updateDataList', updateDataList)

    this.setState({
      vehicleDetailsDtoListData: updateDataList,
      recentDataSelect: index,
      error: "",
      disclaimerAgreeState:"No"
    });
  };

  addMoreDetail = (index) => () => {
    const { vehicleDetailsDtoListData } = this.state;
    const updateDataList = [];
    let childData = [];
    let autoPartDefendentDtoListValue = [];
    for (
      let arrayIndex = 0;
      arrayIndex < vehicleDetailsDtoListData.length;
      arrayIndex++
    ) {
      // childData = vehicleDetailsDtoListData[arrayIndex].autoPartDefendentDtoListValueChildData
      if (vehicleDetailsDtoListData[arrayIndex].vehicleDetailsId === index) {
        // childData = vehicleDetailsDtoListData[arrayIndex].autoPartDefendentDtoListValueChildData
        if (
          vehicleDetailsDtoListData[arrayIndex]
            .autoPartDefendentDtoListValueChildData === undefined ||
          vehicleDetailsDtoListData[arrayIndex]
            .autoPartDefendentDtoListValueChildData.length === 0
        ) {
          autoPartDefendentDtoListValue =
            vehicleDetailsDtoListData[arrayIndex].autoPartDefendentDtoListValue;
          autoPartDefendentDtoListValue.push({
            selectedIndex: 1,
            autoPartid: 0,
            autoPartDefendentId: 0,
          });
          childData.push({
            vehicleDetailsIndex: 1,
            vehicleDetailsId:
              vehicleDetailsDtoListData[arrayIndex].vehicleDetailsId,
            vehicleResponseId:
              vehicleDetailsDtoListData[arrayIndex].vehicleResponseId,
            autoPartDefendentDtoList:
              vehicleDetailsDtoListData[arrayIndex].autoPartDefendentDtoList,
            autoPartDefendentDtoListData: [],
            autoPartid: 0,
            autoPartDefendentId: 0,
          });
        } else {
          childData =
            vehicleDetailsDtoListData[arrayIndex]
              .autoPartDefendentDtoListValueChildData;
          autoPartDefendentDtoListValue =
            vehicleDetailsDtoListData[arrayIndex].autoPartDefendentDtoListValue;
          autoPartDefendentDtoListValue.push({
            selectedIndex: Number.parseInt(
              `${childData[childData.length - 1].vehicleDetailsIndex + 1}`,
              10
            ),
            autoPartid: 0,
            autoPartDefendentId: 0,
          });
          childData.push({
            vehicleDetailsIndex: Number.parseInt(
              `${childData[childData.length - 1].vehicleDetailsIndex + 1}`,
              10
            ),
            vehicleDetailsId:
              vehicleDetailsDtoListData[arrayIndex].vehicleDetailsId,
            vehicleResponseId:
              vehicleDetailsDtoListData[arrayIndex].vehicleResponseId,
            autoPartDefendentDtoList:
              vehicleDetailsDtoListData[arrayIndex].autoPartDefendentDtoList,
            autoPartDefendentDtoListData: [],
            autoPartid: 0,
            autoPartDefendentId: 0,
          });

          // empty
        }

        updateDataList.push({
          vehicleYear: vehicleDetailsDtoListData[arrayIndex].vehicleYear,
          vehicleMake: vehicleDetailsDtoListData[arrayIndex].vehicleMake,
          vehicleModel: vehicleDetailsDtoListData[arrayIndex].vehicleModel,
          vehicleDetailsId:
            vehicleDetailsDtoListData[arrayIndex].vehicleDetailsId,
          vehicleResponseId:
            vehicleDetailsDtoListData[arrayIndex].vehicleResponseId,
          selectedPartId: vehicleDetailsDtoListData[arrayIndex].selectedPartId,
          autoPartDefendentDataId:
            vehicleDetailsDtoListData[arrayIndex].autoPartDefendentDataId,
          autoPartDefendentDtoList:
            vehicleDetailsDtoListData[arrayIndex].autoPartDefendentDtoList,
          autoPartDefendentDtoListData:
            vehicleDetailsDtoListData[arrayIndex]
              .autoPartDefendentDtoListData !== undefined
              ? vehicleDetailsDtoListData[arrayIndex]
                  .autoPartDefendentDtoListData
              : [],
          autoPartDefendentDtoListValue,
          autoPartDefendentDtoListValueChildData: childData,
        });
      } else {
        updateDataList.push({
          vehicleYear: vehicleDetailsDtoListData[arrayIndex].vehicleYear,
          vehicleMake: vehicleDetailsDtoListData[arrayIndex].vehicleMake,
          vehicleModel: vehicleDetailsDtoListData[arrayIndex].vehicleModel,
          vehicleDetailsId:
            vehicleDetailsDtoListData[arrayIndex].vehicleDetailsId,
          vehicleResponseId:
            vehicleDetailsDtoListData[arrayIndex].vehicleResponseId,
          selectedPartId: vehicleDetailsDtoListData[arrayIndex].selectedPartId,
          autoPartDefendentDataId:
            vehicleDetailsDtoListData[arrayIndex].autoPartDefendentDataId !==
            undefined
              ? vehicleDetailsDtoListData[arrayIndex].autoPartDefendentDataId
              : 0,
          autoPartDefendentDtoList:
            vehicleDetailsDtoListData[arrayIndex].autoPartDefendentDtoList,
          autoPartDefendentDtoListData:
            vehicleDetailsDtoListData[arrayIndex]
              .autoPartDefendentDtoListData !== undefined
              ? vehicleDetailsDtoListData[arrayIndex]
                  .autoPartDefendentDtoListData
              : [],
          autoPartDefendentDtoListValue:
            vehicleDetailsDtoListData[arrayIndex].autoPartDefendentDtoListValue,
          autoPartDefendentDtoListValueChildData:
            vehicleDetailsDtoListData[arrayIndex]
              .autoPartDefendentDtoListValueChildData,
        });
      }
      this.setState({
        vehicleDetailsDtoListData: updateDataList,
        recentDataSelect: index,
        error: "",
        disclaimerAgreeState:"No"
      });
    }
  };
  // nextQuestionDataApi

  reviewData = (data) => {
    const updateDataList = [];
    data.map((item) => {
      const childDtoList = [];
      const selectedChildData = [];
      const selectedPartId =
        item.selectedPartId !== undefined ? item.selectedPartId.split(",") : [];
      const autoPartDefendentDataId =
        item.selectedManufactureId !== undefined
          ? item.selectedManufactureId.split(",")
          : [];
      //  console.log('ssssssssdddddddd item autoPartDefendentDtoList',selectedPartId)
      if (item.autoPartDefendentDtoList !== undefined) {
        if (item.autoPartDefendentDtoList.length > 0) {
          for (let i = 0; i < selectedPartId.length; i++) {
            const index = item.autoPartDefendentDtoList.findIndex(
              (p) => p.autoPartid === Number.parseInt(selectedPartId[i], 10)
            );
            childDtoList.push({
              vehicleDetailsIndex: i,
              vehicleDetailsId: item.vehicleDetailsId,
              vehicleResponseId: item.vehicleResponseId,
              autoPartDefendentDtoList: item.autoPartDefendentDtoList,
              autoPartDefendentDtoListData:
                item.autoPartDefendentDtoList[index] !== undefined
                  ? item.autoPartDefendentDtoList[index]
                      .autoPartManufactureDtoList
                  : [],
              autoPartid: selectedPartId[i] !== "" ? selectedPartId[i] : 0,
              autoPartDefendentId:
                autoPartDefendentDataId[i] !== ""
                  ? autoPartDefendentDataId[i]
                  : 0,
            });
            selectedChildData.push({
              selectedIndex: i,
              autoPartid:
                selectedPartId[i] !== ""
                  ? Number.parseInt(selectedPartId[i], 10)
                  : 0,
              autoPartDefendentId:
                autoPartDefendentDataId[i] !== ""
                  ? Number.parseInt(autoPartDefendentDataId[i], 10)
                  : 0,
            });
          }
        }

        // selectedChildData.push({
        //   selectedIndex: 0,
        //   autoPartid: isNaN(Number.parseInt(selectedPartId[0], 10)) ? 0 : Number.parseInt(selectedPartId[0], 10),
        //   autoPartDefendentId: isNaN(Number.parseInt(autoPartDefendentDataId[0], 10)) ? 0 : Number.parseInt(autoPartDefendentDataId[0], 10),
        // });
        const index = item.autoPartDefendentDtoList.findIndex(
          (p) => p.autoPartid === Number.parseInt(selectedPartId[0], 10)
        );
        updateDataList.push({
          vehicleYear: item.vehicleYear,
          vehicleMake: item.vehicleMake,
          vehicleModel: item.vehicleModel,
          vehicleDetailsId: item.vehicleDetailsId,
          vehicleResponseId: item.vehicleResponseId,
          selectedPartId: selectedPartId[0] !== "" ? selectedPartId[0] : 0,
          autoPartDefendentDtoList: item.autoPartDefendentDtoList,
          autoPartDefendentDataId:
            autoPartDefendentDataId[0] !== ""
              ? Number.parseInt(autoPartDefendentDataId[0], 10)
              : 0,
          autoPartDefendentDtoListData:
            item.autoPartDefendentDtoList[index] !== undefined
              ? item.autoPartDefendentDtoList[index].autoPartManufactureDtoList
              : [],
          autoPartDefendentDtoListValue: selectedChildData,
          autoPartDefendentDtoListValueChildData: childDtoList,
        });
      } else {
        updateDataList.push({
          vehicleYear: item.vehicleYear,
          vehicleMake: item.vehicleMake,
          vehicleModel: item.vehicleModel,
          vehicleDetailsId: item.vehicleDetailsId,
          vehicleResponseId: item.vehicleResponseId,
          selectedPartId: 0,
          autoPartDefendentDtoList: [],
          autoPartDefendentDataId: 0,
          autoPartDefendentDtoListData: [],
          autoPartDefendentDtoListValue: selectedChildData,
          autoPartDefendentDtoListValueChildData: childDtoList,
        });
      }
      return true;
    });
    return updateDataList;
  };

  reviewDataReimbursement = (data, ansData, vehicleDetailList, revew) => {
    const { vehicleDataNewObject } = this.state;
    const updateDataList = [];
    // console.log('dddddddddddddddddddddddddddd revew',revew, data, ansData, vehicleDetailList.vehicleDetailsDtoList ,vehicleDataNewObject)

    if (revew !== "revew") {
      if (vehicleDataNewObject !== null && vehicleDataNewObject.length > 0) {
        vehicleDataNewObject.map((item) => {
          const reimbursementDetailsDtoListAns = [];
          // const anslength = Number.parseInt(ansData[0].answerText, 10);
          // console.log('dddddddddddddddddddddddddddd',data, ansData, vehicleDetailList ,vehicleDataNewObject)

          if (data === null) {
            ansData.map((itemReimberse) => {
              // console.log('vehicleDetailList niraj review', itemReimberse, itemReimberse.eligibilityQuestionResponseDto, ansData, vehicleDetailList);
              let ansDataSet = "";
              if (itemReimberse.eligibilityQuestionResponseDtos !== null) {
                if (vehicleDetailList.questionTypeId === 12) {
                  if (
                    itemReimberse.eligibilityQuestionResponseDtos.findIndex(
                      (itemList) => itemList.vehicleId === item.vehicleDetailsId
                    ) !== -1
                  ) {
                    ansDataSet =
                      itemReimberse.eligibilityQuestionResponseDtos[
                        itemReimberse.eligibilityQuestionResponseDtos.findIndex(
                          (itemListR) =>
                            itemListR.vehicleId === item.vehicleDetailsId
                        )
                      ].value;
                  }
                }
              }
              // console.log('itemReimberse',)
              reimbursementDetailsDtoListAns.push({
                eligibilityQuestionId: vehicleDetailList.eligibilityQuestionId,
                userId: item.userId,
                value: ansDataSet,
                eligibilityAnswerId: itemReimberse.answerId,
                vehicleId: item.vehicleDetailsId,
                answerText: itemReimberse.answerText,
                isQualify: itemReimberse.isQualify,
                placeholder: itemReimberse.placeholder,
              });
              return true;
            });
            // for (let arrayIndex = 0; arrayIndex < anslength; arrayIndex++) {
            //   reimbursementDetailsDtoListAns.push({
            //     answerId: arrayIndex,
            //     answerText: listLabel[arrayIndex] !== undefined ? listLabel[arrayIndex] : 'Reimbursement Amount',
            //     // value: '',
            //     // userId:
            //     // vehicleId
            //   //   eligibilityQuestionId
            //   //   eligibilityAnswerId

            //   //   "eligibilityQuestionId": 773,
            //   // "userId": "3953",
            //   // "value": "1000",
            //   // "eligibilityAnswerId": 1353,
            //   // "vehicleId":2362
            //   });
            // }
          } else if (data !== null) {
            data.map((iteamlist) => {
              if (iteamlist.vehicleDetailsId === item.vehicleDetailsId) {
                iteamlist.reimbursementDetailsDtoList.map(
                  (dataVechile, index) => {
                    reimbursementDetailsDtoListAns.push({
                      answerId: index,
                      answerText:
                        listLabel[index] !== undefined
                          ? listLabel[index]
                          : "Reimbursement Amount",
                      ansValue: dataVechile.reimbursementAmount,
                    });
                    return true;
                  }
                );
              }
              return true;
            });
          }
          // console.log('reimbursementDetailsDtoListAns', item);
          updateDataList.push({
            vehicleYear: item.vehicleYear,
            vehicleMake: item.vehicleMake,
            vehicleModel: item.vehicleModel,
            vehicleDetailsId: item.vehicleDetailsId,
            vehicleType: item.vehicleType,
            vin: item.vin,
            reimbursementDetailsDtoList: reimbursementDetailsDtoListAns,
          });

          return true;
        });
        // console.log('updateDataList', updateDataList);
        // return updateDataList;
      }
    } else {
      vehicleDataNewObject.map((item) => {
        const reimbursementDetailsDtoListAns = [];
        // const anslength = Number.parseInt(ansData[0].answerText, 10);
        if (data === null) {
          ansData.map((itemReimberse) => {
            // console.log('vehicleDetailList niraj review', itemReimberse, itemReimberse.eligibilityQuestionResponseDto, ansData, vehicleDetailList);
            let ansDataSet = "";
            if (itemReimberse.eligibilityQuestionResponseDtos !== null) {
              if (vehicleDetailList.questionTypeId === 12) {
                if (
                  itemReimberse.eligibilityQuestionResponseDtos.findIndex(
                    (itemList) => itemList.vehicleId === item.vehicleDetailsId
                  ) !== -1
                ) {
                  ansDataSet =
                    itemReimberse.eligibilityQuestionResponseDtos[
                      itemReimberse.eligibilityQuestionResponseDtos.findIndex(
                        (itemListR) =>
                          itemListR.vehicleId === item.vehicleDetailsId
                      )
                    ].value;
                }
              }
            }

            reimbursementDetailsDtoListAns.push({
              eligibilityQuestionId: vehicleDetailList.eligibilityQuestionId,
              userId: item.userId,
              value: ansDataSet,
              eligibilityAnswerId: itemReimberse.answerId,
              vehicleId: item.vehicleDetailsId,
              answerText: itemReimberse.answerText,
              isQualify: itemReimberse.isQualify,
            });
            return true;
          });
        } else if (data !== null) {
          data.map((iteamlist) => {
            if (iteamlist.vehicleDetailsId === item.vehicleDetailsId) {
              iteamlist.reimbursementDetailsDtoList.map(
                (dataVechile, index) => {
                  reimbursementDetailsDtoListAns.push({
                    answerId: index,
                    answerText:
                      listLabel[index] !== undefined
                        ? listLabel[index]
                        : "Reimbursement Amount",
                    ansValue: dataVechile.reimbursementAmount,
                  });
                  return true;
                }
              );
            }
            return true;
          });
        }
        updateDataList.push({
          vehicleYear: item.vehicleYear,
          vehicleMake: item.vehicleMake,
          vehicleModel: item.vehicleModel,
          vehicleDetailsId: item.vehicleDetailsId,
          vehicleType: item.vehicleType,
          vin: item.vin,
          reimbursementDetailsDtoList: reimbursementDetailsDtoListAns,
        });

        return true;
      });
    }

    // console.log('reimbursementDetailsDtoListAns', updateDataList);

    return updateDataList;
  };

  multiQuestioFunction = (questionList, type) => {
    // console.log('questionList questionList', questionList, questionList.eligibilityAnswerDto);
    const { settlementUserId } = this.state;
    const eligibilityAnswerDtoList = [];

    if (questionList.questionTypeId === 13) {
      questionList.eligibilityAnswerDto.map((item) => {
        // let ansValue = ''
        // if (item.eligibilityQuestionResponseDto !== null) {
        //   ansValue = item.eligibilityQuestionResponseDto.value;
        // }
        item.eligibilityQuestionResponseDtos &&
          item.eligibilityQuestionResponseDtos.map((iteam, index) => {
            eligibilityAnswerDtoList.push({
              answerId: item.answerId,
              answerText: item.answerText,
              isDisabled: item.isDisabled,
              isQualify: item.isQualify,
              matchValue: item.matchValue,
              placeholder: item.placeholder,
              inputType: item.inputType,
              moveToNextQuestion: item.moveToNextQuestion,
              value: iteam.value,
              review: "review",
              reviewIndex: index,
              eligibilityQuestionId: questionList.eligibilityQuestionId,
              userId: settlementUserId,
              eligibilityAnswerId: item.answerId,
            });
            return true;
          });

        return true;
      });

      if (eligibilityAnswerDtoList.length === 0) {
        eligibilityAnswerDtoList.push({
          answerId: 0,
          answerText: "",
          isDisabled: "",
          isQualify: "",
          matchValue: "",
          placeholder: "",
          inputType: "",
          moveToNextQuestion: "",
          value: "",
          review: "add",
          reviewIndex: 0,
          eligibilityQuestionId: questionList.eligibilityQuestionId,
          userId: settlementUserId,
          eligibilityAnswerId: "",
        });
      }
    } else {
      questionList.eligibilityAnswerDto.map((item) => {
        let ansValue = "";
        if (item.eligibilityQuestionResponseDto !== null) {
          ansValue = item.eligibilityQuestionResponseDto.value !== "Invalid date" ? item.eligibilityQuestionResponseDto.value : "";
        }
        eligibilityAnswerDtoList.push({
          answerId: item.answerId,
          answerText: item.answerText,
          isDisabled: item.isDisabled,
          isQualify: item.isQualify,
          matchValue: item.matchValue,
          placeholder: item.placeholder,
          inputType: item.inputType,
          moveToNextQuestion: item.moveToNextQuestion,
          value: ansValue,
          eligibilityQuestionId: questionList.eligibilityQuestionId,
          userId: settlementUserId,
          eligibilityAnswerId: item.answerId,
        });
        return true;
      });
    }

    const questtype = {
      questionText: questionList.questionText,
      eligibilityAnswerDto: eligibilityAnswerDtoList,
      questionListDto: questionList.eligibilityAnswerDto,
      eligibilityQuestionId: questionList.eligibilityQuestionId,
    };
    // console.log('sssssssssssssssss',questtype);

    return questtype;
  };

  async componentDidUpdate() {
    const {
      nextQuestionDataApi,
      recievedDataList,
      autoPartDefendentParts,
      nextQuestionSaveDataApi,
      backQuestionSaveDataApi,
      pendingSettlementDOcUser,
      vehicleData,
      vehicleDataSettlement,
      questonUploadFile
    } = this.props.data;
  
    console.log("latestone",nextQuestionSaveDataApi,backQuestionSaveDataApi)
    const {
      nextQuestionDataApi1,
      recievedDataListData,
      vehicleDataNewResponse,
      vehicleDataNewResponseData,
      childIndexDataId,
      recentDataStateChildM,
      recentDataSelect,
      vehicleDetailsDtoListData,
      AutoPartDefendentParts,
      stateId,
      stateSubmitData,
      forwardStatus,
      pendingSettlementDOc1,
      backQuestionSaveDataApi1,
      nextQuestionSaveDataApi1,
      multipleFileState,
      recordedState,
      repeatState,
      nexState,
      dupeInterCheck,
      nexxState,dupeState
    } = this.state;
    const {
      match: { params },
    } = this.props;
  
    const updateDataList = [];
    let childData = [];
    console.log("questonUploadFile",questonUploadFile,nextQuestionDataApi);
    if(  recordedState === true && this.props.data.questonUploadFile && this.props.data.questonUploadFile["id"] && repeatState !== this.props.data.questonUploadFile){
      console.log("seaa",this.props.data.questonUploadFile,typeof this.props.data.questonUploadFile);
      const a= [];
      a.push(this.props.data.questonUploadFile);
      this.setState({multipleFileState:[...this.state.multipleFileState,...a],recordedState:false,repeatState:this.props.data.questonUploadFile,loaded:false})
      console.log("sea",multipleFileState)
    }
    console.log("set",multipleFileState);
      if(nexState === true && this.props.data.nextQuestionSaveDataApi && this.props.data.nextQuestionSaveDataApi["userEligibilityQuestionData"] ){
        let a= [];
        // a.push(this.props.data.nextQuestionDataApi["userEligibilityQuestionData"])
        a= [...this.props.data.nextQuestionSaveDataApi["userEligibilityQuestionData"]]
        this.setState({multipleFileState: [...this.state.multipleFileState,...a],nexState:false,optionalNotesTextState: this.props.data.nextQuestionSaveDataApi["optionalNotesData"]});
      console.log("gg",this.state.multipleFileState)
    }
   if(dupeInterCheck === true && this.props.data.nextQuestionSaveDataApi && this.props.data.nextQuestionSaveDataApi["questionTypeId"] === 14){
    let a =this.props.data.nextQuestionSaveDataApi.disclaimerAgree == "No" ?false : true;
    console.log("inside",a,this.props.data.nextQuestionSaveDataApi.disclaimerAgree);
     this.setState({interCheck:a,dupeInterCheck:false})
   }
    if(nexxState === true && backQuestionSaveDataApi && backQuestionSaveDataApi["userEligibilityQuestionData" ] && dupeState !== backQuestionSaveDataApi.eligibilityQuestionId){
      console.log("inn",backQuestionSaveDataApi)
      let a= [];
      
      // a.push(this.props.data.nextQuestionDataApi["userEligibilityQuestionData"])
      a= [...this.props.data.backQuestionSaveDataApi["userEligibilityQuestionData"]]
      this.setState({multipleFileState: [...this.state.multipleFileState,...a],optionalNotesTextState: this.props.data.backQuestionSaveDataApi["optionalNotesData"],dupeState:backQuestionSaveDataApi.eligibilityQuestionId ,nexxState:false});
    console.log("gg",this.state.multipleFileState)
  }
    if (recievedDataListData !== recievedDataList) {
      this.setState({
        recievedDataListData: recievedDataList,
      });
      const data = {
        userId: this.state.settlementUserId,
        settlementId: params.eid,
      };

      this.props.getAllVehicleDataByUserIdAPI(data);
      // this.props.getAllVehicleDataSettlementByUserIdAPI(data);
    }

    if (vehicleDataSettlement !== undefined) {
      if (vehicleDataSettlement !== vehicleDataNewResponse) {
        const vehicleDtoList = [];
        vehicleDataSettlement.map((item) => {
          vehicleDtoList.push({
            userId: this.state.settlementUserId,
            // vehicleCost: item.vehicleCost,
            vehicleDataId: item.vehicleDataId,
            vehicleDetailsId: item.vehicleDetailsId,
            vehicleMake: item.vehicleMake,
            vehicleModel: item.vehicleModel,
            vehicleType: item.vehicleType,
            vehicleYear: item.vehicleYear,
            vin: item.vin,
            soldDate: item.soldDate,
            fromInfutor: item.fromInfutor,
            // purchaseDate: item.purchaseDate,
          });
          return true;
        });

        this.setState({
          vehicleDataNewResponse: vehicleDataSettlement,
          vehicleDataNewObject: vehicleDtoList,
          // vehicleOptions: vehicleData.records,
          loaded:
            nextQuestionSaveDataApi !== undefined
              ? nextQuestionSaveDataApi.questionTypeId !== 12
                ? false
                : true
              : true,
        });
        if (
          nextQuestionDataApi.length === 0 ||
          nextQuestionDataApi[0] === "false" ||
          nextQuestionDataApi[0] === "a"
        ) {
          await this.setState({
            loaded: false,
          });
        }
      }
    }

    if (vehicleData !== undefined && vehicleData.records !== undefined) {
      if (vehicleData.records !== vehicleDataNewResponseData) {
        const vehicleDto = [];
        vehicleData.records.map((item) => {
          vehicleDto.push({
            userId: this.state.settlementUserId,
            vehicleCost: item.vehicleCost,
            vehicleDataId: item.vehicleDataId,
            vehicleDetailsId: item.vehicleDetailsId,
            vehicleMake: item.vehicleMake,
            vehicleModel: item.vehicleModel,
            vehicleType: item.vehicleType,
            vehicleYear: item.vehicleYear,
            vin: item.vin,
            soldDate: item.soldDate,
            purchaseDate: item.purchaseDate,
            fromInfutor: item.fromInfutor,
          });
          return true;
        });

        this.setState({
          vehicleDataNewResponseData: vehicleData.records,
          vehicleOptions: vehicleDto,
          loaded:
            nextQuestionSaveDataApi !== undefined
              ? nextQuestionSaveDataApi.questionTypeId === 8 ||
                nextQuestionDataApi.questionTypeId === 8
                ? false
                : false
              : nextQuestionDataApi.length === 0
              ? false
              : false,
        });
        if (
          nextQuestionDataApi.length === 0 ||
          nextQuestionDataApi[0] === "false" ||
          nextQuestionDataApi[0] === "a"
        ) {
          await this.setState({
            loaded: false,
          });
        }
      }
    }

    if (autoPartDefendentParts !== AutoPartDefendentParts) {
      if (recentDataStateChildM === "Child") {
        for (
          let arrayIndex = 0;
          arrayIndex < vehicleDetailsDtoListData.length;
          arrayIndex++
        ) {
          if (
            vehicleDetailsDtoListData[arrayIndex].vehicleDetailsId ===
            recentDataSelect
          ) {
            childData =
              vehicleDetailsDtoListData[arrayIndex]
                .autoPartDefendentDtoListValueChildData;
            for (let i = 0; i < childData.length; i++) {
              if (childData[i].vehicleDetailsIndex === childIndexDataId) {
                childData[
                  i
                ].autoPartDefendentDtoListData = autoPartDefendentParts;
              }
            }
            updateDataList.push({
              vehicleYear: vehicleDetailsDtoListData[arrayIndex].vehicleYear,
              vehicleMake: vehicleDetailsDtoListData[arrayIndex].vehicleMake,
              vehicleModel: vehicleDetailsDtoListData[arrayIndex].vehicleModel,
              vehicleDetailsId:
                vehicleDetailsDtoListData[arrayIndex].vehicleDetailsId,
              vehicleResponseId:
                vehicleDetailsDtoListData[arrayIndex].vehicleResponseId,
              selectedPartId:
                vehicleDetailsDtoListData[arrayIndex].selectedPartId,
              autoPartDefendentDtoList:
                vehicleDetailsDtoListData[arrayIndex].autoPartDefendentDtoList,
              autoPartDefendentDataId:
                vehicleDetailsDtoListData[arrayIndex]
                  .autoPartDefendentDataId !== undefined
                  ? vehicleDetailsDtoListData[arrayIndex]
                      .autoPartDefendentDataId
                  : 0,
              autoPartDefendentDtoListData:
                vehicleDetailsDtoListData[arrayIndex]
                  .autoPartDefendentDtoListData !== undefined
                  ? vehicleDetailsDtoListData[arrayIndex]
                      .autoPartDefendentDtoListData
                  : [],
              autoPartDefendentDtoListValue:
                vehicleDetailsDtoListData[arrayIndex]
                  .autoPartDefendentDtoListValue !== undefined
                  ? vehicleDetailsDtoListData[arrayIndex]
                      .autoPartDefendentDtoListValue
                  : [],
              autoPartDefendentDtoListValueChildData: childData,
            });
          } else {
            updateDataList.push({
              vehicleYear: vehicleDetailsDtoListData[arrayIndex].vehicleYear,
              vehicleMake: vehicleDetailsDtoListData[arrayIndex].vehicleMake,
              vehicleModel: vehicleDetailsDtoListData[arrayIndex].vehicleModel,
              vehicleDetailsId:
                vehicleDetailsDtoListData[arrayIndex].vehicleDetailsId,
              vehicleResponseId:
                vehicleDetailsDtoListData[arrayIndex].vehicleResponseId,
              selectedPartId:
                vehicleDetailsDtoListData[arrayIndex].selectedPartId,
              autoPartDefendentDtoList:
                vehicleDetailsDtoListData[arrayIndex].autoPartDefendentDtoList,
              autoPartDefendentDataId:
                vehicleDetailsDtoListData[arrayIndex]
                  .autoPartDefendentDataId !== undefined
                  ? vehicleDetailsDtoListData[arrayIndex]
                      .autoPartDefendentDataId
                  : 0,
              autoPartDefendentDtoListData:
                vehicleDetailsDtoListData[arrayIndex]
                  .autoPartDefendentDtoListData !== undefined
                  ? vehicleDetailsDtoListData[arrayIndex]
                      .autoPartDefendentDtoListData
                  : [],
              autoPartDefendentDtoListValue:
                vehicleDetailsDtoListData[arrayIndex]
                  .autoPartDefendentDtoListValue !== undefined
                  ? vehicleDetailsDtoListData[arrayIndex]
                      .autoPartDefendentDtoListValue
                  : [],
              autoPartDefendentDtoListValueChildData:
                vehicleDetailsDtoListData[arrayIndex]
                  .autoPartDefendentDtoListValueChildData,
            });
          }
          // if (childData[childIndexDataId-1].vehicleDetailsIndex === recentDataSelect) {
          // }
        }
      } else {
        for (
          let arrayIndex = 0;
          arrayIndex < vehicleDetailsDtoListData.length;
          arrayIndex++
        ) {
          if (
            vehicleDetailsDtoListData[arrayIndex].vehicleDetailsId ===
            recentDataSelect
          ) {
            updateDataList.push({
              vehicleYear: vehicleDetailsDtoListData[arrayIndex].vehicleYear,
              vehicleMake: vehicleDetailsDtoListData[arrayIndex].vehicleMake,
              vehicleModel: vehicleDetailsDtoListData[arrayIndex].vehicleModel,
              vehicleDetailsId:
                vehicleDetailsDtoListData[arrayIndex].vehicleDetailsId,
              vehicleResponseId:
                vehicleDetailsDtoListData[arrayIndex].vehicleResponseId,
              selectedPartId:
                vehicleDetailsDtoListData[arrayIndex].selectedPartId,
              autoPartDefendentDtoList:
                vehicleDetailsDtoListData[arrayIndex].autoPartDefendentDtoList,
              autoPartDefendentDtoListData: autoPartDefendentParts,
              autoPartDefendentDataId:
                vehicleDetailsDtoListData[arrayIndex]
                  .autoPartDefendentDataId !== undefined
                  ? vehicleDetailsDtoListData[arrayIndex]
                      .autoPartDefendentDataId
                  : 0,
              autoPartDefendentDtoListValue:
                vehicleDetailsDtoListData[arrayIndex]
                  .autoPartDefendentDtoListValue !== undefined
                  ? vehicleDetailsDtoListData[arrayIndex]
                      .autoPartDefendentDtoListValue
                  : [],
              autoPartDefendentDtoListValueChildData:
                vehicleDetailsDtoListData[arrayIndex]
                  .autoPartDefendentDtoListValueChildData,
            });
          } else {
            updateDataList.push({
              vehicleYear: vehicleDetailsDtoListData[arrayIndex].vehicleYear,
              vehicleMake: vehicleDetailsDtoListData[arrayIndex].vehicleMake,
              vehicleModel: vehicleDetailsDtoListData[arrayIndex].vehicleModel,
              vehicleDetailsId:
                vehicleDetailsDtoListData[arrayIndex].vehicleDetailsId,
              vehicleResponseId:
                vehicleDetailsDtoListData[arrayIndex].vehicleResponseId,
              selectedPartId:
                vehicleDetailsDtoListData[arrayIndex].selectedPartId,
              autoPartDefendentDtoList:
                vehicleDetailsDtoListData[arrayIndex].autoPartDefendentDtoList,
              autoPartDefendentDataId:
                vehicleDetailsDtoListData[arrayIndex]
                  .autoPartDefendentDataId !== undefined
                  ? vehicleDetailsDtoListData[arrayIndex]
                      .autoPartDefendentDataId
                  : 0,
              autoPartDefendentDtoListData:
                vehicleDetailsDtoListData[arrayIndex]
                  .autoPartDefendentDtoListData !== undefined
                  ? vehicleDetailsDtoListData[arrayIndex]
                      .autoPartDefendentDtoListData
                  : [],
              autoPartDefendentDtoListValue:
                vehicleDetailsDtoListData[arrayIndex]
                  .autoPartDefendentDtoListValue !== undefined
                  ? vehicleDetailsDtoListData[arrayIndex]
                      .autoPartDefendentDtoListValue
                  : [],
              autoPartDefendentDtoListValueChildData:
                vehicleDetailsDtoListData[arrayIndex]
                  .autoPartDefendentDtoListValueChildData,
            });
          }
        }
      }

      this.setState({
        AutoPartDefendentParts: autoPartDefendentParts,
        vehicleDetailsDtoListData: updateDataList,
        loaded: false,
      });
    }

    if (pendingSettlementDOcUser !== pendingSettlementDOc1) {
      if (pendingSettlementDOcUser !== undefined) {
        if (pendingSettlementDOcUser.length > 0) {
          // this.setState({
          //     skipUploadDoc1:2
          // })
        }
        this.setState({
          pendingSettlementDOc1: pendingSettlementDOcUser,
        });
      }
    }
    if (stateSubmitData === true) {
      let multipleIputTypeQuestionLsit = [];
      let a = [];
      if (forwardStatus === 1) {
        if (stateId === 1) {
          if (nextQuestionDataApi !== undefined) {
            if (nextQuestionDataApi !== nextQuestionDataApi1) {
              
              a.push(nextQuestionDataApi.userEligibilityQuestionData)
              let b = a.slice();
    
              console.log("aap",a,b,b[0])
              console.log("aaap",typeof nextQuestionDataApi.eligibilityAnswerDto, nextQuestionDataApi.userEligibilityQuestionData)
              if (
                nextQuestionDataApi.questionTypeId === 7 ||
                nextQuestionDataApi.questionTypeId === 13 || 
                nextQuestionDataApi.questionTypeId === 15
              ) {
                multipleIputTypeQuestionLsit = this.multiQuestioFunction(
                  nextQuestionDataApi,
                  nextQuestionDataApi.questionTypeId
                );
              }

              this.setState({
                nextQuestionDataApi1: nextQuestionDataApi,
                multipleIputTypeQuestion: multipleIputTypeQuestionLsit,
                // counterQuesr:nextQuestionDataApi.questionOrder,
                enrollmentId: nextQuestionDataApi.enrollmentId,
                recentAnswer: [],
                multipleInputOptionsData: [],
                resentData: 1,
                renderState: 1,
                // loaded: false,
                showLastQusetion: nextQuestionDataApi.length === 0,
                multipleFileState:b[0],
                optionalNotesTextState:nextQuestionDataApi.optionalNotesData
                // recentAnswerState:nextQuestionDataApi.eligibilityAnswerDto[0].eligibilityQuestionResponseDto[0].value
                // stateId:2,
              });
             
            }
          }
        } else if (nextQuestionSaveDataApi !== undefined) {
          if (nextQuestionSaveDataApi1 !== nextQuestionSaveDataApi) {
            let result = [];
            let resultReimbursement = [];
            if (
              nextQuestionSaveDataApi.vehicleDetailsDtoWithAllPartAndManfactureList !==
              undefined
            ) {
              if (
                nextQuestionSaveDataApi.vehicleDetailsDtoWithAllPartAndManfactureList !==
                null
              ) {
                result = this.reviewData(
                  nextQuestionSaveDataApi.vehicleDetailsDtoWithAllPartAndManfactureList
                );
              }
            }
            if (
              nextQuestionSaveDataApi.vehicleDetailsDtoWithReimburseDetailList !==
              undefined
            ) {
              if (nextQuestionSaveDataApi.questionLeft !== "N") {
                resultReimbursement = await this.reviewDataReimbursement(
                  nextQuestionSaveDataApi.vehicleDetailsDtoWithReimburseDetailList,
                  nextQuestionSaveDataApi.eligibilityAnswerDto,
                  nextQuestionSaveDataApi,
                  "next"
                );
                await this.setState({
                  loaded: false,
                });
              }
            }
            if (
              nextQuestionSaveDataApi.questionTypeId === 7 ||
              nextQuestionSaveDataApi.questionTypeId === 13 || 
              nextQuestionSaveDataApi.questionTypeId === 15
            ) {
              multipleIputTypeQuestionLsit = this.multiQuestioFunction(
                nextQuestionSaveDataApi,
                nextQuestionDataApi.questionTypeId
              );
            }

            // console.log('resultReimbursement',resultReimbursement)
            // vehicleDetailsDtoList
            this.setState({
              nextQuestionDataApi1: nextQuestionSaveDataApi,
              nextQuestionSaveDataApi1: nextQuestionSaveDataApi,
              answerIdLatestQ: "",
              answerTextLatestQ: "",
              recentAnswer: [],
              multipleInputOptionsData: [],
              multipleIputTypeQuestion: multipleIputTypeQuestionLsit,

              // counterQuesr:nextQuestionSaveDataApi.questionOrder,
              enrollmentId: nextQuestionSaveDataApi.enrollmentId,
              resentData: 1,
              renderState: 1,
              vehicleDetailsDtoListData:
                result.length > 0
                  ? result
                  : nextQuestionSaveDataApi.vehicleDetailsDtoList,
              reimbursementDetailsDtoListDta:
                resultReimbursement.length > 0
                  ? resultReimbursement
                  : nextQuestionSaveDataApi.vehicleDetailsDtoList,
              // loaded: isloadedStatus,
            });
            if (
              nextQuestionSaveDataApi1 !== nextQuestionSaveDataApi &&
              nextQuestionSaveDataApi.questionLeft === "N"
            ) {
              await this.setState({
                loaded: false,
              });
            }
          }
        }
      } else if (forwardStatus === 3) {
        // empty
      } else if (backQuestionSaveDataApi !== undefined) {
        if (backQuestionSaveDataApi1 !== backQuestionSaveDataApi) {
          let result = [];
          let resultReimbursement = [];

          if (
            backQuestionSaveDataApi.vehicleDetailsDtoWithAllPartAndManfactureList !==
            undefined
          ) {
            if (
              backQuestionSaveDataApi.vehicleDetailsDtoWithAllPartAndManfactureList !==
              null
            ) {
              result = this.reviewData(
                backQuestionSaveDataApi.vehicleDetailsDtoWithAllPartAndManfactureList
              );
            }
          }
          if (backQuestionSaveDataApi.eligibilityAnswerDto !== undefined) {
            resultReimbursement = this.reviewDataReimbursement(
              backQuestionSaveDataApi.vehicleDetailsDtoWithReimburseDetailList,
              backQuestionSaveDataApi.eligibilityAnswerDto,
              backQuestionSaveDataApi,
              "revew"
            );
          }
          if (
            backQuestionSaveDataApi.questionTypeId === 7 ||
            backQuestionSaveDataApi.questionTypeId === 13 ||
            backQuestionSaveDataApi.questionTypeId === 15
          ) {
            multipleIputTypeQuestionLsit = this.multiQuestioFunction(
              backQuestionSaveDataApi,
              nextQuestionDataApi.questionTypeId
            );
          }

          this.setState({
            nextQuestionDataApi1: backQuestionSaveDataApi,
            backQuestionSaveDataApi1: backQuestionSaveDataApi,
            answerIdLatestQ: "",
            answerTextLatestQ: "",
            recentAnswer: [],
            multipleInputOptionsData: [],
            multipleIputTypeQuestion: multipleIputTypeQuestionLsit,

            // counterQuesr:backQuestionSaveDataApi.questionOrder,
            enrollmentId: backQuestionSaveDataApi.enrollmentId,
            resentData: 1,
            renderState: 1,
            // loaded: false,
            vehicleDetailsDtoListData: result,
            reimbursementDetailsDtoListDta: resultReimbursement,
          });
        }
      }
    }
  }

  completeSteps() {
    if (this.state.uploadCount !== this.state.RequireDocCount) {
      this.setState({
        UploadError: true,
        // modalIsOpen: false
      });
    } else {
      this.setState({
        success: true,
        UploadError: false,
        skipUploadDoc1: 1,
      });
    }

    // this.setState({modalIsOpen: true});
  }

  openModal() {
    this.setState({ modalIsOpen: true });
  }

  afterOpenModal() {
    // references are now sync'd and can be accessed.
    // this.subtitle.style.color = '#f00';
  }

  // term and policy
  isValidTermPolicy() {
    const {
      errorsTermPolicy,
      isValidTermPolicy,
    } = this.validateInputTermPolicy(this.state);

    if (!isValidTermPolicy) {
      this.setState({ errorsTermPolicy });
    }
    return isValidTermPolicy;
  }

  validateInputTermPolicy(data) {
    const errorsTermPolicy = {};
    if (data.acceptTermCondition === 0) {
      errorsTermPolicy.acceptTermCondition = "required";
      errorsTermPolicy.acceptTermConditionError = true;
    }

    if (data.allowFileCliam === 0) {
      errorsTermPolicy.allowFileCliam = "required";
      errorsTermPolicy.allowFileCliamError = true;
    }

    return {
      errorsTermPolicy,
      isValidTermPolicy: isEmpty(errorsTermPolicy),
    };
  }
  uploadFileDeleteHandler(e){
    let val = e;
    const dupe = [...this.state.multipleFileState];
   const indexx =  this.state.multipleFileState.
   findIndex(res=>
      res.id === val
    );
    const del = dupe.splice(indexx,1)
    console.log("poppeye",e,indexx)
    this.setState({fileNameState:"",multipleFileState:dupe});
    this.props.deleteEligibilityQuestionFileByUser({questionDataId:e});

  }
  closeModal() {
    this.setState({ modalIsOpen: false });
  }
  handleCheck = () => {
    this.setState({ interCheck: !this.state.interCheck });
    console.log("this.state.interCheck", this.state.interCheck);
  };

  inputSelctorOptionsOne = (jsDate, dateString) => {
    console.log("time", jsDate);
    this.setState({
      claimPeriodStart: jsDate,
    });
  };
  handleChangeFile(evt,info) {
    console.log("yuo",evt)
    let file = evt.target.files[0];
    console.log("ff",file)
    if(file !== undefined){
    let fileExtension = file.name.split(".").pop();
    console.log("file",file,info,fileExtension,file.name);
    info.fileType = fileExtension;
    info.fileName = file.name;
    info.file = file;
    this.setState({fileNameState:info.fileName,recordedState:true,loaded:true});

    // this.setState({ fileNameState: true });
    // console.log("g", file);
    // if (fileExtension === "xlsx") {
    //   this.setState({ fileName: file.name,fileDraw : file }, () => {
    //     // console.log("this",this.state.fileDraw)
    //   });
      
    // } else
    //   this.setState({ fileName: "Please select the file of .xlsx format" });
    // console.log("asdasd file ", fileExtension);
    const newFileDocument = this.state.documentList.map((document, sidx) => {
      return {
         documentFile: file,
      };
    });
   console.log("info",info)
    this.setState({ documentList: newFileDocument });
    if(file.name !== ""){
    this.props.uploadEligibilityQuestionFileByUser(info)
    }
  }
    // evt.target.value = null;
  } 
 
  render() {
    const {
      nextQuestionDataApi1,
      settlementName,
      categoryImage,
      vehicleOptions,
      error,
      UserName,
      totalNumberOfQuestions,
      vehicleDataNewObject,
      multipleIputTypeQuestion,
      loaded,
      fileNameState,
      multipleFileState,
      optionalNotesTextState,
      interCheck
    } = this.state;
    console.log("pojo",this.state.optionalNotesTextState,optionalNotesTextState)
    const {
      match: { params },
    } = this.props;
    let a = {};
    let e = [];
    let success = this.state.success;
    let PopErrorNotAllowedToMove = this.state.PopErrorNotAllowedToMove;
    let PopErrorNotAllowedToMoveE = this.state.PopErrorNotAllowedToMoveE;
    const currentQuestionBody = [];
    let questionNumber = this.state.questionNumber;
    let questionTypeCheck = false;
    let loader1;

    if (loaded) {
      loader1 = (
        <div className="loader">
          <img src={loader} alt="" />
        </div>
      );
    }
    if (nextQuestionDataApi1.questionLeft === "Y") {
      // if (nextQuestionDataApi1.isMandatory === 0) {
      //   stateButtonShowSkip = true;
      // }
      questionNumber = nextQuestionDataApi1.questionOrder;
      if (nextQuestionDataApi1.questionTypeId === 9) {
        const QuestionInfo = nextQuestionDataApi1;
        const questionText = nextQuestionDataApi1.questionText;
        const optText = QuestionInfo.optionalNotesData;
        const optionalNotesText = QuestionInfo.showOptionalNotesText !== "" ? parse(QuestionInfo.showOptionalNotesText) : "";
        const optionsOne = [];
        
        const options = [];
        const uploadOneFile = []; 
        const uploadLabel = QuestionInfo.allowFileUpload === 1 && QuestionInfo.allowFileUploadText !== "" ? QuestionInfo.allowFileUploadText : "";
        const optionTable =[];
        const optionTables = [];
          console.log("questonUploadFilez",this.props.data.questonUploadFile,typeof this.props.data.questonUploadFile)
          const optName = [];
          if(multipleFileState.length>0){
            multipleFileState.map(res=>{
          
              optName.push(
                <div className="joclasss"> 
                {/* <p>{res.uploadedFileName.split('.')[0]}</p> */}
                <p>{res.uploadedFileName.substr(0, res.uploadedFileName.lastIndexOf("\."))}</p>
                </div>
              );
                  optionTable.push(
                    <div className="joclasss">
                    <a target="blank" href={res.uploadedFilePath}>Click here to view file</a>
                    </div>
      
                  );
                  optionTables.push(
                      <div className="joclass">
                        <Tooltip id="tooltip-icon" title="Delete">
                        <Icon onClick={()=>this.uploadFileDeleteHandler(res.id)}>delete</Icon>
                      </Tooltip>
                      </div>
                      )
              
            })
          }
          if (loaded) {
            loader1 = (
              <div className="loader">
                <img src={loader} alt="" />
              </div>
            );
          }
          //   if( this.props.data.questonUploadFile && QuestionInfo.eligibilityQuestionId === this.props.data.questonUploadFile["eligibilityQuestionId"]){
        //     optionTable.push(
        //       <a target="blank" href={this.props.data.questonUploadFile["uploadedFilePath"]}>Click here to view file</a>

        //     )
        // }
        // if( this.props.data.questonUploadFile && QuestionInfo.eligibilityQuestionId === this.props.data.questonUploadFile["eligibilityQuestionId"]){
        //   optionTables.push(
      
        //     <Tooltip id="tooltip-icon" title="Delete">
        //     <Icon onClick={()=>this.uploadFileDeleteHandler(this.props.data.questonUploadFile["id"])}>delete</Icon>
        //   </Tooltip>
        //   )}
        const dataa = {
          settlementId:QuestionInfo.settlementId,
          fileType:"",
          fileName:"",
          userId:this.state.settlementUserId,
          eligibilityQuestionId:QuestionInfo.eligibilityQuestionId,
          file :""
        };              
       
        const optionsList = [];
          if(QuestionInfo.allowFileUpload === 1){
            uploadOneFile.push(
              <div>
                  <input
                              id="contained-button-file"
                              type="file"
                              name="recentAnswerTwo"
                              style={{ width: "94px" }}
                              onChange={(e) => this.handleChangeFile(e,dataa)}
              // <input
              //   type="file"
                
                // value={this.state.recentAnswerState}
                // onChange={this.inputSelctorOptions}
                
              />
            </div>
            )
          }
        if (QuestionInfo.showOptionalNotes === 1) {
          optionsOne.push(
            <div >
              <textarea
              style={{width:"98%",height:"80px",marginBottom:"25px",border: "2px solid #03a4f1"}}
                type="text"
                name="recentAnswerOne"
                value = {this.state.optionalNotesTextState}
                // value={optText !== null &&  this.state.optionalNotesTextState === ""  ? optText : this.state.optionalNotesTextState}
                onChange={this.inputSelctorOptionsNotes}
              />
              {/* <ReactQuill/> */}
            </div>
          );
        }
        
        currentQuestionBody.push(
          <span key="q1">
            <QuestionComponent
              questionText={parse(questionText)}
              QuestionOptions={options}
              questionNotesText = {optionalNotesText}
              questionInput = {optionsOne}
              templatePath={nextQuestionDataApi1.templatePath}
              questionLabel = {uploadLabel}
              questionName ={optName}
              questionFile = {uploadOneFile}
              questionTable = {optionTable}
              questionTables = {optionTables}
              attachTemplateText={nextQuestionDataApi1.attachTemplateText}
            />
          </span>
        );
      }

      if (nextQuestionDataApi1.questionTypeId === 2) {
        const QuestionInfo = nextQuestionDataApi1;
        const AnswerOptions = QuestionInfo.eligibilityAnswerDto;
        const questionText = QuestionInfo.questionText;
        const optText = QuestionInfo.optionalNotesData;
        const optionalNotesText = QuestionInfo.showOptionalNotesText !== "" ? parse(QuestionInfo.showOptionalNotesText):"";
        const optionsOne = [];
        const options = [];
        const uploadOneFile = []; 
        const uploadLabel = QuestionInfo.allowFileUpload === 1 && QuestionInfo.allowFileUploadText !== "" ? QuestionInfo.allowFileUploadText : "";
        const optionTable =[];
        const optionTables = [];
          console.log("questonUploadFilez",this.props.data.questonUploadFile,typeof this.props.data.questonUploadFile)
          const optName = [];
          if(multipleFileState.length>0){
            multipleFileState.map(res=>{
          
              optName.push(
                <div className="joclasss">
                {/* <p>{res.uploadedFileName.split('.')[0]}</p> */}
                <p>{res.uploadedFileName.substr(0, res.uploadedFileName.lastIndexOf("\."))}</p>
                </div>
              );
                  optionTable.push(
                    <div className="joclasss">
                    <a target="blank" href={res.uploadedFilePath}>Click here to view file</a>
                    </div>
      
                  );
                  optionTables.push(
                      <div className="joclass">
                        <Tooltip id="tooltip-icon" title="Delete">
                        <Icon onClick={()=>this.uploadFileDeleteHandler(res.id)}>delete</Icon>
                      </Tooltip>
                      </div>
                      )
              
            })
          }
          if (loaded) {
            loader1 = (
              <div className="loader">
                <img src={loader} alt="" />
              </div>
            );
          }
          //   if( this.props.data.questonUploadFile && QuestionInfo.eligibilityQuestionId === this.props.data.questonUploadFile["eligibilityQuestionId"]){
        //     optionTable.push(
        //       <a target="blank" href={this.props.data.questonUploadFile["uploadedFilePath"]}>Click here to view file</a>

        //     )
        // }
        // if( this.props.data.questonUploadFile && QuestionInfo.eligibilityQuestionId === this.props.data.questonUploadFile["eligibilityQuestionId"]){
        //   optionTables.push(
      
        //     <Tooltip id="tooltip-icon" title="Delete">
        //     <Icon onClick={()=>this.uploadFileDeleteHandler(this.props.data.questonUploadFile["id"])}>delete</Icon>
        //   </Tooltip>
        //   )}
        const dataa = {
          settlementId:QuestionInfo.settlementId,
          fileType:"",
          fileName:"",
          userId:this.state.settlementUserId,
          eligibilityQuestionId:QuestionInfo.eligibilityQuestionId,
          file :""
        };              
       
        const optionsList = [];
          if(QuestionInfo.allowFileUpload === 1){
            uploadOneFile.push(
              <div>
                  <input
                              id="contained-button-file"
                              type="file"
                              name="recentAnswerTwo"
                              style={{ width: "94px" }}
                              onChange={(e) => this.handleChangeFile(e,dataa)}
              // <input
              //   type="file"
                
                // value={this.state.recentAnswerState}
                // onChange={this.inputSelctorOptions}
                
              />
            </div>
            )
          }
        if (QuestionInfo.showOptionalNotes === 1) {
          optionsOne.push(
            <div >
              <textarea
                type="text"
                name="recentAnswerOne"
                style={{height:"80px",width:"98%",marginBottom:"25px",border: "2px solid #03a4f1"}}
                value = {this.state.optionalNotesTextState}
                // value={optText !== null &&  this.state.optionalNotesTextState === ""  ? optText : this.state.optionalNotesTextState}
                onChange={this.inputSelctorOptionsNotes}
              />
              {/* <ReactQuill/> */}
            </div>
          );
        }
        AnswerOptions.map((item, index) => {
          if (item.eligibilityQuestionResponseDto !== null) {
            if (this.state.recentAnswer.length === 0) {
              if (
                item.eligibilityQuestionResponseDto.eligibilityAnswerId !==
                undefined
              ) {
                this.state.recentAnswer.push(
                  item.eligibilityQuestionResponseDto.eligibilityAnswerId
                );
                this.state.radioDupeState.push( item.eligibilityQuestionResponseDto.eligibilityAnswerId);
              }
            }
          }

          if (item.isDisabled !== 1) {
            options.push(
              <span key={index}>
                <a
                  className={
                    this.state.recentAnswer.indexOf(item.answerId) > -1
                      ? "button active"
                      : "button"
                  }
                  onClick={() =>
                    this.radioSelectOption(item.answerId, item.answerText)
                  }
                >
                  {item.answerText}
                </a>
              </span>
            );
          }
          // if (item.showOptionalNotes === 1) {
          //   optionsOne.push(
          //     <div key={index}>
          //       <input
          //         type="text"
          //         name="recentAnswerOne"
          //         value={this.state.optionalNotesTextState}
          //         onChange={this.inputSelctorOptionsNotes}
          //       />
          //       {/* <ReactQuill/> */}
          //     </div>
          //   );
          // }
          return true;
        });
        currentQuestionBody.push(
          <span key="q1">
            <QuestionComponent
              questionText={parse(questionText)}
              QuestionOptions={options}
              questionNotesText = {optionalNotesText}
              questionInput = {optionsOne}
              templatePath={nextQuestionDataApi1.templatePath}
              questionLabel = {uploadLabel}
              questionName ={optName}
              questionFile = {uploadOneFile}
              questionTable = {optionTable}
              questionTables = {optionTables}
              attachTemplateText={nextQuestionDataApi1.attachTemplateText}
            />
          </span>
        );
      }
      if (nextQuestionDataApi1.questionTypeId === 4) {
        const QuestionInfo = nextQuestionDataApi1;
        const AnswerOptions = QuestionInfo.eligibilityAnswerDto;
        const questionText = QuestionInfo.questionText;
        const optText = QuestionInfo.optionalNotesData;
        const optionalNotesText = QuestionInfo.showOptionalNotesText !== "" ? parse(QuestionInfo.showOptionalNotesText) :"";
        const optionsOne = [];
        const options = [];
        const uploadOneFile = []; 
        const uploadLabel = QuestionInfo.allowFileUpload === 1 && QuestionInfo.allowFileUploadText !== "" ? QuestionInfo.allowFileUploadText : "";
        const optionTable =[];
        const optionTables = [];
          console.log("questonUploadFilez",this.props.data.questonUploadFile,typeof this.props.data.questonUploadFile)
          const optName = [];
          if(multipleFileState.length>0){
            multipleFileState.map(res=>{
          
              optName.push(
                <div className="joclasss">
                {/* <p>{res.uploadedFileName.split('.')[0]}</p> */}
                <p>{res.uploadedFileName.substr(0, res.uploadedFileName.lastIndexOf("\."))}</p>
                </div>
              );
                  optionTable.push(
                    <div className="joclasss">
                    <a target="blank" href={res.uploadedFilePath}>Click here to view file</a>
                    </div>
      
                  );
                  optionTables.push(
                      <div className="joclass">
                        <Tooltip id="tooltip-icon" title="Delete">
                        <Icon onClick={()=>this.uploadFileDeleteHandler(res.id)}>delete</Icon>
                      </Tooltip>
                      </div>
                      )
              
            })
          }
          if (loaded) {
            loader1 = (
              <div className="loader">
                <img src={loader} alt="" />
              </div>
            );
          }
          //   if( this.props.data.questonUploadFile && QuestionInfo.eligibilityQuestionId === this.props.data.questonUploadFile["eligibilityQuestionId"]){
        //     optionTable.push(
        //       <a target="blank" href={this.props.data.questonUploadFile["uploadedFilePath"]}>Click here to view file</a>

        //     )
        // }
        // if( this.props.data.questonUploadFile && QuestionInfo.eligibilityQuestionId === this.props.data.questonUploadFile["eligibilityQuestionId"]){
        //   optionTables.push(
      
        //     <Tooltip id="tooltip-icon" title="Delete">
        //     <Icon onClick={()=>this.uploadFileDeleteHandler(this.props.data.questonUploadFile["id"])}>delete</Icon>
        //   </Tooltip>
        //   )}
        const dataa = {
          settlementId:QuestionInfo.settlementId,
          fileType:"",
          fileName:"",
          userId:this.state.settlementUserId,
          eligibilityQuestionId:QuestionInfo.eligibilityQuestionId,
          file :""
        };              
       
        const optionsList = [];
          if(QuestionInfo.allowFileUpload === 1){
            uploadOneFile.push(
              <div>
                  <input
                              id="contained-button-file"
                              type="file"
                              name="recentAnswerTwo"
                              style={{ width: "94px" }}
                              onChange={(e) => this.handleChangeFile(e,dataa)}
              // <input
              //   type="file"
                
                // value={this.state.recentAnswerState}
                // onChange={this.inputSelctorOptions}
                
              />
            </div>
            )
          }
        if (QuestionInfo.showOptionalNotes === 1) {
          optionsOne.push(
            <div >
              <textarea
                type="text"
                name="recentAnswerOne"
                style={{height:"80px",width:"98%",marginBottom:"25px",border: "2px solid #03a4f1"}}
                value = {this.state.optionalNotesTextState}
                // value={optText !== null &&  this.state.optionalNotesTextState === ""  ? optText : this.state.optionalNotesTextState}
                onChange={this.inputSelctorOptionsNotes}
              />
              {/* <ReactQuill/> */}
            </div>
          );
        }
        AnswerOptions.map((item, index) => {
          if (item.eligibilityQuestionResponseDto !== null) {
            if (this.state.recentAnswer.length === 0) {
              if (
                item.eligibilityQuestionResponseDto.eligibilityAnswerId !==
                undefined
              ) {
                this.state.recentAnswer.push(
                  item.eligibilityQuestionResponseDto.eligibilityAnswerId
                );
                this.state.yesState.push(
                  item.eligibilityQuestionResponseDto.eligibilityAnswerId
                );
              }
            }
          }

          if (item.isDisabled !== 1) {
            options.push(
              <span key={index}>
                <a
                  className={
                    this.state.recentAnswer.indexOf(item.answerId) > -1
                      ? "button active"
                      : "button"
                  }
                  onClick={() =>
                    this.radioSelectOptionOne(item.answerId, item.answerText)
                  }
                >
                  {item.answerText}
                </a>
              </span>
            );
          }
          // if (item.showOptionalNotes === 1) {
          //   optionsOne.push(
          //     <div key={index}>
          //       <input
          //         type="text"
          //         name="recentAnswerOne"
          //         value={this.state.optionalNotesTextState}
          //         onChange={this.inputSelctorOptionsNotes}
          //       />
          //       {/* <ReactQuill/> */}
          //     </div>
          //   );
          // }
          return true;
        });
        currentQuestionBody.push(
          <div key="q1">
            <QuestionComponent
              questionText={parse(questionText)}
              QuestionOptions={options}
              questionNotesText = {optionalNotesText}
              questionInput = {optionsOne}
              templatePath={nextQuestionDataApi1.templatePath}
              questionLabel = {uploadLabel}
              questionName ={optName}
              questionFile = {uploadOneFile}
              questionTable = {optionTable}
              questionTables = {optionTables}
              attachTemplateText={nextQuestionDataApi1.attachTemplateText}
            />
          </div>
        );
      }
      if (nextQuestionDataApi1.questionTypeId === 3) {
       console.log("prop",multipleFileState)
        const QuestionInfo = nextQuestionDataApi1;
        console.log("QuestionInfo",QuestionInfo,typeof QuestionInfo,this.state.optionalNotesTextState)
        const AnswerOptions = QuestionInfo.eligibilityAnswerDto;
        const questionText = QuestionInfo.questionText;
        const optText = QuestionInfo.optionalNotesData;
        const optionalNotesText = QuestionInfo.showOptionalNotesText !== "" ? parse(QuestionInfo.showOptionalNotesText) :"";
        const optionsOne = [];
        const options = [];
        const uploadOneFile = []; 
        const uploadLabel = QuestionInfo.allowFileUpload === 1 && QuestionInfo.allowFileUploadText !== "" ? QuestionInfo.allowFileUploadText : "";
        const optionTable =[];
        const optionTables = [];
        const latest = [];
        const optName = [];
        if(multipleFileState.length>0){
          multipleFileState.map(res=>{
        
            optName.push(
              <div className="joclasss">
              <p>{res.uploadedFileName.substr(0, res.uploadedFileName.lastIndexOf("\."))}</p>
              {/* <p>{res.uploadedFileName}</p> */}
              </div>
            );
                optionTable.push(
                  <div className="joclasss">
                  <a target="blank" href={res.uploadedFilePath}>Click here to view file</a>
                  </div>
    
                );
                optionTables.push(
                    <div className="joclass">
                      <Tooltip id="tooltip-icon" title="Delete">
                      <Icon onClick={()=>this.uploadFileDeleteHandler(res.id)} >delete</Icon>
                    </Tooltip>
                    </div>
                    )
            
          })
        }
        if (loaded) {
          loader1 = (
            <div className="loader">
              <img src={loader} alt="" />
            </div>
          );
        }
        // if(this.props.data.questonUploadFile && this.props.data.questonUploadFile["eligibilityQuestionId"]){
        //   // let a ;
        //    a.b = this.props.data.questonUploadFile.uploadedFileName;
        //    a.c = this.props.data.questonUploadFile.uploadedFilePath;
        //    a.d = this.props.data.questonUploadFile.id;
        //   //  let e;
        //    e.push(a);
        //    const f = e.slice();
        //    console.log("ok",f,e)
        // }
          console.log("questonUploadFilez",this.props.data.questonUploadFile,typeof this.props.data.questonUploadFile)
        // if( this.props.data.questonUploadFile && QuestionInfo.eligibilityQuestionId === this.props.data.questonUploadFile["eligibilityQuestionId"]){
        //     optionTable.push(
        //       <a target="blank" href={this.props.data.questonUploadFile["uploadedFilePath"]}>Click here to view file</a>

        //     )
        // }
        // if( this.props.data.questonUploadFile && QuestionInfo.eligibilityQuestionId === this.props.data.questonUploadFile["eligibilityQuestionId"]){
        //   optionTables.push(
      
        //     <Tooltip id="tooltip-icon" title="Delete">
        //     <Icon onClick={()=>this.uploadFileDeleteHandler(this.props.data.questonUploadFile["id"])}>delete</Icon>
        //   </Tooltip>
        //   )}
        const dataa = {
          settlementId:QuestionInfo.settlementId,
          fileType:"",
          fileName:"",
          userId:this.state.settlementUserId,
          eligibilityQuestionId:QuestionInfo.eligibilityQuestionId,
          file :""
        };              
       
        const optionsList = [];
          if(QuestionInfo.allowFileUpload === 1){
            uploadOneFile.push(
              <div>
                  <input
                              id="contained-button-file"
                              type="file"
                              
                              name="recentAnswerTwo"
                              style={{ width: "94px" }}
                              onChange={(e) => this.handleChangeFile(e,dataa)}
              // <input
              //   type="file"
                
                // value={this.state.recentAnswerState}
                // onChange={this.inputSelctorOptions}
                
              />
            </div>
            )
          }
          if (QuestionInfo.showOptionalNotes === 1) {
            optionsOne.push(
              <div >
                <textarea
                  type="text"
                  style={{height:"80px" ,width : "98%",marginBottom:"25px",border: "2px solid #03a4f1"}}
                  name="recentAnswerOne"
                  value = {this.state.optionalNotesTextState}
                  // value={optText !== null &&  this.state.optionalNotesTextState === ""  ? optText : this.state.optionalNotesTextState}
                  onChange={this.inputSelctorOptionsNotes}
                />
                {/* <ReactQuill/> */}
              </div>
            );
          }
        
        AnswerOptions.map((item, index) => {
          if (item.eligibilityQuestionResponseDto !== null) {
            if (this.state.resentData === 1) {
              // this.state.recentAnswer = [];
              if (
                item.eligibilityQuestionResponseDto.eligibilityAnswerId !==
                undefined
              ) {
                if (this.state.recentAnswer.length < 1) {
                  this.state.recentAnswer.push(
                    item.eligibilityQuestionResponseDto.value
                  );
                }
              }
            }
          }

          if (item.isDisabled !== 1) {
            options.push(
              <span key={index}>
                <input
                  type="text"
                  name="recentAnswer"
                  value={this.state.recentAnswer}
                  onChange={this.inputSelctorOptions}
                />
              </span>
            );
          }
          // if (item.showOptionalNotes === 1) {
          //   optionsOne.push(
          //     <div key={index}>
          //       <input
          //         type="text"
          //         name="recentAnswerOne"
          //         value={this.state.optionalNotesTextState}
          //         onChange={this.inputSelctorOptionsNotes}
          //       />
          //       {/* <ReactQuill/> */}
          //     </div>
          //   );
          // }
          return true;
        });
        // optionsList.push(
        //   <div>
        //     {options}
        //   </div>
        // )
        currentQuestionBody.push(
          <span key="q1">
            <QuestionComponent
              questionText={parse(questionText)}
            
              QuestionOptions={options}
              questionNotesText = {optionalNotesText}
              questionInput = {optionsOne}
              templatePath={nextQuestionDataApi1.templatePath}
              questionLabel = {uploadLabel}
              // questionName ={fileNameState !== "" ? fileNameState : ""}
              questionName = {optName}
              questionFile = {uploadOneFile}
              questionTable = {optionTable}
              questionTables = {optionTables}
              attachTemplateText={nextQuestionDataApi1.attachTemplateText}
              // questionAll = {latest}
            />
          </span>
        );
      }

      // if (nextQuestionDataApi1.questionTypeId === 15) {
      //   const QuestionInfo = nextQuestionDataApi1;
      //   const AnswerOptions = QuestionInfo.eligibilityAnswerDto;
      //   const questionText = QuestionInfo.questionText;
      //   const options = [];
      //   AnswerOptions.map((item, index) => {
      //     if (item.eligibilityQuestionResponseDto !== null) {
      //       if (this.state.resentData === 1) {
      //         // this.state.recentAnswer = [];
      //         if (
      //           item.eligibilityQuestionResponseDto.eligibilityAnswerId !==
      //             undefined ||
      //           item.eligibilityQuestionResponseDto === null
      //         ) {
      //           if (this.state.recentAnswer.length < 1) {
      //             this.state.recentAnswer.push(
      //               item.eligibilityQuestionResponseDto.value
      //             );
      //           }
      //         }
      //       }
      //     }

      //     if (item.isDisabled !== 1) {
      //       options.push(
      //         <span key={index}>
      //           {/* <input
      //             type="text"
      //             name="recentAnswer"
      //             value={this.state.recentAnswer}
      //             onChange={this.inputSelctorOptions}
      //           /> */}
      //           <label className="multiple-line-input">{item.answerText}</label>
      //           <DatePickerInput
      //             showOnInputClick={true}
      //             value={this.item}
      //             onChange={this.inputSelctorOptionsOne}
      //             className="my-custom-datepicker-component"
      //             autoClose={true}
      //             placeholder="Select Date"
      //             locale="en-au"
      //             displayFormat="MM/DD/YYYY"
      //             // onHide={
      //             //   () => {
      //             //     this.onSubmit()
      //             //   }
      //             // }

      //             //   {...anyReactInputProps}
      //           />
      //         </span>
      //       );
      //     }
      //     return true;
      //   });
      //   currentQuestionBody.push(
      //     <span key="q1">
      //       <QuestionComponent
      //         questionText={parse(questionText)}
      //         QuestionOptions={options}
      //       />
      //     </span>
      //   );
      // }
      // if (nextQuestionDataApi1.questionTypeId === 7) {
      //   const QuestionInfo = multipleIputTypeQuestion;
      //   const AnswerOptions = multipleIputTypeQuestion.eligibilityAnswerDto;
      //   const QuestionInfoOne = nextQuestionDataApi1;
      //   const questionText = QuestionInfoOne.questionText;
      //   const optionalNotesText = QuestionInfoOne.showOptionalNotesText !== "" ? parse(QuestionInfoOne.showOptionalNotesText) :"";
      //   const optionsOne = [];
      //   const optionsList = [];
      //   console.log("AnswerOptions11",QuestionInfo)
      //   const options = [];
      //   if (QuestionInfoOne.showOptionalNotes === 1) {
      //     optionsOne.push(
      //       <span >
      //         <textarea
      //           type="text"
      //           name="recentAnswerOne"
      //           style={{height:"80px" ,width : "378px"}}
      //           value={this.state.optionalNotesTextState}
      //           onChange={this.inputSelctorOptionsNotes}
      //         />
      //         {/* <ReactQuill/> */}
      //       </span>
      //     );
      //   }
      //   if (AnswerOptions !== undefined) {
      //     AnswerOptions.map((item, index) => {
      //       if (item.isDisabled !== 1 ) {
      //         // console.log('ssssssssssss',AnswerOptions)

      //         // if (item.eligibilityQuestionResponseDto !== null) {
      //         //   if (this.state.resentData === 1) {
      //         // console.log('this.state.resentData', item.eligibilityQuestionResponseDto.eligibilityAnswerId);

      //         // if (item.eligibilityQuestionResponseDto.eligibilityAnswerId !== undefined) {
      //         //   // console.log('this.state.resentData item.eligibilityQuest', item.eligibilityQuestionResponseDto.eligibilityAnswerId);

      //         //   // this.state.recentAnswer.push(item.eligibilityQuestionResponseDto.value)
      //         //   // multipleInputOptionsData=item.eligibilityQuestionResponseDto.value
      //         //   options.push(
      //         //     <span className="col s12 m12 l6" key={index}>
      //         //       <label className="multiple-line-input">{item.answerText}</label>
      //         //       <input type="text" value={item.eligibilityQuestionResponseDto.value} name={index} onKeyDown={this.onKeyPressed} className="numberonly" onChange={this.multipleInputOptions(item.answerId)} placeholder="Add number of purchases" key={index} />
      //         //     </span>,
      //         //   );
      //         // }
      //         // }
      //         // } else {
      //         options.push(
      //           <span className="col s12 m12 l6" key={index}>
      //             <label className="multiple-line-input">
      //               {item.answerText}
      //             </label>
      //             {item.inputType === "date" ? 
      //              <DatePickerInput
      //              showOnInputClick
      //              onChange={this.multipleInputOptionsDate(
      //                item.answerId,
      //                index
      //              )}
      //              value={item.value}
      //              className="my-custom-datepicker-component"
      //              autoClose
      //              placeholder="Date"
      //              // minDate={moment().subtract(this.state.checkYear, 'year').toDate()}
      //             //  maxDate={moment()}
      //              locale="en-au"
      //              displayFormat="MM/DD/YYYY"
      //              position="bottom"
      //            /> :<input
      //               value={item.value}
      //               type="text"
      //               onKeyDown={this.onKeyPressed}
      //               name={index}
      //               onChange={this.multipleInputOptions(item.answerId)}
      //               placeholder={
      //                 item.placeholder !== ""
      //                   ? item.placeholder
      //                   : "Add number of purchases"
      //               }
      //               key={index}
      //               className="numberonly"
      //             />}
      //           </span>
      //         );
      //       }
      //       // options.push(<span key={index}><label>{item.answerText}</label><input type="text" value={multipleInputOptionsData} name={'recentAnswer'+index} onChange={this.multipleInputOptions} placeholder="" key={index} /></span>)
      //       // }
      //       // if (item.showOptionalNotes === 1) {
      //       //   optionsOne.push(
      //       //     <div key={index}>
      //       //       <input
      //       //         type="text"
      //       //         name="recentAnswerOne"
      //       //         value={this.state.optionalNotesTextState}
      //       //         onChange={this.inputSelctorOptionsNotes}
      //       //       />
      //       //       {/* <ReactQuill/> */}
      //       //     </div>
      //       //   );
      //       // }
      //       return true;
      //     });
      //   }
      //   currentQuestionBody.push(
      //     <span key="q1">
      //       <QuestionComponent
      //         questionText={questionText && parse(questionText)}
      //         QuestionOptions={options}
      //         questionNotesText = {optionalNotesText}
      //         questionInput = {optionsOne}
      //       />
      //     </span>
      //   );
      // }

      if (nextQuestionDataApi1.questionTypeId === 15) {
        const QuestionInfo = multipleIputTypeQuestion;
        const AnswerOptions = multipleIputTypeQuestion.eligibilityAnswerDto;
        const questionText = QuestionInfo.questionText;
        const QuestionInfoOne  =  nextQuestionDataApi1;
        const optText = QuestionInfoOne.optionalNotesData;
        const optionalNotesText = QuestionInfoOne.showOptionalNotesText !== "" ? parse(QuestionInfoOne.showOptionalNotesText) : "";
        const optionsOne = [];
        const options = [];
        const uploadOneFile = []; 
        const uploadLabel = QuestionInfoOne.allowFileUpload === 1 && QuestionInfoOne.allowFileUploadText !== "" ? QuestionInfoOne.allowFileUploadText : "";
        const optionTable =[];
        const optionTables = [];
          console.log("questonUploadFilez",this.props.data.questonUploadFile,typeof this.props.data.questonUploadFile)
        //   if( this.props.data.questonUploadFile && QuestionInfoOne.eligibilityQuestionId === this.props.data.questonUploadFile["eligibilityQuestionId"]){
        //     optionTable.push(
        //       <a target="blank" href={this.props.data.questonUploadFile["uploadedFilePath"]}>Click here to view file</a>

        //     )
        // }
        // if( this.props.data.questonUploadFile && QuestionInfoOne.eligibilityQuestionId === this.props.data.questonUploadFile["eligibilityQuestionId"]){
        //   optionTables.push(
      
        //     <Tooltip id="tooltip-icon" title="Delete">
        //     <Icon onClick={()=>this.uploadFileDeleteHandler(this.props.data.questonUploadFile["id"])}>delete</Icon>
        //   </Tooltip>
        //   )}
        const optName = [];
        if(multipleFileState.length>0){
          multipleFileState.map(res=>{
        
            optName.push(
              <div className="joclasss">
              {/* <p>{res.uploadedFileName.split('.')[0]}</p> */}
              <p>{res.uploadedFileName.substr(0, res.uploadedFileName.lastIndexOf("\."))}</p>
              </div>
            );
                optionTable.push(
                  <div className="joclasss">
                  <a target="blank" href={res.uploadedFilePath}>Click here to view file</a>
                  </div>
    
                );
                optionTables.push(
                    <div className="joclass">
                      <Tooltip id="tooltip-icon" title="Delete">
                      <Icon onClick={()=>this.uploadFileDeleteHandler(res.id)}>delete</Icon>
                    </Tooltip>
                    </div>
                    )
            
          })
        }
        if (loaded) {
          loader1 = (
            <div className="loader">
              <img src={loader} alt="" />
            </div>
          );
        }
        const dataa = {
          settlementId:QuestionInfoOne.settlementId,
          fileType:"",
          fileName:"",
          userId:this.state.settlementUserId,
          eligibilityQuestionId:QuestionInfoOne.eligibilityQuestionId,
          file :""
        };              
       
        const optionsList = [];
          if(QuestionInfoOne.allowFileUpload === 1){
            uploadOneFile.push(
              <div>
                  <input
                              id="contained-button-file"
                              type="file"
                              name="recentAnswerTwo"
                              style={{ width: "94px" }}
                              onChange={(e) => this.handleChangeFile(e,dataa)}
              // <input
              //   type="file"
                
                // value={this.state.recentAnswerState}
                // onChange={this.inputSelctorOptions}
                
              />
            </div>
            )
          }
        if (QuestionInfoOne.showOptionalNotes === 1) {
          optionsOne.push(
            <div >
              <textarea
                type="text"
                name="recentAnswerOne"
                style={{height:"80px" ,width : "98%",marginBottom:"25px",border: "2px solid #03a4f1"}}
                value = {this.state.optionalNotesTextState}
                // value={optText !== null &&  this.state.optionalNotesTextState === ""  ? optText : this.state.optionalNotesTextState}
                onChange={this.inputSelctorOptionsNotes}
              />
              {/* <ReactQuill/> */}
            </div>
          );
        }
        if (AnswerOptions !== undefined) {
          AnswerOptions.map((item, index) => {
            if (item.isDisabled !== 1) {
              // console.log('ssssssssssss',AnswerOptions)

              // if (item.eligibilityQuestionResponseDto !== null) {
              //   if (this.state.resentData === 1) {
              // console.log('this.state.resentData', item.eligibilityQuestionResponseDto.eligibilityAnswerId);

              // if (item.eligibilityQuestionResponseDto.eligibilityAnswerId !== undefined) {
              //   // console.log('this.state.resentData item.eligibilityQuest', item.eligibilityQuestionResponseDto.eligibilityAnswerId);

              //   // this.state.recentAnswer.push(item.eligibilityQuestionResponseDto.value)
              //   // multipleInputOptionsData=item.eligibilityQuestionResponseDto.value
              //   options.push(
              //     <span className="col s12 m12 l6" key={index}>
              //       <label className="multiple-line-input">{item.answerText}</label>
              //       <input type="text" value={item.eligibilityQuestionResponseDto.value} name={index} onKeyDown={this.onKeyPressed} className="numberonly" onChange={this.multipleInputOptions(item.answerId)} placeholder="Add number of purchases" key={index} />
              //     </span>,
              //   );
              // }
              // }
              // } else {
              options.push(
                <span key={index}>
                {/* <input
                  type="text"
                  name="recentAnswer"
                  value={this.state.recentAnswer}
                  onChange={this.inputSelctorOptions}
                /> */}
                <label className="multiple-line-input">{item.answerText}</label>
                {/* <DatePickerInput
                  showOnInputClick={true}
                  value={this.item}
                  onChange={this.multipleInputOptionsDate(item.answerId)}
                  className="my-custom-datepicker-component"
                  autoClose={true}
                  placeholder="Select Date"
                  locale="en-au"
                  displayFormat="MM/DD/YYYY"
                  // onHide={
                  //   () => {
                  //     this.onSubmit()
                  //   }
                  // }

                  //   {...anyReactInputProps}
                /> */}
                {console.log("item.value", item.value)}
                     <DatePickerInput
                      showOnInputClick
                      onChange={this.multipleInputOptionsDate(
                        item.answerId,
                        index
                      )}
                      value={item.value !== "Invalid date" ? item.value : null}
                      className="my-custom-datepicker-component"
                      autoClose
                      placeholder="Date"
                      // minDate={moment().subtract(this.state.checkYear, 'year').toDate()}
                      // maxDate={moment()}
                      locale="en-au"
                      displayFormat="MM/DD/YYYY"
                      // position="bottom"
                    />

              </span>
              );
            }
            // options.push(<span key={index}><label>{item.answerText}</label><input type="text" value={multipleInputOptionsData} name={'recentAnswer'+index} onChange={this.multipleInputOptions} placeholder="" key={index} /></span>)
            // }
            return true;
          });
        }
        currentQuestionBody.push(
          <span key="q1">
            <QuestionComponent
              questionText={questionText && parse(questionText)}
              QuestionOptions={options}
              questionNotesText = {optionalNotesText}
              questionInput = {optionsOne}
              templatePath={nextQuestionDataApi1.templatePath}
              questionLabel = {uploadLabel}
              questionName ={optName}
              questionFile = {uploadOneFile}
              questionTable = {optionTable}
              questionTables = {optionTables}
              attachTemplateText={nextQuestionDataApi1.attachTemplateText}
            />
          </span>
        );
      }

       if (nextQuestionDataApi1.questionTypeId === 7) {
        const QuestionInfo = multipleIputTypeQuestion;
        const AnswerOptions = multipleIputTypeQuestion.eligibilityAnswerDto;
        const questionText = QuestionInfo.questionText;
        const QuestionInfoOne  =  nextQuestionDataApi1;
        const optText = QuestionInfoOne.optionalNotesData;
        const optionalNotesText = QuestionInfoOne.showOptionalNotesText !== "" ? parse(QuestionInfoOne.showOptionalNotesText) :"";
        const optionsOne = [];
        const options = [];
        const uploadOneFile = []; 
        const uploadLabel = QuestionInfoOne.allowFileUpload === 1 && QuestionInfoOne.allowFileUploadText !== "" ? QuestionInfoOne.allowFileUploadText : "";
        const optionTable =[];
        const optionTables = [];
          console.log("questonUploadFilez",this.props.data.questonUploadFile,typeof this.props.data.questonUploadFile)
          const optName = [];
          if(multipleFileState.length>0){
            multipleFileState.map(res=>{
          
              optName.push(
                <div className="joclasss">
                {/* <p>{res.uploadedFileName.split('.')[0]}</p> */}
                <p>{res.uploadedFileName.substr(0, res.uploadedFileName.lastIndexOf("\."))}</p>
                </div>
              );
                  optionTable.push(
                    <div className="joclasss">
                    <a target="blank" href={res.uploadedFilePath}>Click here to view file</a>
                    </div>
      
                  );
                  optionTables.push(
                      <div className="joclass">
                        <Tooltip id="tooltip-icon" title="Delete">
                        <Icon onClick={()=>this.uploadFileDeleteHandler(res.id)}>delete</Icon>
                      </Tooltip>
                      </div>
                      )
              
            })
          }
          if (loaded) {
            loader1 = (
              <div className="loader">
                <img src={loader} alt="" />
              </div>
            );
          }
          //   if( this.props.data.questonUploadFile && QuestionInfoOne.eligibilityQuestionId === this.props.data.questonUploadFile["eligibilityQuestionId"]){
        //     optionTable.push(
        //       <a target="blank" href={this.props.data.questonUploadFile["uploadedFilePath"]}>Click here to view file</a>

        //     )
        // }
        // if( this.props.data.questonUploadFile && QuestionInfoOne.eligibilityQuestionId === this.props.data.questonUploadFile["eligibilityQuestionId"]){
        //   optionTables.push(
      
        //     <Tooltip id="tooltip-icon" title="Delete">
        //     <Icon onClick={()=>this.uploadFileDeleteHandler(this.props.data.questonUploadFile["id"])}>delete</Icon>
        //   </Tooltip>
        //   )}
        const dataa = {
          settlementId:QuestionInfoOne.settlementId,
          fileType:"",
          fileName:"",
          userId:this.state.settlementUserId,
          eligibilityQuestionId:QuestionInfoOne.eligibilityQuestionId,
          file :""
        };              
       
        const optionsList = [];
          if(QuestionInfoOne.allowFileUpload === 1){
            uploadOneFile.push(
              <div>
                  <input
                              id="contained-button-file"
                              type="file"
                              name="recentAnswerTwo"
                              style={{ width: "94px" }}
                              onChange={(e) => this.handleChangeFile(e,dataa)}
              // <input
              //   type="file"
                
                // value={this.state.recentAnswerState}
                // onChange={this.inputSelctorOptions}
                
              />
            </div>
            )
          }
        console.log("AnswerOptions", AnswerOptions)
        if (QuestionInfoOne.showOptionalNotes === 1) {
          optionsOne.push(
            <div >
              <textarea
                type="text"
                name="recentAnswerOne"
                style={{height:"80px" ,width : "98%",marginBottom:"25px",border: "2px solid #03a4f1"}}
                value = {this.state.optionalNotesTextState}
                // value={optText !== null &&  this.state.optionalNotesTextState === ""  ? optText : this.state.optionalNotesTextState}
                onChange={this.inputSelctorOptionsNotes}
              />
              {/* <ReactQuill/> */}
            </div>
          );
        }
        if (AnswerOptions !== undefined) {
          AnswerOptions.map((item, index) => {
            if (item.isDisabled !== 1) {
              if (
                item.inputType === "number"
              ) {
                  options.push(
                    <span className="col s12 m12 l6" key={index}>
                      <label className="multiple-line-input">
                        {item.answerText}
                      </label>
                      <input
                        value={item.value}
                        type="text"
                        onKeyDown={this.onKeyPressed}
                        name={index}
                        onChange={this.multipleInputOptionsNumber(item.answerId)}
                        placeholder={
                          item.placeholder !== ""
                            ? item.placeholder
                            : ""
                        }
                        key={index}
                        className="numberonly"
                      />
                    </span>
                  );
                } else if (
                item.inputType === "date"
              ) {
                  options.push(
                    <span className="col s12 m12 l6" key={index}>
                      <label className="multiple-line-input">
                        {item.answerText}
                      </label>
                      <DatePickerInput
                        showOnInputClick
                        onChange={this.multipleInputTypeDateOptions(
                          item.answerId,
                        )}
                        value={item.value !== "Invalid date" ? item.value : null}
                        className="my-custom-datepicker-component"
                        autoClose
                        placeholder={
                          item.placeholder !== ""
                            ? item.placeholder
                            : "Date"
                        }
                        // minDate={moment().subtract(this.state.checkYear, 'year').toDate()}
                        maxDate={moment()}
                        locale="en-au"
                        displayFormat="MM/DD/YYYY"
                        position="bottom"
                      />
                     
                    </span>
                  );
                } else {

                        options.push(
                            <span className="col s12 m12 l6" key={index}>
                              <label className="multiple-line-input">
                                {item.answerText}
                              </label>
                              <input
                                value={item.value}
                                type="text"
                                name={index}
                                onChange={this.multipleInputOptions(item.answerId)}
                                placeholder={
                                  item.placeholder !== ""
                                    ? item.placeholder
                                    : ""
                                }
                                key={index}
                              />
                            </span>
                          );
                }
            }
            // options.push(<span key={index}><label>{item.answerText}</label><input type="text" value={multipleInputOptionsData} name={'recentAnswer'+index} onChange={this.multipleInputOptions} placeholder="" key={index} /></span>)
            // }
            return true;
          });
        }
        currentQuestionBody.push(
          <span key="q1">
            <QuestionComponent
              questionText={questionText && parse(questionText)}
              QuestionOptions={options}
              questionNotesText = {optionalNotesText}
              questionInput = {optionsOne}
              templatePath={nextQuestionDataApi1.templatePath}
              questionLabel = {uploadLabel}
              questionName ={optName}
              questionFile = {uploadOneFile}
              questionTable = {optionTable}
              questionTables = {optionTables}
              attachTemplateText={nextQuestionDataApi1.attachTemplateText}
            />
          </span>
        );
      }

      if (nextQuestionDataApi1.questionTypeId === 13) {
        const QuestionInfo = multipleIputTypeQuestion;
        const QuestionInfoOne = nextQuestionDataApi1;
        const optText = QuestionInfoOne.optionalNotesData;
        const AnswerOptions = multipleIputTypeQuestion.eligibilityAnswerDto;
        const questionText = QuestionInfo.questionText;
        const optionalNotesText = QuestionInfoOne.showOptionalNotesText && QuestionInfoOne.showOptionalNotesText  !== "" ? parse(QuestionInfoOne.showOptionalNotesText) : "";
        const optionsOne = [];
        const options = [];
        const optionsList = [];
        const uploadOneFile = []; 
        const uploadLabel = QuestionInfoOne.allowFileUpload === 1 && QuestionInfoOne.allowFileUploadText !== "" ? QuestionInfoOne.allowFileUploadText : "";
        const optionTable =[];
        const optionTables = [];
          console.log("questonUploadFilez",this.props.data.questonUploadFile,typeof this.props.data.questonUploadFile)
        //   if( this.props.data.questonUploadFile && QuestionInfoOne.eligibilityQuestionId === this.props.data.questonUploadFile["eligibilityQuestionId"]){
        //     optionTable.push(
        //       <a target="blank" href={this.props.data.questonUploadFile["uploadedFilePath"]}>Click here to view file</a>

        //     )
        // }
        // if( this.props.data.questonUploadFile && QuestionInfoOne.eligibilityQuestionId === this.props.data.questonUploadFile["eligibilityQuestionId"]){
        //   optionTables.push(
        //     <Tooltip id="tooltip-icon" title="Delete">
        //     <Icon onClick={()=>this.uploadFileDeleteHandler(this.props.data.questonUploadFile["id"])}>delete</Icon>
        //   </Tooltip>
        //   )}
        const optName = [];
        if(multipleFileState.length>0){
          multipleFileState.map(res=>{
        
            optName.push(
              <div className="joclasss">
              {/* <p>{res.uploadedFileName.split('.')[0]}</p> */}
              <p>{res.uploadedFileName.substr(0, res.uploadedFileName.lastIndexOf("\."))}</p>
              </div>
            );
                optionTable.push(
                  <div className="joclasss">
                  <a target="blank" href={res.uploadedFilePath}>Click here to view file</a>
                  </div>
    
                );
                optionTables.push(
                    <div className="joclass">
                      <Tooltip id="tooltip-icon" title="Delete">
                      <Icon onClick={()=>this.uploadFileDeleteHandler(res.id)}>delete</Icon>
                    </Tooltip>
                    </div>
                    )
            
          })
        }
        if (loaded) {
          loader1 = (
            <div className="loader">
              <img src={loader} alt="" />
            </div>
          );
        }
        const dataa = {
          settlementId:QuestionInfoOne.settlementId,
          fileType:"",
          fileName:"",
          userId:this.state.settlementUserId,
          eligibilityQuestionId:QuestionInfoOne.eligibilityQuestionId,
          file :""
        };              
       
        
          if(QuestionInfoOne.allowFileUpload === 1){
            uploadOneFile.push(
              <div>
                  <input
                              id="contained-button-file"
                              type="file"
                              name="recentAnswerTwo"
                              style={{ width: "94px" }}
                              onChange={(e) => this.handleChangeFile(e,dataa)}
              // <input
              //   type="file"
                
                // value={this.state.recentAnswerState}
                // onChange={this.inputSelctorOptions}
                
              />
            </div>
            )
          }
        console.log(
          "eligibilityAnswerDtoeligibilityAnswerDto multipleIputTypeQuestion",
          multipleIputTypeQuestion
        );
        if (QuestionInfoOne.showOptionalNotes === 1) {
          optionsOne.push(
            <div >
              <textarea
                type="text"
                name="recentAnswerOne"
                style={{height:"80px" ,width : "98%",marginBottom:"25px",border: "2px solid #03a4f1"}}
                value = {this.state.optionalNotesTextState}
                // value={optText !== null &&  this.state.optionalNotesTextState === ""  ? optText : this.state.optionalNotesTextState}
                onChange={this.inputSelctorOptionsNotes}
              />
              {/* <ReactQuill/> */}
            </div>
          );
        }
        if (AnswerOptions !== undefined) {
          AnswerOptions.map((item, index) => {
            if (item.review === "add" && item.reviewIndex === 0) {
              options.push(
                <div>
                  <Select
                    className="dropdownBox browser-default "
                    name="optionsDropdown"
                    value={item.answerId}
                    onChange={this.onMultiselectSelect(index)}
                    style={{
                      maxWidth: "200px",
                    }}
                  >
                    <MenuItem key={0} value={0}>
                      Select option
                    </MenuItem>

                    {multipleIputTypeQuestion &&
                      multipleIputTypeQuestion.questionListDto.map((s, idx) => (
                        <MenuItem key={idx} value={s.answerId}>
                          {s.answerText}
                        </MenuItem>
                      ))}
                  </Select>

                  <a href="" onClick={this.deleteQuestionDetail(index)}>
                    <i
                      className="material-icons dp48 delete-manufacture"
                      style={{
                        display:
                          item.autoPartDefendentDtoList !== undefined
                            ? item.autoPartDefendentDtoList.length > 1
                              ? "inline-block"
                              : "inline-block"
                            : "inline-block",
                      }}
                    >
                      close
                    </i>
                  </a>
                </div>
              );
            }

            if (item.isDisabled !== 1) {
              if (
                item.inputType === "number" &&
                AnswerOptions.inputType !== ""
              ) {
                options.push(
                  <span className="col s12 m12 l12 survey" key={index}>
                    {item.review === "add" || item.reviewIndex === 0 ? (
                      <label className="multiple-line-input">
                        {item.answerText}
                      </label>
                    ) : (
                      ""
                    )}

                    <input
                      value={item.value}
                      type="text"
                      onKeyDown={this.onKeyPressed}
                      name={index}
                      onChange={this.multipleInputOptionsSelect(
                        item.answerId,
                        index
                      )}
                      placeholder={
                        item.placeholder !== ""
                          ? item.placeholder
                          : "Enter Number"
                      }
                      key={index}
                      className="numberonly"
                    />
                    <a href="" onClick={this.deleteQuestionDetail(index)}>
                      <i
                        className="material-icons dp48 delete-manufacture"
                        style={{
                          display:
                            item.autoPartDefendentDtoList !== undefined
                              ? item.autoPartDefendentDtoList.length > 1
                                ? "inline-block"
                                : "inline-block"
                              : "inline-block",
                        }}
                      >
                        close
                      </i>
                    </a>
                  </span>
                );
              } else if (
                item.inputType === "input" &&
                AnswerOptions.inputType !== ""
              ) {
                options.push(
                  <span className="col s12 m12 l12 survey" key={index}>
                    {item.review === "add" || item.reviewIndex === 0 ? (
                      <label className="multiple-line-input">
                        {item.answerText}
                      </label>
                    ) : (
                      ""
                    )}
                    <input
                      value={item.value}
                      type="text"
                      // onKeyDown={this.onKeyPressed}
                      name={index}
                      onChange={this.multipleInputOptionsSelect(
                        item.answerId,
                        index
                      )}
                      placeholder={
                        item.placeholder !== ""
                          ? item.placeholder
                          : "Enter text"
                      }
                      key={index}
                      // className="numberonly"
                    />

                    <a href="" onClick={this.deleteQuestionDetail(index)}>
                      <i
                        className="material-icons dp48 delete-manufacture"
                        style={{
                          display:
                            item.autoPartDefendentDtoList !== undefined
                              ? item.autoPartDefendentDtoList.length > 1
                                ? "inline-block"
                                : "inline-block"
                              : "inline-block",
                        }}
                      >
                        close
                      </i>
                    </a>
                  </span>
                );
              } else if (
                item.inputType === "date" &&
                AnswerOptions.inputType !== ""
              ) {
                options.push(
                  <span
                    className="col s12 m12 l12 survey-datepicker"
                    key={index}
                  >
                    {item.review === "add" || item.reviewIndex === 0 ? (
                      <label className="multiple-line-input">
                        {item.answerText}
                      </label>
                    ) : (
                      ""
                    )}

                    <DatePickerInput
                      showOnInputClick
                      onChange={this.multipleInputOptionsDate(
                        item.answerId,
                        index
                      )}
                      value={item.value !== "Invalid date" ? item.value : null}
                      className="my-custom-datepicker-component"
                      autoClose
                      placeholder="Date"
                      // minDate={moment().subtract(this.state.checkYear, 'year').toDate()}
                      maxDate={moment()}
                      locale="en-au"
                      displayFormat="MM/DD/YYYY"
                      position="bottom"
                    />

                    <a href="" onClick={this.deleteQuestionDetail(index)}>
                      <i
                        className="material-icons dp48 delete-manufacture"
                        style={{
                          display:
                            item.autoPartDefendentDtoList !== undefined
                              ? item.autoPartDefendentDtoList.length > 1
                                ? "inline-block"
                                : "inline-block"
                              : "inline-block",
                        }}
                      >
                        close
                      </i>
                    </a>

                    {/* <input
                          value={item.value}
                          type="text"
                          // onKeyDown={this.onKeyPressed}
                          name={index}
                          onChange={this.multipleInputOptionsSelect(item.answerId)}
                          placeholder={
                            item.placeholder !== ""
                              ? item.placeholder
                              : "Enter text"
                          }
                          key={index}
                          // className="numberonly"
                        /> */}
                  </span>
                );
              }
            }
            // options.push(<span key={index}><label>{item.answerText}</label><input type="text" value={multipleInputOptionsData} name={'recentAnswer'+index} onChange={this.multipleInputOptions} placeholder="" key={index} /></span>)
            // }
            return true;
          });
        }

        optionsList.push(
          <div>
            <div>{options}</div>
            <button
              className="waves-effect waves-light btn btn-blue mt-10"
              // style={{
              //   display:
              //   AnswerOptions.length >            ? "inline-block"
              //             : "none"
              //           : "inline-block"
              //         : "none"
              //       : "none"
              // }}
              onClick={this.addMoreQuestionDetail}
            >
              {" "}
              Add
            </button>
          </div>
        );
        currentQuestionBody.push(
          <span key="q1">
            <QuestionComponent
              questionText={questionText && parse(questionText)}
              QuestionOptions={optionsList}
              questionNotesText = {optionalNotesText}
              questionInput = {optionsOne}
              templatePath={nextQuestionDataApi1.templatePath}
              questionLabel = {uploadLabel}
              questionName ={optName}
              questionFile = {uploadOneFile}
              questionTable = {optionTable}
              questionTables = {optionTables}
              attachTemplateText={nextQuestionDataApi1.attachTemplateText}
            />
          </span>
        );
      }

      if (nextQuestionDataApi1.questionTypeId === 5) {
        const QuestionInfo = nextQuestionDataApi1;
        const AnswerOptions = QuestionInfo.eligibilityAnswerDto;
        const questionText = QuestionInfo.questionText;
        const optText = QuestionInfo.optionalNotesData;
        const optionalNotesText = QuestionInfo.showOptionalNotesText !== "" ? parse(QuestionInfo.showOptionalNotesText) :"";
        const optionsOne = [];
        const options = [];
        const uploadOneFile = []; 
        const uploadLabel = QuestionInfo.allowFileUpload === 1 && QuestionInfo.allowFileUploadText !== "" ? QuestionInfo.allowFileUploadText : "";
        const optionTable =[];
        const optionTables = [];
          console.log("questonUploadFilez",this.props.data.questonUploadFile,typeof this.props.data.questonUploadFile)
          const optName = [];
          if(multipleFileState.length>0){
            multipleFileState.map(res=>{
          
              optName.push(
                <div className="joclasss">
                {/* <p>{res.uploadedFileName.split('.')[0]}</p> */}
                <p>{res.uploadedFileName.substr(0, res.uploadedFileName.lastIndexOf("\."))}</p>
                </div>
              );
                  optionTable.push(
                    <div className="joclasss">
                    <a target="blank" href={res.uploadedFilePath}>Click here to view file</a>
                    </div>
      
                  );
                  optionTables.push(
                      <div className="joclass">
                        <Tooltip id="tooltip-icon" title="Delete">
                        <Icon onClick={()=>this.uploadFileDeleteHandler(res.id)}>delete</Icon>
                      </Tooltip>
                      </div>
                      )
              
            })
          }
          if (loaded) {
            loader1 = (
              <div className="loader">
                <img src={loader} alt="" />
              </div>
            );
          }
          //   if( this.props.data.questonUploadFile && QuestionInfo.eligibilityQuestionId === this.props.data.questonUploadFile["eligibilityQuestionId"]){
        //     optionTable.push(
        //       <a target="blank" href={this.props.data.questonUploadFile["uploadedFilePath"]}>Click here to view file</a>

        //     )
        // }
        // if( this.props.data.questonUploadFile && QuestionInfo.eligibilityQuestionId === this.props.data.questonUploadFile["eligibilityQuestionId"]){
        //   optionTables.push(
      
        //     <Tooltip id="tooltip-icon" title="Delete">
        //     <Icon onClick={()=>this.uploadFileDeleteHandler(this.props.data.questonUploadFile["id"])}>delete</Icon>
        //   </Tooltip>
        //   )}
        const dataa = {
          settlementId:QuestionInfo.settlementId,
          fileType:"",
          fileName:"",
          userId:this.state.settlementUserId,
          eligibilityQuestionId:QuestionInfo.eligibilityQuestionId,
          file :""
        };              
       
        const optionsList = [];
          if(QuestionInfo.allowFileUpload === 1){
            uploadOneFile.push(
              <div>
                  <input
                              id="contained-button-file"
                              type="file"
                              name="recentAnswerTwo"
                              style={{ width: "94px" }}
                              onChange={(e) => this.handleChangeFile(e,dataa)}
              // <input
              //   type="file"
                
                // value={this.state.recentAnswerState}
                // onChange={this.inputSelctorOptions}
                
              />
            </div>
            )
          }
        if (QuestionInfo.showOptionalNotes === 1) {
          optionsOne.push(
            <div >
              <textarea
                type="text"
                name="recentAnswerOne"
                style={{height:"80px" ,width : "98%",marginBottom:"25px",border: "2px solid #03a4f1"}}
                value = {this.state.optionalNotesTextState}
                // value={optText !== null &&  this.state.optionalNotesTextState === ""  ? optText : this.state.optionalNotesTextState}
                onChange={this.inputSelctorOptionsNotes}
              />
              {/* <ReactQuill/> */}
            </div>
          );
        }
        let dropdown = "";
        options.push({
          value: "",
          label: "Select Option",
          name: "select Option",
        });
        AnswerOptions.map((item) => {
          if (item.isDisabled !== 1) {
            if (item.eligibilityQuestionResponseDto !== null) {
              if (this.state.recentAnswer.length === 0) {
                if (
                  item.eligibilityQuestionResponseDto.eligibilityAnswerId !==
                  undefined
                ) {
                  this.state.recentAnswer.push(
                    item.eligibilityQuestionResponseDto.eligibilityAnswerId
                  );
                  this.state.dropdState.push(
                    item.eligibilityQuestionResponseDto.eligibilityAnswerId
                  );
                }
              }
            }
            return options.push({
              value: item.answerId,
              label: item.answerText,
              name: item.answerText,
            });
          }
          // if (item.showOptionalNotes === 1) {
          //   optionsOne.push(
          //     <div>
          //       <input
          //         type="text"
          //         name="recentAnswerOne"
          //         value={this.state.optionalNotesTextState}
          //         onChange={this.inputSelctorOptionsNotes}
          //       />
          //       {/* <ReactQuill/> */}
          //     </div>
          //   );
          // }
          return true;
        });
        dropdown = (
          <Select
            className="dropdownBox browser-default "
            name="optionsDropdown"
            value={Number.parseInt(
              this.state.recentAnswer[0] !== undefined
                ? this.state.recentAnswer[0]
                : 0,
              10
            )}
            onChange={this._onSelect}
            style={{
              maxWidth: "200px",
            }}
          >
            <MenuItem key={0} value={0}>
              Select option
            </MenuItem>

            {AnswerOptions.map((s, idx) => (
              <MenuItem key={idx} value={s.answerId}>
                {s.answerText}
              </MenuItem>
            ))}
          </Select>
        );

        currentQuestionBody.push(
          <span key="q1">
            <QuestionComponent
              questionText={parse(questionText)}
              QuestionOptions={dropdown}
              questionNotesText = {optionalNotesText}
              questionInput = {optionsOne}
              templatePath={nextQuestionDataApi1.templatePath}
              questionLabel = {uploadLabel}
              questionName ={optName}
              questionFile = {uploadOneFile}
              questionTable = {optionTable}
              questionTables = {optionTables}
              attachTemplateText={nextQuestionDataApi1.attachTemplateText}
            />
          </span>
        );
      }
      if (nextQuestionDataApi1.questionTypeId === 1) {
        const QuestionInfo = nextQuestionDataApi1;
        const AnswerOptions = QuestionInfo.eligibilityAnswerDto;
        const questionText = QuestionInfo.questionText;
        const optText = QuestionInfo.optionalNotesData;
        const optionalNotesText = QuestionInfo.showOptionalNotesText !== "" ? parse(QuestionInfo.showOptionalNotesText) : "";
        const optionsOne = [];
        const options = [];
        const uploadOneFile = []; 
        const uploadLabel = QuestionInfo.allowFileUpload === 1 && QuestionInfo.allowFileUploadText !== "" ? QuestionInfo.allowFileUploadText : "";
        const optionTable =[];
        const optionTables = [];
          console.log("nextQuestionDataApi1",nextQuestionDataApi1);
          const optName = [];
          if(multipleFileState.length>0){
            multipleFileState.map(res=>{
          
              optName.push(
                <div className="joclasss">
                {/* <p>{res.uploadedFileName.split('.')[0]}</p> */}
                <p>{res.uploadedFileName.substr(0, res.uploadedFileName.lastIndexOf("\."))}</p>
                </div>
              );
                  optionTable.push(
                    <div className="joclasss">
                    <a target="blank" href={res.uploadedFilePath}>Click here to view file</a>
                    </div>
      
                  );
                  optionTables.push(
                      <div className="joclass">
                        <Tooltip id="tooltip-icon" title="Delete">
                        <Icon onClick={()=>this.uploadFileDeleteHandler(res.id)}>delete</Icon>
                      </Tooltip>
                      </div>
                      )
              
            })
          }
          if (loaded) {
            loader1 = (
              <div className="loader">
                <img src={loader} alt="" />
              </div>
            );
          }
          // if( this.props.data.questonUploadFile && QuestionInfo.eligibilityQuestionId === this.props.data.questonUploadFile["eligibilityQuestionId"]){
          //   optionTable.push(
          //     <a target="blank" href={this.props.data.questonUploadFile["uploadedFilePath"]}>Click here to view file</a>

          //   )
        // }
        // if( this.props.data.questonUploadFile && QuestionInfo.eligibilityQuestionId === this.props.data.questonUploadFile["eligibilityQuestionId"]){
        //   optionTables.push(
      
        //  <button
        //         className="normal-case show-right-button"
        //         variant="raised"
        //         component="a"
        //         onClick={()=>this.uploadFileDeleteHandler(this.props.data.questonUploadFile["id"])}
        //       >
        //         Delete File
        //       </button>
      //   <Tooltip id="tooltip-icon" title="Delete">
      //   <Icon onClick={()=>this.uploadFileDeleteHandler(this.props.data.questonUploadFile["id"])}>delete</Icon>
      // </Tooltip>
      //     )}
        const dataa = {
          settlementId:QuestionInfo.settlementId,
          fileType:"",
          fileName:"",
          userId:this.state.settlementUserId,
          eligibilityQuestionId:QuestionInfo.eligibilityQuestionId,
          file :""
        };              
       
        const optionsList = [];
          if(QuestionInfo.allowFileUpload === 1){
            uploadOneFile.push(
              <div>
                  <input
                              id="contained-button-file"
                              type="file"
                              name="recentAnswerTwo"
                              style={{ width: "94px" }}
                              onChange={(e) => this.handleChangeFile(e,dataa)}
              // <input
              //   type="file"
                
                // value={this.state.recentAnswerState}
                // onChange={this.inputSelctorOptions}
                
              />
            </div>
            )
          }
        if (QuestionInfo.showOptionalNotes === 1) {
          optionsOne.push(
            <div >
              <textarea
                 style={{height:"80px" ,width : "98%",marginBottom:"25px",border: "2px solid #03a4f1"}}
                type="text"
                name="recentAnswerOne"
                value = {this.state.optionalNotesTextState}
                // value={optText !== null &&  this.state.optionalNotesTextState === ""  ? optText : this.state.optionalNotesTextState}
                onChange={this.inputSelctorOptionsNotes}
              />
              {/* <ReactQuill/> */}
            </div>
          );
        }
        AnswerOptions.map((item, index) => {
          if (item.eligibilityQuestionResponseDto !== null) {
            if (this.state.resentData === 1) {
              if (
                item.eligibilityQuestionResponseDto.eligibilityAnswerId !==
                undefined
              ) {
                this.state.recentAnswer.push(
                  item.eligibilityQuestionResponseDto.eligibilityAnswerId
                );
                this.state.addState.push(item.eligibilityQuestionResponseDto.eligibilityAnswerId);
              }
            }
          }
          if (item.isDisabled !== 1) {
            options.push(
              <span key={index}>
                <a
                  className={
                    this.state.recentAnswer.indexOf(item.answerId) > -1
                      ? "button active"
                      : "button"
                  }
                  onClick={() =>
                    this.MultiselectOptions(item.answerId, item.answerText)
                  }
                >
                  {item.answerText}
                </a>
              </span>
            );
          }
          // if (item.showOptionalNotes === 1) {
          //   optionsOne.push(
          //     <div key={index}>
          //       <input
          //         type="text"
          //         name="recentAnswerOne"
          //         value={this.state.optionalNotesTextState}
          //         onChange={this.inputSelctorOptionsNotes}
          //       />
          //       {/* <ReactQuill/> */}
          //     </div>
          //   );
          // }
          return true;
        });
        currentQuestionBody.push(
          <span key="q1">
            <QuestionComponent
              questionText={parse(questionText)}
              QuestionOptions={options}
              questionNotesText = {optionalNotesText}
              questionInput = {optionsOne}
              templatePath={nextQuestionDataApi1.templatePath}
              questionLabel = {uploadLabel}
              questionName ={optName}
              questionFile = {uploadOneFile}
              questionTable = {optionTable}
              questionTables = {optionTables}
              attachTemplateText={nextQuestionDataApi1.attachTemplateText}
            />
          </span>
        );
      }

      if (nextQuestionDataApi1.questionTypeId === 14) {
        const QuestionInfo = nextQuestionDataApi1;
        const questionText = QuestionInfo.questionText;
        const optText = QuestionInfo.optionalNotesData;
        const optionalNotesText = QuestionInfo.showOptionalNotesText !== "" ? parse(QuestionInfo.showOptionalNotesText) : "";
        const optionsOne = [];
        const uploadOneFile = []; 
        const uploadLabel = QuestionInfo.allowFileUpload === 1 && QuestionInfo.allowFileUploadText !== "" ? QuestionInfo.allowFileUploadText : "";
        const optionTable =[];
        const optionTables = [];
         
        //   if( this.props.data.questonUploadFile && QuestionInfo.eligibilityQuestionId === this.props.data.questonUploadFile["eligibilityQuestionId"]){
        //     optionTable.push(
        //       <a target="blank" href={this.props.data.questonUploadFile["uploadedFilePath"]}>Click here to view file</a>

        //     )
        // }
        // if( this.props.data.questonUploadFile && QuestionInfo.eligibilityQuestionId === this.props.data.questonUploadFile["eligibilityQuestionId"]){
        //   optionTables.push(
      
        //     <Tooltip id="tooltip-icon" title="Delete">
        //     <Icon onClick={()=>this.uploadFileDeleteHandler(this.props.data.questonUploadFile["id"])}>delete</Icon>
        //   </Tooltip>
        //   )}
        // if(nextQuestionDataApi1.disclaimerAgree.length>0){
        //   this.state.dupeInterCheck.push(nextQuestionDataApi1.disclaimerAgree)
        // }
        console.log("questonUploadFile14",interCheck,this.state.interCheck)
        const optName = [];
        if(multipleFileState.length>0){
          multipleFileState.map(res=>{
        
            optName.push(
              <div className="joclasss">
              {/* <p>{res.uploadedFileName.split('.')[0]}</p> */}
              <p>{res.uploadedFileName.substr(0, res.uploadedFileName.lastIndexOf("\."))}</p>
              </div>
            );
                optionTable.push(
                  <div className="joclasss">
                  <a target="blank" href={res.uploadedFilePath}>Click here to view file</a>
                  </div>
    
                );
                optionTables.push(
                    <div className="joclass">
                      <Tooltip id="tooltip-icon" title="Delete">
                      <Icon onClick={()=>this.uploadFileDeleteHandler(res.id)}>delete</Icon>
                    </Tooltip>
                    </div>
                    )
            
          })
        }
        const dataa = {
          settlementId:QuestionInfo.settlementId,
          fileType:"",
          fileName:"",
          userId:this.state.settlementUserId,
          eligibilityQuestionId:QuestionInfo.eligibilityQuestionId,
          file :""
        };              
       
        const optionsList = [];
          if(QuestionInfo.allowFileUpload === 1){
            uploadOneFile.push(
              <div>
                  <input
                              id="contained-button-file"
                              type="file"
                              name="recentAnswerTwo"
                              style={{ width: "94px" }}
                              onChange={(e) => this.handleChangeFile(e,dataa)}
              // <input
              //   type="file"
                
                // value={this.state.recentAnswerState}
                // onChange={this.inputSelctorOptions}
                
              />
            </div>
            )
          }
        if (QuestionInfo.showOptionalNotes === 1) {
          optionsOne.push(
            <div >
              <textarea
                type="text"
                name="recentAnswerOne"
                style={{height:"80px" ,width : "98%",marginBottom:"25px",border: "2px solid #03a4f1"}}
                value = {this.state.optionalNotesTextState}
                // value={optText !== null &&  this.state.optionalNotesTextState === ""  ? optText : this.state.optionalNotesTextState}
                onChange={this.inputSelctorOptionsNotes}
              />
              {/* <ReactQuill/> */}
            </div>
          );
        }
        let po = (
          <div>
            <input
              type="checkbox"
              id="vehicle1"
              name="vehicle1"
              onChange={this.handleCheck}
              checked={ this.state.interCheck}
              // checked = {true}
            />
            <label for="vehicle1">
              {" "}
              I <strong>acknowledge</strong>
            </label>
          </div>
        );
        // const options = [];
        // AnswerOptions.map((item, index) => {
        //   if (item.eligibilityQuestionResponseDto !== null) {
        //     if (this.state.resentData === 1) {
        //       if (
        //         item.eligibilityQuestionResponseDto.eligibilityAnswerId !==
        //         undefined
        //       ) {
        //         this.state.recentAnswer.push(
        //           item.eligibilityQuestionResponseDto.eligibilityAnswerId
        //         );
        //       }
        //     }
        //   }
        //   if (item.isDisabled !== 1) {
        //     options.push(
        //       <span key={index}>
        //         <a
        //           className={
        //             this.state.recentAnswer.indexOf(item.answerId) > -1
        //               ? "button active"
        //               : "button"
        //           }
        //           onClick={() =>
        //             this.MultiselectOptions(item.answerId, item.answerText)
        //           }
        //         >
        //           {item.answerText}
        //         </a>
        //       </span>
        //     );
        //   }
        //   return true;
        // });
        currentQuestionBody.push(
          <span key="q1">
            <QuestionComponent
              questionText={parse(questionText)}
              // QuestionOptions={options}
              questionNotesText = {optionalNotesText}
              questionInput = {optionsOne}
              po={po}
              templatePath={nextQuestionDataApi1.templatePath}
              questionLabel = {uploadLabel}
              questionName ={optName}
              questionFile = {uploadOneFile}
              questionTable = {optionTable}
              questionTables = {optionTables}
              attachTemplateText={nextQuestionDataApi1.attachTemplateText}
            />
          </span>
        );
      }

      if (nextQuestionDataApi1.questionTypeId === 6) {
        const QuestionInfo = nextQuestionDataApi1;
        const AnswerOptions = QuestionInfo.eligibilityAnswerDto;
        const questionText = QuestionInfo.questionText;
        const optText = QuestionInfo.optionalNotesData;
        const optionalNotesText = QuestionInfo.showOptionalNotesText !== "" ? parse(QuestionInfo.showOptionalNotesText) :"";
        const optionsOne = [];
        const options = [];
        const uploadOneFile = []; 
        const uploadLabel = QuestionInfo.allowFileUpload === 1 && QuestionInfo.allowFileUploadText !== "" ? QuestionInfo.allowFileUploadText : "";
        const optionTable =[];
        const optionTables = [];
          console.log("questonUploadFilez",this.props.data.questonUploadFile,typeof this.props.data.questonUploadFile)
          const optName = [];
          if(multipleFileState.length>0){
            multipleFileState.map(res=>{
          
              optName.push(
                <div className="joclasss">
                {/* <p>{res.uploadedFileName.split('.')[0]}</p> */}
                <p>{res.uploadedFileName.substr(0, res.uploadedFileName.lastIndexOf("\."))}</p>
                </div>
              );
                  optionTable.push(
                    <div className="joclasss">
                    <a target="blank" href={res.uploadedFilePath}>Click here to view file</a>
                    </div>
      
                  );
                  optionTables.push(
                      <div className="joclass">
                        <Tooltip id="tooltip-icon" title="Delete">
                        <Icon onClick={()=>this.uploadFileDeleteHandler(res.id)}>delete</Icon>
                      </Tooltip>
                      </div>
                      )
              
            })
          }
          if (loaded) {
            loader1 = (
              <div className="loader">
                <img src={loader} alt="" />
              </div>
            );
          }
          //   if( this.props.data.questonUploadFile && QuestionInfo.eligibilityQuestionId === this.props.data.questonUploadFile["eligibilityQuestionId"]){
        //     optionTable.push(
        //       <a target="blank" href={this.props.data.questonUploadFile["uploadedFilePath"]}>Click here to view file</a>

        //     )
        // }
        // if( this.props.data.questonUploadFile && QuestionInfo.eligibilityQuestionId === this.props.data.questonUploadFile["eligibilityQuestionId"]){
        //   optionTables.push(
      
        //     <Tooltip id="tooltip-icon" title="Delete">
        //     <Icon onClick={()=>this.uploadFileDeleteHandler(this.props.data.questonUploadFile["id"])}>delete</Icon>
        //   </Tooltip>
        //   )}
        const dataa = {
          settlementId:QuestionInfo.settlementId,
          fileType:"",
          fileName:"",
          userId:this.state.settlementUserId,
          eligibilityQuestionId:QuestionInfo.eligibilityQuestionId,
          file :""
        };              
       
        const optionsList = [];
          if(QuestionInfo.allowFileUpload === 1){
            uploadOneFile.push(
              <div>
                  <input
                              id="contained-button-file"
                              type="file"
                              name="recentAnswerTwo"
                              style={{ width: "94px" }}
                              onChange={(e) => this.handleChangeFile(e,dataa)}
              // <input
              //   type="file"
                
                // value={this.state.recentAnswerState}
                // onChange={this.inputSelctorOptions}
                
              />
            </div>
            )
          }
        if (QuestionInfo.showOptionalNotes === 1) {
          optionsOne.push(
            <div >
              <textarea
                type="text"
                name="recentAnswerOne"
                style={{height:"80px" ,width : "98%",marginBottom:"25px",border: "2px solid #03a4f1"}}
                value = {this.state.optionalNotesTextState}
                // value={optText !== null &&  this.state.optionalNotesTextState === ""  ? optText : this.state.optionalNotesTextState}
                onChange={this.inputSelctorOptionsNotes}
              />
              {/* <ReactQuill/> */}
            </div>
          );
        }
        AnswerOptions.map((item, index) => {
          if (item.eligibilityQuestionResponseDto !== null) {
            if (this.state.resentData === 1) {
              if (
                item.eligibilityQuestionResponseDto.value !== undefined &&
                item.eligibilityQuestionResponseDto.value !== ""
              ) {
                if (this.state.recentAnswer.length < 1) {
                  this.state.recentAnswer.push(
                    item.eligibilityQuestionResponseDto.value
                  );
                  // this.state.quanState.push(
                  //   item.eligibilityQuestionResponseDto.value
                  // );
                }
              }
            }
          }
          if (item.isDisabled !== 1) {
            options.push(
              <span key={index}>
                <input
                  type="text"
                  name="recentAnswer"
                  value={this.state.recentAnswer}
                  onChange={this.inputSelctorOptionsNumber}
                />
              </span>
            );
          }
          // if (item.showOptionalNotes === 1) {
          //   optionsOne.push(
          //     <div key={index}>
          //       <input
          //         type="text"
          //         name="recentAnswerOne"
          //         value={this.state.optionalNotesTextState}
          //         onChange={this.inputSelctorOptionsNotes}
          //       />
          //       {/* <ReactQuill/> */}
          //     </div>
          //   );
          // }
          return true;
        });
        currentQuestionBody.push(
          <span key="q1">
            <QuestionComponent
              questionText={parse(questionText)}
              QuestionOptions={options}
              questionNotesText = {optionalNotesText}
              questionInput = {optionsOne}
              templatePath={nextQuestionDataApi1.templatePath}
              questionLabel = {uploadLabel}
              questionName ={optName}
              questionFile = {uploadOneFile}
              questionTable = {optionTable}
              questionTables = {optionTables}
              attachTemplateText={nextQuestionDataApi1.attachTemplateText}
            />
          </span>
        );
      }
      if (nextQuestionDataApi1.questionTypeId === 8) {
        const QuestionInfo = nextQuestionDataApi1;
        const AnswerOptions = QuestionInfo.vehicleDetailsDtoList;
        const questionText = QuestionInfo.questionText;
        const optText = QuestionInfo.optionalNotesData;
        const options = [];
        const optionalNotesText = QuestionInfo.showOptionalNotesText !== ""? parse(QuestionInfo.showOptionalNotesText) : "";
        const optionsOne = [];
        const uploadOneFile = []; 
        const uploadLabel = QuestionInfo.allowFileUpload === 1 && QuestionInfo.allowFileUploadText !== "" ? QuestionInfo.allowFileUploadText : "";
        const optionTable =[];
        const optionTables = [];
          console.log("questonUploadFilez",this.props.data.questonUploadFile,typeof this.props.data.questonUploadFile)
          const optName = [];
          if(multipleFileState.length>0){
            multipleFileState.map(res=>{
          
              optName.push(
                <div className="joclasss">
                {/* <p>{res.uploadedFileName.split('.')[0]}</p> */}
                <p>{res.uploadedFileName.substr(0, res.uploadedFileName.lastIndexOf("\."))}</p>
                </div>
              );
                  optionTable.push(
                    <div className="joclasss">
                    <a target="blank" href={res.uploadedFilePath}>Click here to view file</a>
                    </div>
      
                  );
                  optionTables.push(
                      <div className="joclass">
                        <Tooltip id="tooltip-icon" title="Delete">
                        <Icon onClick={()=>this.uploadFileDeleteHandler(res.id)}>delete</Icon>
                      </Tooltip>
                      </div>
                      )
              
            })
          }
          if (loaded) {
            loader1 = (
              <div className="loader">
                <img src={loader} alt="" />
              </div>
            );
          }
          //   if( this.props.data.questonUploadFile && QuestionInfo.eligibilityQuestionId === this.props.data.questonUploadFile["eligibilityQuestionId"]){
        //     optionTable.push(
        //       <a target="blank" href={this.props.data.questonUploadFile["uploadedFilePath"]}>Click here to view file</a>

        //     )
        // }
        // if( this.props.data.questonUploadFile && QuestionInfo.eligibilityQuestionId === this.props.data.questonUploadFile["eligibilityQuestionId"]){
        //   optionTables.push(
      
        //     <Tooltip id="tooltip-icon" title="Delete">
        //     <Icon onClick={()=>this.uploadFileDeleteHandler(this.props.data.questonUploadFile["id"])}>delete</Icon>
        //   </Tooltip>
        //   )}
        const dataa = {
          settlementId:QuestionInfo.settlementId,
          fileType:"",
          fileName:"",
          userId:this.state.settlementUserId,
          eligibilityQuestionId:QuestionInfo.eligibilityQuestionId,
          file :""
        };              
       
        const optionsList = [];
          if(QuestionInfo.allowFileUpload === 1){
            uploadOneFile.push(
              <div>
                  <input
                              id="contained-button-file"
                              type="file"
                              name="recentAnswerTwo"
                              style={{ width: "94px" }}
                              onChange={(e) => this.handleChangeFile(e,dataa)}
              // <input
              //   type="file"
                
                // value={this.state.recentAnswerState}
                // onChange={this.inputSelctorOptions}
                
              />
            </div>
            )
          }
        if (QuestionInfo.showOptionalNotes === 1) {
          optionsOne.push(
            <div >
              <textarea
                type="text"
                name="recentAnswerOne"
                style={{height:"80px" ,width : "98%",marginBottom:"25px",border: "2px solid #03a4f1"}}
                value = {this.state.optionalNotesTextState}
                // value={optText !== null &&  this.state.optionalNotesTextState === ""  ? optText : this.state.optionalNotesTextState}
                onChange={this.inputSelctorOptionsNotes}
              />
              {/* <ReactQuill/> */}
            </div>
          );
        }
        vehicleOptions.map((item, index) => {
          if (AnswerOptions !== null && AnswerOptions.length > 0) {
            AnswerOptions.map((item1) => {
              if (item1.vehicleDetailsId !== null) {
                if (this.state.resentData === 1) {
                  if (
                    this.state.recentAnswer.indexOf(item1.vehicleDetailsId) ===
                    -1
                  ) {
                    this.state.recentAnswer.push(item1.vehicleDetailsId);
                    // this.state.vehiclerecentAnswer.push(item1.vehicleDetailsId);
                  }
                }
              }
              if (item.showOptionalNotes === 1) {
                optionsOne.push(
                  <span>
                    <textarea
                      type="text"
                      name="recentAnswerOne"
                      style={{height:"80px" ,width : "98%"}}
                      value={this.state.optionalNotesTextState}
                      onChange={this.inputSelctorOptionsNotes}
                    />
                    {/* <ReactQuill/> */}
                  </span>
                );
              }
              return true;
            });
          }
          options.push(
            <span key={index}>
              <a
                className={
                  this.state.recentAnswer.indexOf(item.vehicleDataId) > -1
                    ? "button active"
                    : "button"
                }
                onClick={() =>
                  this.vehicleOptionsMultiSelection(item.vehicleDataId)
                }
              >{`${item.vehicleYear} ${item.vehicleMake} ${item.vehicleModel}`}</a>
            </span>
          );

          //  }
          return true;
        });
        currentQuestionBody.push(
          <span key="q1">
            <QuestionComponent
              questionText={parse(questionText)}
              QuestionOptions={options}
              questionNotesText = {optionalNotesText}
              questionInput = {optionsOne}
              templatePath={nextQuestionDataApi1.templatePath}
              questionLabel = {uploadLabel}
              questionName ={optName}
              questionFile = {uploadOneFile}
              questionTable = {optionTable}
              questionTables = {optionTables}
              attachTemplateText={nextQuestionDataApi1.attachTemplateText}
            />{" "}
            <AddVehicleInEligibility
              settlementId={params.eid}
              onSubmit={() => {
                this.setState(() => ({
                  loaded: true,
                }));
                // setTimeout(() => {
                //   const dataa = {
                //     userId: this.state.settlementUserId, pageNumber: 0, pageSize: 40, searchKeyword: '',
                //   };
                //   this.props.getAllVehicleDataByUserIdAPI(dataa);
                // }, 1000);
              }}
            />
          </span>
        );
      }

      // Code for type 11
      if (nextQuestionDataApi1.questionTypeId === 11) {
        const QuestionInfo = nextQuestionDataApi1;
        const AnswerOptions = QuestionInfo.vehicleDetailsDtoList;
        const questionText = QuestionInfo.questionText;
        const optionalNotesText = QuestionInfo.showOptionalNotesText !== "" ? parse(QuestionInfo.showOptionalNotesText) : "";
        const optionsOne = [];
        const optText = QuestionInfo.optionalNotesData;
        const options = [];
        const uploadOneFile = []; 
        const uploadLabel = QuestionInfo.allowFileUpload === 1 && QuestionInfo.allowFileUploadText !== "" ? QuestionInfo.allowFileUploadText : "";
        const optionTable =[];
        const optionTables = [];
          console.log("questonUploadFilez",this.props.data.questonUploadFile,typeof this.props.data.questonUploadFile)
        //   if( this.props.data.questonUploadFile && QuestionInfo.eligibilityQuestionId === this.props.data.questonUploadFile["eligibilityQuestionId"]){
        //     optionTable.push(
        //       <a target="blank" href={this.props.data.questonUploadFile["uploadedFilePath"]}>Click here to view file</a>

        //     )
        // }
        // if( this.props.data.questonUploadFile && QuestionInfo.eligibilityQuestionId === this.props.data.questonUploadFile["eligibilityQuestionId"]){
        //   optionTables.push(
      
        //     <Tooltip id="tooltip-icon" title="Delete">
        //     <Icon onClick={()=>this.uploadFileDeleteHandler(this.props.data.questonUploadFile["id"])}>delete</Icon>
        //   </Tooltip>
        //   )}
        const optName = [];
        if(multipleFileState.length>0){
          multipleFileState.map(res=>{
        
            optName.push(
              <div className="joclasss">
              {/* <p>{res.uploadedFileName.split('.')[0]}</p> */}
              <p>{res.uploadedFileName.substr(0, res.uploadedFileName.lastIndexOf("\."))}</p>
              </div>
            );
                optionTable.push(
                  <div className="joclasss">
                  <a target="blank" href={res.uploadedFilePath}>Click here to view file</a>
                  </div>
    
                );
                optionTables.push(
                    <div className="joclass">
                      <Tooltip id="tooltip-icon" title="Delete">
                      <Icon onClick={()=>this.uploadFileDeleteHandler(res.id)}>delete</Icon>
                    </Tooltip>
                    </div>
                    )
            
          })
        }
        if (loaded) {
          loader1 = (
            <div className="loader">
              <img src={loader} alt="" />
            </div>
          );
        }
        const dataa = {
          settlementId:QuestionInfo.settlementId,
          fileType:"",
          fileName:"",
          userId:this.state.settlementUserId,
          eligibilityQuestionId:QuestionInfo.eligibilityQuestionId,
          file :""
        };              
       
        const optionsList = [];
          if(QuestionInfo.allowFileUpload === 1){
            uploadOneFile.push(
              <div>
                  <input
                              id="contained-button-file"
                              type="file"
                              name="recentAnswerTwo"
                              style={{ width: "94px" }}
                              onChange={(e) => this.handleChangeFile(e,dataa)}
              // <input
              //   type="file"
                
                // value={this.state.recentAnswerState}
                // onChange={this.inputSelctorOptions}
                
              />
            </div>
            )
          }
        console.log("ssssssssssssssvehicleDataNewObject", vehicleDataNewObject);
        if (QuestionInfo.showOptionalNotes === 1) {
          optionsOne.push(
            <div >
              <textarea
                type="text"
                name="recentAnswerOne"
                style={{height:"80px" ,width : "98%",marginBottom:"25px",border: "2px solid #03a4f1"}}
                value = {this.state.optionalNotesTextState}
                // value={optText !== null &&  this.state.optionalNotesTextState === ""  ? optText : this.state.optionalNotesTextState}
                onChange={this.inputSelctorOptionsNotes}
              />
              {/* <ReactQuill/> */}
            </div>
          );
        }
        vehicleDataNewObject.map((item, index) => {
          if (AnswerOptions !== null && AnswerOptions.length > 0) {
            AnswerOptions.map((item1) => {
              if (item1.vehicleDetailsId !== null) {
                if (this.state.resentData === 1) {
                  if (
                    this.state.recentAnswer.indexOf(item1.vehicleDetailsId) ===
                    -1
                  ) {
                    this.state.recentAnswer.push(item1.vehicleDetailsId);
                  }
                }
              }
              return true;
            });
          }

          // options.push(<span key={index}><a className={this.state.recentAnswer.indexOf(item.vehicleDataId) > -1 ? 'button active' : 'button'} onClick={() => this.vehicleOptionsMultiSelection(item.vehicleDataId)}>{`${item.vehicleYear} ${item.vehicleMake} ${item.vehicleModel}`}</a></span>);
          options.push(
            <VinComponet
              key={index}
              vehicleDetail={item}
              indexValue={index}
              funtionchangeDate={this.changeDate}
              funtionchangeSoldDate={this.changeSoldDate}
              functionChangeVin={this.changeVinNumber}
            />
          );
          //  }
          return true;
        });
        currentQuestionBody.push(
          <span key="q1">
            <QuestionComponent
              questionText={parse(questionText)}
              QuestionOptions={options}
              questionNotesText = {optionalNotesText}
              questionInput = {optionsOne}
              templatePath={nextQuestionDataApi1.templatePath}
              questionLabel = {uploadLabel}
              questionName ={optName}
              questionFile = {uploadOneFile}
              questionTable = {optionTable}
              questionTables = {optionTables}
              attachTemplateText={nextQuestionDataApi1.attachTemplateText}
            />{" "}
            {/* <AddVehicleInEligibility
              settlementId={params.eid}
              onSubmit={() => {
                this.setState(() => ({
                  loaded: true,
                }));
              // setTimeout(() => {
              //   const dataa = {
              //     userId: this.state.settlementUserId, pageNumber: 0, pageSize: 40, searchKeyword: '',
              //   };
              //   this.props.getAllVehicleDataByUserIdAPI(dataa);
              // }, 1000);
              }
      }
            /> */}
          </span>
        );
      }

      // code for vehicle and type 10

      if (nextQuestionDataApi1.questionTypeId === 12) {
        questionTypeCheck = true;
        const QuestionInfo = nextQuestionDataApi1;
        const optText = QuestionInfo.optionalNotesData;
        // const AnswerOptions = QuestionInfo.eligibilityAnswerDto;
        const questionText = QuestionInfo.questionText;
        const vehicleDataAPi = this.state.reimbursementDetailsDtoListDta;
        const optionalNotesText = QuestionInfo.showOptionalNotesText !== "" ? parse(QuestionInfo.showOptionalNotesText) : "";
        const optionsOne = [];
        const options = [];
        const dropdown = [];
        const uploadOneFile = []; 
        const uploadLabel = QuestionInfo.allowFileUpload === 1 && QuestionInfo.allowFileUploadText !== "" ? QuestionInfo.allowFileUploadText : "";
        const optionTable =[];
        const optionTables = [];
          console.log("questonUploadFilez",this.props.data.questonUploadFile,typeof this.props.data.questonUploadFile)
        //   if( this.props.data.questonUploadFile && QuestionInfo.eligibilityQuestionId === this.props.data.questonUploadFile["eligibilityQuestionId"]){
        //     optionTable.push(
        //       <a target="blank" href={this.props.data.questonUploadFile["uploadedFilePath"]}>Click here to view file</a>

        //     )
        // }
        // if( this.props.data.questonUploadFile && QuestionInfo.eligibilityQuestionId === this.props.data.questonUploadFile["eligibilityQuestionId"]){
        //   optionTables.push(
      
        //     <Tooltip id="tooltip-icon" title="Delete">
        //     <Icon onClick={()=>this.uploadFileDeleteHandler(this.props.data.questonUploadFile["id"])}>delete</Icon>
        //   </Tooltip>
        //   )}
        const optName = [];
        if(multipleFileState.length>0){
          multipleFileState.map(res=>{
        
            optName.push(
              <div className="joclasss">
              {/* <p>{res.uploadedFileName.split('.')[0]}</p> */}
              <p>{res.uploadedFileName.substr(0, res.uploadedFileName.lastIndexOf("\."))}</p>
              </div>
            );
                optionTable.push(
                  <div className="joclasss">
                  <a target="blank" href={res.uploadedFilePath}>Click here to view file</a>
                  </div>
    
                );
                optionTables.push(
                    <div className="joclass">
                      <Tooltip id="tooltip-icon" title="Delete">
                      <Icon onClick={()=>this.uploadFileDeleteHandler(res.id)}>delete</Icon>
                    </Tooltip>
                    </div>
                    )
            
          })
        }
        if (loaded) {
          loader1 = (
            <div className="loader">
              <img src={loader} alt="" />
            </div>
          );
        }
        const dataa = {
          settlementId:QuestionInfo.settlementId,
          fileType:"",
          fileName:"",
          userId:this.state.settlementUserId,
          eligibilityQuestionId:QuestionInfo.eligibilityQuestionId,
          file :""
        };              
       
        const optionsList = [];
          if(QuestionInfo.allowFileUpload === 1){
            uploadOneFile.push(
              <div>
                  <input
                              id="contained-button-file"
                              type="file"
                              name="recentAnswerTwo"
                              style={{ width: "94px" }}
                              onChange={(e) => this.handleChangeFile(e,dataa)}
              // <input
              //   type="file"
                
                // value={this.state.recentAnswerState}
                // onChange={this.inputSelctorOptions}
                
              />
            </div>
            )
          }
        if (QuestionInfo.showOptionalNotes === 1) {
          optionsOne.push(
            <div >
              <textarea
                type="text"
                name="recentAnswerOne"
                style={{height:"80px" ,width : "98%",marginBottom:"25px",border: "2px solid #03a4f1"}}
                value = {this.state.optionalNotesTextState}
                // value={optText !== null &&  this.state.optionalNotesTextState === ""  ? optText : this.state.optionalNotesTextState}
                onChange={this.inputSelctorOptionsNotes}
              />
              {/* <ReactQuill/> */}
            </div>
          );
        }
        options.push({
          value: "",
          label: "select Option",
          name: "select Option",
        });
        if (vehicleDataAPi !== null) {
          vehicleDataAPi.map((item) => {
            if (
              (QuestionInfo.soldFlag === 0 && item.vehicleType !== "Sold") ||
              QuestionInfo.soldFlag === 1
            ) {
              dropdown.push(
                <div key={item.vehicleDetailsId} className="manufacture-brand">
                  <h4 className="VehicleNamePartHeading">
                    {/* {console.log('item',item)} */}{" "}
                    {`${item.vehicleYear} ${item.vehicleMake} ${item.vehicleModel}`}
                  </h4>
                  {item.reimbursementDetailsDtoList.map((itemR) => (
                    <div
                      className="currency-outer"
                      key={itemR.eligibilityAnswerId + item.vehicleDetailsId}
                    >
                      <label className="multiple-line-input">
                        {itemR.answerText}
                      </label>
                      <span>$</span>
                      <input
                        type="text"
                        value={itemR.value}
                        name={itemR.eligibilityAnswerId}
                        onKeyDown={this.onKeyPressed}
                        className="numberonly"
                        onChange={this.multipleInputOptionsR(
                          itemR.eligibilityAnswerId,
                          item.vehicleDetailsId
                        )}
                        // placeholder={itemR.answerText}
                        placeholder={
                          itemR.placeholder !== ""
                            ? itemR.placeholder
                            : "Add number of purchases"
                        }
                        key={itemR.answerId}
                      />
                    </div>
                  ))}

                  {/* <div>{item.reimbursementDetailsDtoList !== undefined ? item.reimbursementDetailsDtoList.length > 0 ? :}</div> */}
                </div>
              );
            }
            return true;
          });
        }
        currentQuestionBody.push(
          <span key="q1">
            <QuestionComponent
              questionText={parse(questionText)}
              QuestionOptions={dropdown}
              questionNotesText = {optionalNotesText}
              questionInput = {optionsOne}
              templatePath={nextQuestionDataApi1.templatePath}
              questionLabel = {uploadLabel}
              questionName ={optName}
              questionFile = {uploadOneFile}
              questionTable = {optionTable}
              questionTables = {optionTables}
              attachTemplateText={nextQuestionDataApi1.attachTemplateText}
            />
          </span>
        );
      }

      if (nextQuestionDataApi1.questionTypeId === 10) {
        questionTypeCheck = true;
        const QuestionInfo = nextQuestionDataApi1;
        console.log("10",QuestionInfo)
        // const AnswerOptions = QuestionInfo.eligibilityAnswerDto;
        const questionText = QuestionInfo.questionText;
        const vehicleDataAPi = this.state.vehicleDetailsDtoListData;
        const optText = QuestionInfo.optionalNotesData;
        const options = [];
        const dropdown = [];
        const optionalNotesText = QuestionInfo.showOptionalNotesText !== ""? parse(QuestionInfo.showOptionalNotesText) : "";
        const optionsOne = [];
        const uploadOneFile = []; 
        const uploadLabel = QuestionInfo.allowFileUpload === 1 && QuestionInfo.allowFileUploadText !== "" ? QuestionInfo.allowFileUploadText : "";
        const optionTable =[];
        const optionTables = [];
          console.log("questonUploadFilez",this.props.data.questonUploadFile,typeof this.props.data.questonUploadFile)
        //   if( this.props.data.questonUploadFile && QuestionInfo.eligibilityQuestionId === this.props.data.questonUploadFile["eligibilityQuestionId"]){
        //     optionTable.push(
        //       <a target="blank" href={this.props.data.questonUploadFile["uploadedFilePath"]}>Click here to view file</a>

        //     )
        // }
        // if( this.props.data.questonUploadFile && QuestionInfo.eligibilityQuestionId === this.props.data.questonUploadFile["eligibilityQuestionId"]){
        //   optionTables.push(
      
        //     <Tooltip id="tooltip-icon" title="Delete">
        //     <Icon onClick={()=>this.uploadFileDeleteHandler(this.props.data.questonUploadFile["id"])}>delete</Icon>
        //   </Tooltip>
        //   )}
        const optName = [];
        if(multipleFileState.length>0){
          multipleFileState.map(res=>{
        
            optName.push(
              <div className="joclasss">
              {/* <p>{res.uploadedFileName.split('.')[0]}</p> */}
              <p>{res.uploadedFileName.substr(0, res.uploadedFileName.lastIndexOf("\."))}</p>
              </div>
            );
                optionTable.push(
                  <div className="joclasss">
                  <a target="blank" href={res.uploadedFilePath}>Click here to view file</a>
                  </div>
    
                );
                optionTables.push(
                    <div className="joclass">
                      <Tooltip id="tooltip-icon" title="Delete">
                      <Icon onClick={()=>this.uploadFileDeleteHandler(res.id)}>delete</Icon>
                    </Tooltip>
                    </div>
                    )
            
          })
        }
        if (loaded) {
          loader1 = (
            <div className="loader">
              <img src={loader} alt="" />
            </div>
          );
        }
        const dataa = {
          settlementId:QuestionInfo.settlementId,
          fileType:"",
          fileName:"",
          userId:this.state.settlementUserId,
          eligibilityQuestionId:QuestionInfo.eligibilityQuestionId,
          file :""
        };              
       
        const optionsList = [];
          if(QuestionInfo.allowFileUpload === 1){
            uploadOneFile.push(
              <div>
                  <input
                              id="contained-button-file"
                              type="file"
                              name="recentAnswerTwo"
                              style={{ width: "94px" }}
                              onChange={(e) => this.handleChangeFile(e,dataa)}
              // <input
              //   type="file"
                
                // value={this.state.recentAnswerState}
                // onChange={this.inputSelctorOptions}
                
              />
            </div>
            )
          }
        options.push({
          value: "",
          label: "select Option",
          name: "select Option",
        });
        if (QuestionInfo.showOptionalNotes === 1) {
          optionsOne.push(
            <div >
              <textarea
                type="text"
                name="recentAnswerOne"
                style={{height:"80px" ,width : "98%",marginBottom:"25px",border: "2px solid #03a4f1"}}
                value = {this.state.optionalNotesTextState}
                // value={optText !== null &&  this.state.optionalNotesTextState === ""  ? optText : this.state.optionalNotesTextState}
                onChange={this.inputSelctorOptionsNotes}
              />
              {/* <ReactQuill/> */}
            </div>
          );
        }
        if (vehicleDataAPi !== null) {
          vehicleDataAPi.map((item, idVehicle) =>
            dropdown.push(
              <div key={item.vehicleDetailsId} className="manufacture-brand">
                <h4 className="VehicleNamePartHeading">
                  {" "}
                  {`${item.vehicleYear} ${item.vehicleMake} ${item.vehicleModel}`}
                </h4>
                {item.autoPartDefendentDtoList !== undefined ? (
                  item.autoPartDefendentDtoList.length > 0 ? (
                    item.autoPartDefendentDtoListValueChildData !==
                    undefined ? (
                      item.autoPartDefendentDtoListValueChildData.length > 0 ? (
                        <div className="add-manufacturer">
                          {item.autoPartDefendentDtoListValueChildData.map(
                            (iteamData, iteamId) => (
                              <div className="manufactureouter" key={iteamId}>
                                <div className="row">
                                  <div className="col s12 m1">
                                    <div className="VehicleNamePart">Part</div>
                                  </div>
                                  <div className="col s12 m5">
                                    <Select
                                      className="dropdownBox"
                                      name={`autoPartDefendentDtoList #${
                                        idVehicle + 1
                                      } name`}
                                      value={Number.parseInt(
                                        iteamData.autoPartid,
                                        10
                                      )}
                                      onChange={this.multipleDropdownFunction(
                                        item.vehicleDetailsId,
                                        "Child",
                                        iteamData.vehicleDetailsIndex,
                                        iteamData.autoPartid,
                                        iteamId + 1
                                      )}
                                    >
                                      <MenuItem disabled key={0} value={0}>
                                        Select auto part
                                      </MenuItem>

                                      {iteamData.autoPartDefendentDtoList.map(
                                        (s, idx) => (
                                          <MenuItem
                                            key={idx}
                                            value={s.autoPartid}
                                          >
                                            {s.autoPartName}
                                          </MenuItem>
                                        )
                                      )}
                                    </Select>
                                  </div>
                                  <div className="col s12 m5">
                                    <Select
                                      className=" dropdownBox"
                                      name={`autoPartDefendentDtoListData #${
                                        idVehicle + 1
                                      } name`}
                                      value={Number.parseInt(
                                        iteamData.autoPartDefendentId,
                                        10
                                      )}
                                      onChange={this.multipleDropdownFunctionPart(
                                        item.vehicleDetailsId,
                                        "Child",
                                        iteamData.vehicleDetailsIndex,
                                        iteamData.autoPartid
                                      )}
                                    >
                                      <MenuItem disabled key={0} value={0}>
                                        Select manufacturer part
                                      </MenuItem>

                                      {iteamData.autoPartDefendentDtoListData !==
                                      undefined
                                        ? iteamData.autoPartDefendentDtoListData.map(
                                            (s, idx) => (
                                              <MenuItem
                                                key={idx}
                                                value={s.autoPartDefendentId}
                                              >
                                                {s.autoPartDefendentName}
                                              </MenuItem>
                                            )
                                          )
                                        : ""}
                                    </Select>
                                  </div>
                                  <div className="col s1">
                                    <a
                                      href=""
                                      onClick={this.deleteMoreDetail(
                                        iteamData.vehicleDetailsId,
                                        iteamData.vehicleDetailsIndex,
                                        iteamData.autoPartid
                                      )}
                                    >
                                      <i
                                        className="material-icons dp48 delete-manufacture"
                                        style={{
                                          display:
                                            item.autoPartDefendentDtoList !==
                                            undefined
                                              ? item.autoPartDefendentDtoList
                                                  .length > 1
                                                ? "inline-block"
                                                : "inline-block"
                                              : "inline-block",
                                        }}
                                      >
                                        close
                                      </i>
                                    </a>
                                  </div>
                                </div>
                              </div>
                            )
                          )}
                        </div>
                      ) : (
                        ""
                      )
                    ) : (
                      ""
                    )
                  ) : (
                    <div className="no-manufacturing-message">
                      {" "}
                      No Manufacturing
                    </div>
                  )
                ) : (
                  <div className="no-manufacturing-message">
                    {" "}
                    No Manufacturing
                  </div>
                )}

                <button
                  className="waves-effect waves-light btn btn-blue"
                  style={{
                    display:
                      item.autoPartDefendentDtoList !== undefined
                        ? item.autoPartDefendentDtoList.length > 0
                          ? item.autoPartDefendentDtoListValueChildData !==
                            undefined
                            ? item.autoPartDefendentDtoListValueChildData
                                .length < item.autoPartDefendentDtoList.length
                              ? "inline-block"
                              : "none"
                            : "inline-block"
                          : "none"
                        : "none",
                  }}
                  onClick={this.addMoreDetail(item.vehicleDetailsId)}
                >
                  {" "}
                  Add
                </button>
              </div>
            )
          );
        }
        currentQuestionBody.push(
          <span key="q1">
            <QuestionManufactureComponent
              questionText={parse(questionText)}
              questionTypeCheck={questionTypeCheck}
              QuestionOptions={dropdown}
              questionNotesText = {optionalNotesText}
              questionInput = {optionsOne}
              questionLabel = {uploadLabel}
              questionName ={optName}
              questionFile = {uploadOneFile}
              questionTable = {optionTable}
              questionTables = {optionTables}
            />
          </span>
        );
      }
      // end for type 10
      if (this.state.renderState === 1) {
        PopErrorNotAllowedToMove = true;
      }
    } else if (nextQuestionDataApi1.questionLeft === "N") {
      success = true;
      PopErrorNotAllowedToMove = false;
      PopErrorNotAllowedToMoveE = false;
    }

    let emptyFlag = false;
    if (this.state.showLastQusetion === true && totalNumberOfQuestions === 0) {
      success = false;
      emptyFlag = true;
    }

    return (
      <span>
        {loader1}
        <ToastContainer />
        <SideMenu userName={UserName} />
        <div className="container">
          <header className="section">
            <div className="step-breadcrumb">
              <div className="col s12 center-align">
                {success !== true ? (
                  this.state.totalNumberOfQuestions !== 0 ? (
                    <a
                      className={
                        PopErrorNotAllowedToMove
                          ? "breadcrumb active"
                          : "breadcrumb "
                      }
                    >
                      Check Eligibility: Question{" "}
                      {totalNumberOfQuestions !== 0 &&
                      this.state.counterQuesr !== totalNumberOfQuestions + 1
                        ? questionNumber
                        : nextQuestionDataApi1.totalQuestion}{" "}
                      of {nextQuestionDataApi1.totalQuestion}
                    </a>
                  ) : (
                    ""
                  )
                ) : (
                  ""
                )}

                <a className={success ? "breadcrumb active" : "breadcrumb"}>
                  Complete
                </a>
              </div>
            </div>
          </header>
          {/* <Loader loaded={this.state.loaded} /> */}
          <div className="main-content">
            <div className="divider hdr-bdr" />
            <div className="section-content left-align eligibility-check">
              <div className="row">
                <div className="col s10 offset-s1">
                  <div className={PopErrorNotAllowedToMove ? "row" : "hide"}>
                    <div className="col s12 l2">
                      <div className="green-box">
                        <img
                          className="responsive-img"
                          src={categoryImage}
                          alt=""
                        />
                      </div>
                    </div>
                    {currentQuestionBody}
                  </div>
                  <div className={PopErrorNotAllowedToMove ? "row" : "hide"}>
                    <div className="col s12 ">
                      <div className="divider hdr-bdr " />
                      <span className={error !== "" ? "error" : "hide"}>
                        {error}{" "}
                      </span>
                    </div>
                    <div className="next-showbutton">
                      <div
                        className={
                          PopErrorNotAllowedToMove
                            ? "col s12 apply-settlement-ShowHide"
                            : "col s12 hide"
                        }
                      >
                        <span
                          className={
                            this.state.counterQuesr === 1 ? "hide" : "show"
                          }
                        >
                          <button
                            className="btn waves-effect waves-light primary-btn col s6 offset-s3"
                            type="submit"
                            name="action"
                            onClick={this.ProceedWithQuestionBack}
                          >
                            <i className="material-icons">arrow_backward</i>{" "}
                            Back
                          </button>
                        </span>
                        <span
                          className={
                            this.state.counterQuesr ===
                            nextQuestionDataApi1.totalQuestion + 1
                              ? "hide"
                              : "show"
                          }
                        >
                          {nextQuestionDataApi1.questionTypeId === 14 ? (
                            <button
                              className="btn waves-effect waves-light primary-btn col s6 offset-s3"
                              type="submit"
                              name="action"
                              onClick={this.ProceedWithQuestionNext}
                              disabled={this.state.interCheck === false}
                            >
                              {this.state.buttonText}
                              <i className="material-icons">arrow_forward</i>
                            </button>
                          ) : (
                            <button
                              className="btn waves-effect waves-light primary-btn col s6 offset-s3"
                              type="submit"
                              name="action"
                              onClick={this.ProceedWithQuestionNext}
                            >
                              {this.state.buttonText}
                              <i className="material-icons">arrow_forward</i>
                            </button>
                          )}
                        </span>
                        {/* <a className={counterQuesr ===0 ? "hide": "show"} onClick={this.backToQuestion}>Back</a> */}
                      </div>
                    </div>
                  </div>
                  <div className={PopErrorNotAllowedToMoveE ? "row" : "hide"}>
                    <div className="col s12 m2">
                      <div className="green-box">
                        <img
                          className="responsive-img"
                          src={categoryImage}
                          alt=""
                        />
                      </div>
                    </div>
                    <div className="col s12 m10 pl-none">
                      <div className="img-desc-outer">
                        <div className="img-desc-icon">
                          <img src={exclamation} alt="" />
                        </div>
                        <div className="img-desc-text">
                          <h5>
                            Sorry You are not eligible for the {settlementName}
                          </h5>
                        </div>
                      </div>

                      <p className="no-margin">
                        You do not meet the requirements to make a claim in the
                        settlement. If you belive you may have made an error in
                        your submission.{" "}
                        <a href="" onClick={this.ProceedWithQuestionFirst}>
                          {/* <Link to="/dashboard">  */}
                          click here to go back
                        </a>{" "}
                        and try again.
                      </p>
                    </div>
                  </div>
                  <div className={PopErrorNotAllowedToMoveE ? "row" : "hide"}>
                    <div className="col s12 ">
                      <div className="divider hdr-bdr " />
                    </div>
                  </div>

                  <div className={success ? "row" : "hide"}>
                    <div className="col s12 l2">
                      <div className="green-box">
                        <img
                          className="responsive-img"
                          src={categoryImage}
                          alt=""
                        />
                      </div>
                    </div>
                    <div className="col s12 l10">
                      <h5 className="enroll-formtext">
                        <img src={thumbs} alt="" />
                        You have successfully enrolled with Collectively. You
                        have completed our requirements for the {
                          settlementName
                        }{" "}
                        settlement.
                      </h5>
                      <p className="enroll-formparagraph">
                        {" "}
                        Now you can just sit back and we'll handle the rest for
                        you. If we happen to need any information from you in
                        regards to this settlement, we will contact you.
                      </p>
                      <p className="enroll-formparagraph">
                        If you have additional information to upload, click the
                        enrollments tab on the left sidebar to find the
                        settlement and upload your documents.
                      </p>
                      <p>
                        {" "}
                        <Link to="/dashboard"> Click here </Link> to go back to
                        dashboard{" "}
                      </p>
                    </div>
                  </div>
                  <div className={success ? "row" : "hide"}>
                    <div className="col s12 ">
                      <div className="divider hdr-bdr " />
                    </div>
                  </div>
                  <div className={emptyFlag && !success ? "row" : "hide"}>
                    <div className="col s12 l2">
                      <div className="green-box">
                        <img
                          className="responsive-img"
                          src={categoryImage}
                          alt=""
                        />
                      </div>
                    </div>
                    <h5 className="enroll-formtext-center">
                      <img src={thumbs} alt="" />
                      Please confirm to enroll for {settlementName} settlement
                    </h5>
                    <button
                      className="btn waves-effect waves-light primary-btn col s6 offset-s3 settlement-submit-apply"
                      type="submit"
                      name="action"
                      onClick={this.saveEmptyData}
                    >
                      confirm
                      <i className="material-icons">arrow_forward</i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </span>
    );
  }
}

ApplyContainerQuestion.contextTypes = {
  router: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({ data: state.data });

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getSettlementById,
      uploadEligibilityQuestionFileByUser,
      deleteEligibilityQuestionFileByUser,
      saveToNextQuestionList,
      clearSavedata,
      saveUsersUneligibleSettlements,
      moveToNextQuestionList,
      saveSettlementAnswers,
      saveEnrollmenttDoc,
      saveSettlementWithoutData,
      saveEnrollmentAuthorization,
      getPendingRequiredDocUser,
      getEligibilityQuestionById,
      clearData,
      getAllVehicleDataByUserIdAPI,
      getAllVehicleDataSettlementByUserIdAPI,
      saveMultipleVehicleDataByUserIdAPI,
      getPendingSettlementQuestions,
      getAutoPartDefendentPartsByPartId,
    },
    dispatch
  );

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ApplyContainerQuestion)
);
